import { CountryFullData } from './types';

export const countries: CountryFullData[] = [
  {
    name: {
      en: 'Afghanistan',
      ru: 'Афганистан',
      pl: 'Afganistan',
      uk: 'Афганістан',
      cs: 'Afghánistán',
      be: 'Афганістан',
      pt: 'Afeganistão',
      es: 'Afganistán',
      ro: 'Afganistan',
      bg: 'Афганистан',
      de: 'Afghanistan',
      fr: "L'Afghanistan",
      nl: 'Afghanistan',
      it: 'Afghanistan',
      cn: '阿富汗',
      zh: '阿富汗',
      et: 'Afganistan',
      ja: 'アフガニスタン',
      he: 'אפגניסטן',
      el: 'Αφγανιστάν',
      kk: 'Ауғанстан',
      ka: 'ავღანეთი',
      th: 'อัฟกานิสถาน',
    },
    phoneLength: 9,
    dialCode: '+93',
    code: 'AF',
    flag: '🇦🇫',
  },
  {
    name: {
      en: 'Albania',
      ru: 'Албания',
      pl: 'Albania',
      uk: 'Албанія',
      cs: 'Albánie',
      be: 'Албанія',
      pt: 'Albânia',
      es: 'Albania',
      ro: 'Albania',
      bg: 'Албания',
      de: 'Albanien',
      fr: 'Albanie',
      nl: 'Albanië',
      it: 'Albania',
      cn: '阿尔巴尼亚',
      zh: '阿爾巴尼亞',
      et: 'Albaania',
      ja: 'アルバニア',
      he: 'אלבניה',
      el: 'Αλβανία',
      kk: 'Албания',
      ka: 'ალბანეთი',
      th: 'แอลเบเนีย',
    },
    phoneLength: 8,
    dialCode: '+355',
    code: 'AL',
    flag: '🇦🇱',
  },
  {
    name: {
      en: 'Algeria',
      ru: 'Алжир',
      pl: 'Algieria',
      uk: 'Алжир',
      cs: 'Alžírsko',
      be: 'Алжыр',
      pt: 'Argélia',
      es: 'Argelia',
      ro: 'Algeria',
      bg: 'Алжир',
      de: 'Algerien',
      fr: 'Algérie',
      nl: 'Algerije',
      it: 'Algeria',
      cn: '阿尔及利亚',
      zh: '阿爾及利亞',
      et: 'Alžeeria',
      ja: 'アルジェリア',
      he: "אלג'יריה",
      el: 'Αλγερία',
      kk: 'Алжир',
      ka: 'ალჟირი',
      th: 'แอลจีเรีย',
    },
    phoneLength: 9,
    dialCode: '+213',
    code: 'DZ',
    flag: '🇩🇿',
  },
  {
    name: {
      en: 'American Samoa',
      ru: 'Американское Самоа',
      pl: 'Samoa Amerykańskie',
      uk: 'Американське Самоа',
      cs: 'Americká Samoa',
      be: 'Амерыканскае Самоа',
      pt: 'Samoa',
      es: 'Samoa Americana',
      ro: 'Samoa Americană',
      bg: 'Американска Самоа',
      de: 'Amerikanischen Samoa-Inseln',
      fr: 'Samoa américaines',
      nl: 'Amerikaans Samoa',
      it: 'Samoa americane',
      cn: '美属萨摩亚',
      zh: '美屬薩摩亞',
      et: 'Ameerika Samoa',
      ja: 'アメリカ領サモア',
      he: 'סמואה האמריקנית',
      el: 'Αμερικανική Σαμόα',
      kk: 'Американдық Самоа',
      ka: 'ამერიკის სამოა',
      th: 'อเมริกันซามัว',
    },
    phoneLength: 10,
    dialCode: '+1684',
    code: 'AS',
    flag: '🇦🇸',
  },
  {
    name: {
      en: 'Andorra',
      ru: 'Андорра',
      pl: 'Andora',
      uk: 'Андорра',
      cs: 'Andorra',
      be: 'Андора',
      pt: 'Andorra',
      es: 'Andorra',
      ro: 'Andorra',
      bg: 'Андора',
      de: 'Andorra',
      fr: 'Andorre',
      nl: 'Andorra',
      it: 'Andorra',
      cn: '安道尔',
      zh: '安道爾',
      et: 'Andorra',
      ja: 'アンドラ',
      he: 'אנדורה',
      el: 'Ανδόρρα',
      kk: 'Андорра',
      ka: 'ანდორა',
      th: 'อันดอร์รา',
    },
    phoneLength: 6,
    dialCode: '+376',
    code: 'AD',
    flag: '🇦🇩',
  },
  {
    name: {
      en: 'Angola',
      ru: 'Ангола',
      pl: 'Angola',
      uk: 'Ангола',
      cs: 'Angola',
      be: 'Ангола',
      pt: 'Angola',
      es: 'Angola',
      ro: 'Angola',
      bg: 'Ангола',
      de: 'Angola',
      fr: "L'Angola",
      nl: 'Angola',
      it: 'Angola',
      cn: '安哥拉',
      zh: '安哥拉',
      et: 'Angola',
      ja: 'アンゴラ',
      he: 'אנגולה',
      el: 'Ανγκόλα',
      kk: 'Ангола',
      ka: 'ანგოლა',
      th: 'แองโกลา',
    },
    phoneLength: 9,
    dialCode: '+244',
    code: 'AO',
    flag: '🇦🇴',
  },
  {
    name: {
      en: 'Anguilla',
      ru: 'Ангилья',
      pl: 'Anguilla',
      uk: 'Ангілья',
      cs: 'Anguilla',
      be: 'Ангілья',
      pt: 'Anguila',
      es: 'Anguila',
      ro: 'Anguilla',
      bg: 'Ангила',
      de: 'Anguilla',
      fr: 'Anguilla',
      nl: 'Anguilla',
      it: 'Anguilla',
      cn: '安圭拉岛',
      zh: '安圭拉島',
      et: 'Anguilla',
      ja: 'アンギラ',
      he: 'אנגווילה',
      el: 'Ανγκουίλα',
      kk: 'Ангилья',
      ka: 'ანგილა',
      th: 'แองกวิลลา',
    },
    phoneLength: 7,
    dialCode: '+1264',
    code: 'AI',
    flag: '🇦🇮',
  },
  {
    name: {
      en: 'Antigua and Barbuda',
      ru: 'Антигуа и Барбуда',
      pl: 'Antigua i Barbuda',
      uk: 'Антигуа та Барбуда',
      cs: 'Antigua a Barbuda',
      be: 'Антыгуа і Барбуда',
      pt: 'Antiga e Barbuda',
      es: 'Antigua y Barbuda',
      ro: 'Antigua si Barbuda',
      bg: 'Антигуа и Барбуда',
      de: 'Antigua und Barbuda',
      fr: 'Antigua-et-Barbuda',
      nl: 'Antigua en Barbuda',
      it: 'Antigua e Barbuda',
      cn: '安提瓜和巴布达',
      zh: '安提瓜和巴布達',
      et: 'Antigua ja Barbuda',
      ja: 'アンティグアバーブーダ',
      he: 'אנטיגואה וברבודה',
      el: 'Αντίγκουα και Μπαρμπούντα',
      kk: 'Антигуа және Барбуда',
      ka: 'ანტიგუა და ბარბუდა',
      th: 'แอนติกาและบาร์บูดา',
    },
    phoneLength: 7,
    dialCode: '+1268',
    code: 'AG',
    flag: '🇦🇬',
  },
  {
    name: {
      en: 'Argentina',
      ru: 'Аргентина',
      pl: 'Argentyna',
      uk: 'Аргентина',
      cs: 'Argentina',
      be: 'Аргентына',
      pt: 'Argentina',
      es: 'Argentina',
      ro: 'Argentina',
      bg: 'Аржентина',
      de: 'Argentinien',
      fr: 'Argentine',
      nl: 'Argentinië',
      it: 'Argentina',
      cn: '阿根廷',
      zh: '阿根廷',
      et: 'Argentina',
      ja: 'アルゼンチン',
      he: 'ארגנטינה',
      el: 'Αργεντινή',
      kk: 'Аргентина',
      ka: 'არგენტინა',
      th: 'อาร์เจนตินา',
    },
    phoneLength: 10,
    dialCode: '+54',
    code: 'AR',
    flag: '🇦🇷',
  },
  {
    name: {
      en: 'Armenia',
      ru: 'Армения',
      pl: 'Armenia',
      uk: 'Вірменія',
      cs: 'Arménie',
      be: 'Арменія',
      pt: 'Arménia',
      es: 'Armenia',
      ro: 'Armenia',
      bg: 'Армения',
      de: 'Armenien',
      fr: 'Arménie',
      nl: 'Armenië',
      it: 'Armenia',
      cn: '亚美尼亚',
      zh: '亞美尼亞',
      et: 'Armeenia',
      ja: 'アルメニア',
      he: 'ארמניה',
      el: 'Αρμενία',
      kk: 'Армения',
      ka: 'სომხეთი',
      th: 'อาร์เมเนีย',
    },
    phoneLength: 8,
    dialCode: '+374',
    code: 'AM',
    flag: '🇦🇲',
  },
  {
    name: {
      en: 'Aruba',
      ru: 'Аруба',
      pl: 'Aruba',
      uk: 'Аруба',
      cs: 'Aruba',
      be: 'Аруба',
      pt: 'Aruba',
      es: 'Aruba',
      ro: 'Aruba',
      bg: 'Аруба',
      de: 'Aruba',
      fr: 'Aruba',
      nl: 'Aruba',
      it: 'Aruba',
      cn: '阿鲁巴岛',
      zh: '阿魯巴島',
      et: 'Aruba',
      ja: 'アルバ',
      he: 'ארובה',
      el: 'Αρούμπα',
      kk: 'Аруба',
      ka: 'არუბა',
      th: 'อารูบา',
    },
    phoneLength: 7,
    dialCode: '+297',
    code: 'AW',
    flag: '🇦🇼',
  },
  {
    name: {
      en: 'Australia',
      ru: 'Австралия',
      pl: 'Australia',
      uk: 'Австралія',
      cs: 'Austrálie',
      be: 'Аўстралія',
      pt: 'Austrália',
      es: 'Australia',
      ro: 'Australia',
      bg: 'Австралия',
      de: 'Australien',
      fr: 'Australie',
      nl: 'Australië',
      it: 'Australia',
      cn: '澳大利亚',
      zh: '澳大利亞',
      et: 'Austraalia',
      ja: 'オーストラリア',
      he: 'אוסטרליה',
      el: 'Αυστραλία',
      kk: 'Австралия',
      ka: 'ავსტრალია',
      th: 'ออสเตรเลีย',
    },
    phoneLength: 9,
    dialCode: '+61',
    code: 'AU',
    flag: '🇦🇺',
  },
  {
    name: {
      en: 'Austria',
      ru: 'Австрия',
      pl: 'Austria',
      uk: 'Австрія',
      cs: 'Rakousko',
      be: 'Аўстрыя',
      pt: 'Áustria',
      es: 'Austria',
      ro: 'Austria',
      bg: 'Австрия',
      de: 'Österreich',
      fr: "L'Autriche",
      nl: 'Oostenrijk',
      it: 'Austria',
      cn: '奥地利',
      zh: '奧地利',
      et: 'Austria',
      ja: 'オーストリア',
      he: 'אוסטריה',
      el: 'Αυστρία',
      kk: 'Австрия',
      ka: 'ავსტრია',
      th: 'ออสเตรีย',
    },
    phoneLength: 13,
    dialCode: '+43',
    code: 'AT',
    flag: '🇦🇹',
  },
  {
    name: {
      en: 'Azerbaijan',
      ru: 'Азербайджан',
      pl: 'Azerbejdżan',
      uk: 'Азербайджан',
      cs: 'Ázerbajdžán',
      be: 'Азербайджан',
      pt: 'Azerbaijão',
      es: 'Azerbaiyán',
      ro: 'Azerbaidjan',
      bg: 'Азербайджан',
      de: 'Aserbaidschan',
      fr: 'Azerbaïdjan',
      nl: 'Azerbeidzjan',
      it: 'Azerbaigian',
      cn: '阿塞拜疆',
      zh: '阿塞拜疆',
      et: 'Aserbaidžaan',
      ja: 'アゼルバイジャン',
      he: "אזרבייג'ן",
      el: 'Αζερμπαϊτζάν',
      kk: 'Әзәрбайжан',
      ka: 'აზერბაიჯანი',
      th: 'อาเซอร์ไบจาน',
    },
    phoneLength: 9,
    dialCode: '+994',
    code: 'AZ',
    flag: '🇦🇿',
  },
  {
    name: {
      en: 'Bahamas',
      ru: 'Багамские Острова',
      pl: 'Bahamy',
      uk: 'Багамські острови',
      cs: 'Bahamy',
      be: 'Багамскія астравы',
      pt: 'Baamas',
      es: 'Bahamas',
      ro: 'Bahamas',
      bg: 'Бахамски острови',
      de: 'Bahamas',
      fr: 'Bahamas',
      nl: 'Bahamas',
      it: 'Bahamas',
      cn: '巴哈马',
      zh: '巴哈馬',
      et: 'Bahama',
      ja: 'バハマ',
      he: 'איי בהאמה',
      el: 'Μπαχάμες',
      kk: 'Багам аралдары',
      ka: 'ბაჰამი',
      th: 'บาฮามาส',
    },
    phoneLength: 7,
    dialCode: '+1242',
    code: 'BS',
    flag: '🇧🇸',
  },
  {
    name: {
      en: 'Bahrain',
      ru: 'Бахрейн',
      pl: 'Bahrajn',
      uk: 'Бахрейн',
      cs: 'Bahrajn',
      be: 'Бахрэйн',
      pt: 'Barém',
      es: 'Bahrein',
      ro: 'Bahrain',
      bg: 'Бахрейн',
      de: 'Bahrain',
      fr: 'Bahreïn',
      nl: 'Bahrein',
      it: 'Bahrein',
      cn: '巴林',
      zh: '巴林',
      et: 'Bahrein',
      ja: 'バーレーン',
      he: 'בחריין',
      el: 'Μπαχρέιν',
      kk: 'Бахрейн',
      ka: 'ბაჰრეინი',
      th: 'บาห์เรน',
    },
    phoneLength: 8,
    dialCode: '+973',
    code: 'BH',
    flag: '🇧🇭',
  },
  {
    name: {
      en: 'Bangladesh',
      ru: 'Бангладеш',
      pl: 'Bangladesz',
      uk: 'Бангладеш',
      cs: 'Bangladéš',
      be: 'Бангладэш',
      pt: 'Bangladeche',
      es: 'Bangladesh',
      ro: 'Bangladesh',
      bg: 'Бангладеш',
      de: 'Bangladesch',
      fr: 'Bangladesh',
      nl: 'Bangladesh',
      it: 'Bangladesh',
      cn: '孟加拉国',
      zh: '孟加拉國',
      et: 'Bangladesh',
      ja: 'バングラデシュ',
      he: 'בנגלדש',
      el: 'Μπανγκλαντές',
      kk: 'Бангладеш',
      ka: 'ბანგლადეში',
      th: 'บังกลาเทศ',
    },
    phoneLength: 10,
    dialCode: '+880',
    code: 'BD',
    flag: '🇧🇩',
  },
  {
    name: {
      en: 'Barbados',
      ru: 'Барбадос',
      pl: 'Barbados',
      uk: 'Барбадос',
      cs: 'Barbados',
      be: 'Барбадас',
      pt: 'Barbados',
      es: 'Barbados',
      ro: 'Barbados',
      bg: 'Барбадос',
      de: 'Barbados',
      fr: 'Barbade',
      nl: 'Barbados',
      it: 'Barbados',
      cn: '巴巴多斯',
      zh: '巴巴多斯',
      et: 'Barbados',
      ja: 'バルバドス',
      he: 'ברבדוס',
      el: 'Μπαρμπάντος',
      kk: 'Барбадос',
      ka: 'ბარბადოსი',
      th: 'บาร์เบโดส',
    },
    phoneLength: 7,
    dialCode: '+1246',
    code: 'BB',
    flag: '🇧🇧',
  },
  {
    name: {
      en: 'Belarus',
      ru: 'Белоруссия',
      pl: 'Białoruś',
      uk: 'Білорусь',
      cs: 'Bělorusko',
      be: 'Беларусь',
      pt: 'Bielorrússia',
      es: 'Bielorrusia',
      ro: 'Bielorusia',
      bg: 'Беларус',
      de: 'Weißrussland',
      fr: 'Biélorussie',
      nl: 'Wit-Rusland',
      it: 'Bielorussia',
      cn: '白俄罗斯',
      zh: '白俄羅斯',
      et: 'Valgevene',
      ja: 'ベラルーシ',
      he: 'בלארוס',
      el: 'Λευκορωσία',
      kk: 'Беларусь',
      ka: 'ბელარუსი',
      th: 'เบลารุส',
    },
    phoneLength: 9,
    dialCode: '+375',
    code: 'BY',
    flag: '🇧🇾',
  },
  {
    name: {
      en: 'Belgium',
      ru: 'Бельгия',
      pl: 'Belgia',
      uk: 'Бельгія',
      cs: 'Belgie',
      be: 'Бельгія',
      pt: 'Bélgica',
      es: 'Bélgica',
      ro: 'Belgia',
      bg: 'Белгия',
      de: 'Belgien',
      fr: 'Belgique',
      nl: 'Belgie',
      it: 'Belgio',
      cn: '比利时',
      zh: '比利時',
      et: 'Belgia',
      ja: 'ベルギー',
      he: 'בלגיה',
      el: 'Βέλγιο',
      kk: 'Бельгия',
      ka: 'ბელგია',
      th: 'เบลเยียม',
    },
    phoneLength: 9,
    dialCode: '+32',
    code: 'BE',
    flag: '🇧🇪',
  },
  {
    name: {
      en: 'Belize',
      ru: 'Белиз',
      pl: 'Belize',
      uk: 'Беліз',
      cs: 'Belize',
      be: 'Беліз',
      pt: 'Belize',
      es: 'Belice',
      ro: 'Belize',
      bg: 'Белиз',
      de: 'Belize',
      fr: 'Belize',
      nl: 'Belize',
      it: 'Belize',
      cn: '伯利兹',
      zh: '伯利茲',
      et: 'Belize',
      ja: 'ベリーズ',
      he: 'בליז',
      el: 'Μπελίζ',
      kk: 'Белиз',
      ka: 'ბელიზი',
      th: 'เบลีซ',
    },
    phoneLength: 7,
    dialCode: '+501',
    code: 'BZ',
    flag: '🇧🇿',
  },
  {
    name: {
      en: 'Benin',
      ru: 'Бенин',
      pl: 'Benin',
      uk: 'Бенін',
      cs: 'Benin',
      be: 'Бенін',
      pt: 'Benim',
      es: 'Benín',
      ro: 'Benin',
      bg: 'Бенин',
      de: 'Benin',
      fr: 'Bénin',
      nl: 'Benin',
      it: 'Benin',
      cn: '贝宁',
      zh: '貝寧',
      et: 'Benin',
      ja: 'ベナン',
      he: 'בנין',
      el: 'Μπενίν',
      kk: 'Бенин',
      ka: 'ბენინი',
      th: 'เบนิน',
    },
    phoneLength: 8,
    dialCode: '+229',
    code: 'BJ',
    flag: '🇧🇯',
  },
  {
    name: {
      en: 'Bermuda',
      ru: 'Бермуды',
      pl: 'Bermudy',
      uk: 'Бермуди',
      cs: 'Bermudy',
      be: 'Бярмуды',
      pt: 'Bermudas',
      es: 'Bermudas',
      ro: 'Bermuda',
      bg: 'Бермуди',
      de: 'Bermuda',
      fr: 'Bermudes',
      nl: 'Bermuda',
      it: 'Bermuda',
      cn: '百慕大',
      zh: '百慕大',
      et: 'Bermuda',
      ja: 'バミューダ',
      he: 'ברמודה',
      el: 'Βερμούδες',
      kk: 'Бермуд аралдары',
      ka: 'ბერმუდა',
      th: 'เบอร์มิวดา',
    },
    phoneLength: 7,
    dialCode: '+1441',
    code: 'BM',
    flag: '🇧🇲',
  },
  {
    name: {
      en: 'Bhutan',
      ru: 'Бутан',
      pl: 'Bhutan',
      uk: 'Бутан',
      cs: 'Bhútán',
      be: 'Бутан',
      pt: 'Butão',
      es: 'Bután',
      ro: 'Bhutan',
      bg: 'Бутан',
      de: 'Bhutan',
      fr: 'Bhoutan',
      nl: 'Bhutan',
      it: 'Bhutan',
      cn: '不丹',
      zh: '不丹',
      et: 'Bhutan',
      ja: 'ブータン',
      he: 'בהוטן',
      el: 'Μπουτάν',
      kk: 'Бутан',
      ka: 'ბუტანი',
      th: 'ภูฏาน',
    },
    phoneLength: 8,
    dialCode: '+975',
    code: 'BT',
    flag: '🇧🇹',
  },
  {
    name: {
      en: 'Bolivia',
      ru: 'Боливия',
      pl: 'Boliwia',
      uk: 'Болівія',
      cs: 'Bolívie',
      be: 'Балівія',
      pt: 'Bolívia',
      es: 'Bolivia',
      ro: 'Bolivia',
      bg: 'Боливия',
      de: 'Bolivien',
      fr: 'Bolivie',
      nl: 'Bolivia',
      it: 'Bolivia',
      cn: '玻利维亚',
      zh: '玻利維亞',
      et: 'Boliivia',
      ja: 'ボリビア',
      he: 'בוליביה',
      el: 'Βολιβία',
      kk: 'Боливия',
      ka: 'ბოლივია',
      th: 'โบลิเวีย',
    },
    phoneLength: 8,
    dialCode: '+591',
    code: 'BO',
    flag: '🇧🇴',
  },
  {
    name: {
      en: 'Bosnia and Herzegovina',
      ru: 'Босния и Герцеговина',
      pl: 'Bośnia i Hercegowina',
      uk: 'Боснія і Герцеговина',
      cs: 'Bosna a Hercegovina',
      be: 'Боснія і Герцагавіна',
      pt: 'Bósnia e Herzegovina',
      es: 'Bosnia y Herzegovina',
      ro: 'Bosnia si Hertegovina',
      bg: 'Босна и Херцеговина',
      de: 'Bosnien und Herzegowina',
      fr: 'Bosnie Herzégovine',
      nl: 'Bosnië-Herzegovina',
      it: 'Bosnia Erzegovina',
      cn: '波斯尼亚和黑塞哥维那（简称：波黑',
      zh: '波斯尼亞和黑塞哥維那（簡稱：波黑',
      et: 'Bosnia ja Hertsegoviina',
      ja: 'ボスニア・ヘルツェゴビナ',
      he: 'בוסניה והרצגובינה',
      el: 'Βοσνία και Ερζεγοβίνη',
      kk: 'Босния және Герцеговина',
      ka: 'ბოსნია და ჰერცეგოვინა',
      th: 'บอสเนียและเฮอร์เซโกวีนา',
    },
    phoneLength: 8,
    dialCode: '+387',
    code: 'BA',
    flag: '🇧🇦',
  },
  {
    name: {
      en: 'Botswana',
      ru: 'Ботсвана',
      pl: 'Botswana',
      uk: 'Ботсвана',
      cs: 'Botswana',
      be: 'Батсвана',
      pt: 'Botsuana',
      es: 'Botsuana',
      ro: 'Botswana',
      bg: 'Ботсвана',
      de: 'Botswana',
      fr: 'Botswana',
      nl: 'Botswana',
      it: 'Botswana',
      cn: '博茨瓦纳',
      zh: '博茨瓦納',
      et: 'Botswana',
      ja: 'ボツワナ',
      he: 'בוצואנה',
      el: 'Μποτσουάνα',
      kk: 'Ботсвана',
      ka: 'ბოტსვანა',
      th: 'บอตสวานา',
    },
    phoneLength: 8,
    dialCode: '+267',
    code: 'BW',
    flag: '🇧🇼',
  },
  {
    name: {
      en: 'Brazil',
      ru: 'Бразилия',
      pl: 'Brazylia',
      uk: 'Бразилія',
      cs: 'Brazílie',
      be: 'Бразілія',
      pt: 'Brasil',
      es: 'Brasil',
      ro: 'Brazilia',
      bg: 'Бразилия',
      de: 'Brasilien',
      fr: 'Brésil',
      nl: 'Brazilië',
      it: 'Brasile',
      cn: '巴西',
      zh: '巴西',
      et: 'Brasiilia',
      ja: 'ブラジル',
      he: 'ברזיל',
      el: 'Βραζιλία',
      kk: 'Бразилия',
      ka: 'ბრაზილია',
      th: 'บราซิล',
    },
    phoneLength: 9,
    dialCode: '+55',
    code: 'BR',
    flag: '🇧🇷',
  },
  {
    name: {
      en: 'British Indian Ocean Territory',
      ru: 'Британская территория Индийского океана',
      pl: 'Brytyjskie Terytorium Oceanu Indyjskiego',
      uk: 'Британська територія в Індійському океані',
      cs: 'Britské území v Indickém oceánu',
      be: 'Брытанская тэрыторыя ў Індыйскім акіяне',
      pt: 'Território Britânico do Oceano Índico',
      es: 'Territorio Británico del Océano Índico',
      ro: 'Teritoriul Britanic al Oceanului Indian',
      bg: 'Британска територия в Индийския океан',
      de: 'Britisches Territorium des Indischen Ozeans',
      fr: "Territoire britannique de l'océan Indien",
      nl: 'Brits-Indisch oceaan gebied',
      it: "Territorio britannico dell'Oceano Indiano",
      cn: '英属印度洋领地',
      zh: '英屬印度洋領地',
      et: 'Briti India ookeani territoorium',
      ja: 'イギリス領インド洋地域',
      he: 'טריטוריית האוקיינוס ​​ההודי הבריטי',
      el: 'Βρετανικά Εδάφη Ινδικού Ωκεανού',
      kk: 'Британ аралдары (Үнді мұхиты бөлігі)',
      ka: 'ბრიტანეთის ინდოს ოკეანის ტერიტორია',
      th: 'บริติชอินเดียนโอเชียนเทร์ริทอรี',
    },
    phoneLength: 7,
    dialCode: '+246',
    code: 'IO',
    flag: '🇮🇴',
  },
  {
    name: {
      en: 'Brunei Darussalam',
      ru: 'Бруней-Даруссалам',
      pl: 'Brunei Darussalam',
      uk: 'Бруней-Даруссалам',
      cs: 'Brunej Darussalam',
      be: 'Бруней-Дарусалам',
      pt: 'Brunei',
      es: 'Brunei Darussalam',
      ro: 'Brunei Darussalam',
      bg: 'Бруней Дарусалам',
      de: 'Brunei Darussalam',
      fr: 'Brunei Darussalam',
      nl: 'Brunei Darussalam',
      it: 'Brunei Darussalam',
      cn: '文莱达鲁萨兰国',
      zh: '文萊達魯薩蘭國',
      et: 'Brunei Darussalam',
      ja: 'ブルネイダルサラーム',
      he: 'ברוניי דארוסלאם',
      el: 'Μπρουνέι',
      kk: 'Бруней',
      ka: 'ბრუნეი',
      th: 'บรูไนดารุสซาลาม',
    },
    phoneLength: 7,
    dialCode: '+673',
    code: 'BN',
    flag: '🇧🇳',
  },
  {
    name: {
      en: 'Bulgaria',
      ru: 'Болгария',
      pl: 'Bułgaria',
      uk: 'Болгарія',
      cs: 'Bulharsko',
      be: 'Балгарыя',
      pt: 'Bulgária',
      es: 'Bulgaria',
      ro: 'Bulgaria',
      bg: 'България',
      de: 'Bulgarien',
      fr: 'Bulgarie',
      nl: 'Bulgarije',
      it: 'Bulgaria',
      cn: '保加利亚',
      zh: '保加利亞',
      et: 'Bulgaaria',
      ja: 'ブルガリア',
      he: 'בולגריה',
      el: 'Βουλγαρία',
      kk: 'Болгария',
      ka: 'ბულგარეთი',
      th: 'บัลแกเรีย',
    },
    phoneLength: 9,
    dialCode: '+359',
    code: 'BG',
    flag: '🇧🇬',
  },
  {
    name: {
      en: 'Burkina Faso',
      ru: 'Буркина-Фасо',
      pl: 'Burkina Faso',
      uk: 'Буркіна-Фасо',
      cs: 'Burkina Faso',
      be: 'Буркіна-Фасо',
      pt: 'Burquina Faso',
      es: 'Burkina Faso',
      ro: 'Burkina Faso',
      bg: 'Буркина Фасо',
      de: 'Burkina Faso',
      fr: 'Burkina Faso',
      nl: 'Burkina Faso',
      it: 'Burkina Faso',
      cn: '布基纳法索',
      zh: '布基納法索',
      et: 'Burkina Faso',
      ja: 'ブルキナファソ',
      he: 'בורקינה פאסו',
      el: 'Μπουρκίνα Φάσο',
      kk: 'Буркина-Фасо',
      ka: 'ბურკინა-ფასო',
      th: 'บูร์กินาฟาโซ',
    },
    phoneLength: 8,
    dialCode: '+226',
    code: 'BF',
    flag: '🇧🇫',
  },
  {
    name: {
      en: 'Burundi',
      ru: 'Бурунди',
      pl: 'Burundi',
      uk: 'Бурунді',
      cs: 'Burundi',
      be: 'Бурундзі',
      pt: 'Burúndi',
      es: 'Burundi',
      ro: 'Burundi',
      bg: 'Бурунди',
      de: 'Burundi',
      fr: 'Burundi',
      nl: 'Burundi',
      it: 'Burundi',
      cn: '布隆迪',
      zh: '布隆迪',
      et: 'Burundi',
      ja: 'ブルンジ',
      he: 'בורונדי',
      el: 'Μπουρούντι',
      kk: 'Бурунди',
      ka: 'ბურუნდი',
      th: 'บุรุนดี',
    },
    phoneLength: 8,
    dialCode: '+257',
    code: 'BI',
    flag: '🇧🇮',
  },
  {
    name: {
      en: 'Cambodia',
      ru: 'Камбоджа',
      pl: 'Kambodża',
      uk: 'Камбоджа',
      cs: 'Kambodža',
      be: 'Камбоджа',
      pt: 'Camboja',
      es: 'Camboya',
      ro: 'Cambodgia',
      bg: 'Камбоджа',
      de: 'Kambodscha',
      fr: 'Cambodge',
      nl: 'Cambodja',
      it: 'Cambogia',
      cn: '柬埔寨',
      zh: '柬埔寨',
      et: 'Kambodža',
      ja: 'カンボジア',
      he: 'קמבודיה',
      el: 'Καμπότζη',
      kk: 'Камбоджа',
      ka: 'კამბოჯა',
      th: 'กัมพูชา',
    },
    phoneLength: 8,
    dialCode: '+855',
    code: 'KH',
    flag: '🇰🇭',
  },
  {
    name: {
      en: 'Cameroon',
      ru: 'Камерун',
      pl: 'Kamerun',
      uk: 'Камерун',
      cs: 'Kamerun',
      be: 'Камерун',
      pt: 'Camarões',
      es: 'Camerún',
      ro: 'Camerun',
      bg: 'Камерун',
      de: 'Kamerun',
      fr: 'Cameroun',
      nl: 'Kameroen',
      it: 'Camerun',
      cn: '喀麦隆',
      zh: '喀麥隆',
      et: 'Kamerun',
      ja: 'カメルーン',
      he: 'קמרון',
      el: 'Καμερούν',
      kk: 'Камерун',
      ka: 'კამერუნი',
      th: 'แคเมอรูน',
    },
    phoneLength: 8,
    dialCode: '+237',
    code: 'CM',
    flag: '🇨🇲',
  },
  {
    name: {
      en: 'Canada',
      ru: 'Канада',
      pl: 'Kanada',
      uk: 'Канада',
      cs: 'Kanada',
      be: 'Канада',
      pt: 'Canadá',
      es: 'Canadá',
      ro: 'Canada',
      bg: 'Канада',
      de: 'Kanada',
      fr: 'Canada',
      nl: 'Canada',
      it: 'Canada',
      cn: '加拿大',
      zh: '加拿大',
      et: 'Kanada',
      ja: 'カナダ',
      he: 'קנדה',
      el: 'Καναδάς',
      kk: 'Канада',
      ka: 'კანადა',
      th: 'แคนาดา',
    },
    phoneLength: 10,
    dialCode: '+1',
    code: 'CA',
    flag: '🇨🇦',
  },
  {
    name: {
      en: 'Cape Verde',
      ru: 'Кабо-Верде',
      pl: 'Wyspy Zielonego Przylądka',
      uk: 'Кабо-Верде',
      cs: 'Kapverdy',
      be: 'Каба-Вэрдэ',
      pt: 'Cabo Verde',
      es: 'Cabo Verde',
      ro: 'capul Verde',
      bg: 'Кабо Верде',
      de: 'Kap Verde',
      fr: 'Cap-Vert',
      nl: 'Kaapverdië',
      it: 'capo Verde',
      cn: '佛得角',
      zh: '佛得角',
      et: 'Roheneemesaared',
      ja: 'カーボベルデ',
      he: 'קייפ ורדה',
      el: 'Πράσινο Ακρωτήριο',
      kk: 'Кабо-Верде',
      ka: 'კაბო-ვერდე',
      th: 'เคปเวิร์ด',
    },
    phoneLength: 7,
    dialCode: '+238',
    code: 'CV',
    flag: '🇨🇻',
  },
  {
    name: {
      en: 'Cayman Islands',
      ru: 'Каймановы острова',
      pl: 'Kajmany',
      uk: 'Кайманові острови',
      cs: 'Kajmanské ostrovy',
      be: 'Кайманавы выспы',
      pt: 'Ilhas Caimão',
      es: 'Islas Caimán',
      ro: 'Insulele Cayman',
      bg: 'Кайманови острови',
      de: 'Cayman Inseln',
      fr: 'Îles Caïmans',
      nl: 'Kaaiman Eilanden',
      it: 'Isole Cayman',
      cn: '开曼群岛',
      zh: '開曼群島',
      et: 'Kaimani saared',
      ja: 'ケイマン諸島',
      he: 'איי קיימן',
      el: 'Νήσοι Κέιμαν',
      kk: 'Кайман аралдары',
      ka: 'კაიმანი',
      th: 'หมู่เกาะเคย์แมน',
    },
    phoneLength: 7,
    dialCode: '+1345',
    code: 'KY',
    flag: '🇰🇾',
  },
  {
    name: {
      en: 'Central African Republic',
      ru: 'Центрально-Африканская Республика',
      pl: 'Republika Środkowoafrykańska',
      uk: 'Центральноафриканська Республіка',
      cs: 'Středoafrická republika',
      be: 'Цэнтральна-Афрыканская Рэспубліка',
      pt: 'República Centro-Africana',
      es: 'República Centroafricana',
      ro: 'Republica Centrafricană',
      bg: 'Централноафриканска република',
      de: 'Zentralafrikanische Republik',
      fr: 'République centrafricaine',
      nl: 'Centraal Afrikaanse Republiek',
      it: 'Repubblica Centrafricana',
      cn: '中非共和国',
      zh: '中非共和國',
      et: 'Kesk-Aafrika Vabariik',
      ja: '中央アフリカ共和国',
      he: 'הרפובליקה המרכז - אפריקאית',
      el: 'Κεντροαφρικανική Δημοκρατία',
      kk: 'Орталық Африка Республикасы',
      ka: 'ცენტრალური აფრიკის რესპუბლიკა',
      th: 'สาธารณรัฐแอฟริกากลาง',
    },
    phoneLength: 7,
    dialCode: '+236',
    code: 'CF',
    flag: '🇨🇫',
  },
  {
    name: {
      en: 'Chad',
      ru: 'Чад',
      pl: 'Czad',
      uk: 'Чад',
      cs: 'Čad',
      be: 'Чад',
      pt: 'Chade',
      es: 'Chad',
      ro: 'Ciad',
      bg: 'Чад',
      de: 'Tschad',
      fr: 'Tchad',
      nl: 'Tsjaad',
      it: 'Chad',
      cn: '乍得',
      zh: '乍得',
      et: 'Tšaad',
      ja: 'チャド',
      he: "צ'אד",
      el: 'Τσαντ',
      kk: 'Чад',
      ka: 'ჩადი',
      th: 'ชาด',
    },
    phoneLength: 8,
    dialCode: '+235',
    code: 'TD',
    flag: '🇹🇩',
  },
  {
    name: {
      en: 'Chile',
      ru: 'Чили',
      pl: 'Chile',
      uk: 'Чилі',
      cs: 'Chile',
      be: 'Чылі',
      pt: 'Chile',
      es: 'Chile',
      ro: 'Chile',
      bg: 'Чили',
      de: 'Chile',
      fr: 'Chili',
      nl: 'Chili',
      it: 'Chile',
      cn: '智利',
      zh: '智利',
      et: 'Tšiili',
      ja: 'チリ',
      he: "צ'ילה",
      el: 'Χιλή',
      kk: 'Чили',
      ka: 'ჩილე',
      th: 'ชิลี',
    },
    phoneLength: 9,
    dialCode: '+56',
    code: 'CL',
    flag: '🇨🇱',
  },
  {
    name: {
      en: 'China',
      ru: 'Китай',
      pl: 'Chiny',
      uk: 'Китай',
      cs: 'Čína',
      be: 'Кітай',
      pt: 'China',
      es: 'China',
      ro: 'China',
      bg: 'Китай',
      de: 'China',
      fr: 'Chine',
      nl: 'China',
      it: 'Cina',
      cn: '中国',
      zh: '中國',
      et: 'Hiina',
      ja: '中国',
      he: 'חרסינה',
      el: 'Κίνα',
      kk: 'Кытай',
      ka: 'ჩინეთი',
      th: 'จีน',
    },
    phoneLength: 11,
    dialCode: '+86',
    code: 'CN',
    flag: '🇨🇳',
  },
  {
    name: {
      en: 'Christmas Island',
      ru: 'Остров Рождества',
      pl: 'Wyspa Bożego Narodzenia',
      uk: 'Острів Різдва',
      cs: 'Vánoční ostrov',
      be: 'Востраў Каляд',
      pt: 'Ilha do Natal',
      es: 'Isla de Navidad',
      ro: 'Insula Craciunului',
      bg: 'Коледен остров',
      de: 'Weihnachtsinsel',
      fr: "L'île de noël",
      nl: 'Kersteiland',
      it: 'Isola di Natale',
      cn: '圣诞岛',
      zh: '聖誕島',
      et: 'Jõulusaar',
      ja: 'クリスマス島',
      he: 'אי חג המולד',
      el: 'Νήσος των Χριστουγέννων',
      kk: 'Кристмас аралы',
      ka: 'შობის კუნძული',
      th: 'เกาะคริสต์มาส',
    },
    phoneLength: 7,
    dialCode: '+61',
    code: 'CX',
    flag: '🇨🇽',
  },
  {
    name: {
      en: 'Cocos (Keeling) Islands',
      ru: 'Кокосовые (Килинг) острова',
      pl: 'Wyspy Kokosowe (Keelinga)',
      uk: 'Кокосові (Кілінг) острови',
      cs: 'Kokosové (Keelingovy) ostrovy',
      be: 'Какосавыя (Кілінскія) астравы',
      pt: 'Ilhas dos Cocos',
      es: 'Islas Cocos (Keeling)',
      ro: 'Insulele Cocos (Keeling)',
      bg: 'Кокосови (Кийлинг) острови',
      de: 'Kokosinseln (Keelinginseln)',
      fr: 'Îles Cocos (Keeling)',
      nl: 'Cocos (Keeling) eilanden',
      it: 'Isole Cocos (Keeling)',
      cn: '科科斯（基林）群岛',
      zh: '科科斯（基林）群島',
      et: 'Kookossaared (Keelingi) saared',
      ja: 'ココス（キーリング）諸島',
      he: 'איי קוקוס (קילינג).',
      el: 'Νησιά Κόκος',
      kk: 'Кокос (Килинг) аралдары',
      ka: 'კოკოსი (კილინგი) კუნძულები',
      th: 'หมู่เกาะโคโคส (คีลิง)',
    },
    phoneLength: 6,
    dialCode: '+61',
    code: 'CC',
    flag: '🇨🇨',
  },
  {
    name: {
      en: 'Colombia',
      ru: 'Колумбия',
      pl: 'Kolumbia',
      uk: 'Колумбія',
      cs: 'Kolumbie',
      be: 'Калумбія',
      pt: 'Colômbia',
      es: 'Colombia',
      ro: 'Columbia',
      bg: 'Колумбия',
      de: 'Kolumbien',
      fr: 'Colombie',
      nl: 'Colombia',
      it: 'Colombia',
      cn: '哥伦比亚',
      zh: '哥倫比亞',
      et: 'Kolumbia',
      ja: 'コロンビア',
      he: 'קולומביה',
      el: 'Κολομβία',
      kk: 'Колумбия',
      ka: 'კოლუმბია',
      th: 'โคลอมเบีย',
    },
    phoneLength: 10,
    dialCode: '+57',
    code: 'CO',
    flag: '🇨🇴',
  },
  {
    name: {
      en: 'Comoros',
      ru: 'Коморские острова',
      pl: 'Komory',
      uk: 'Коморські острови',
      cs: 'Komory',
      be: 'Каморскія выспы',
      pt: 'Comores',
      es: 'Comoras',
      ro: 'Comore',
      bg: 'Коморски острови',
      de: 'Komoren',
      fr: 'Comores',
      nl: 'Comoren',
      it: 'Comore',
      cn: '科摩罗',
      zh: '科摩羅',
      et: 'Komoorid',
      ja: 'コモロ',
      he: 'קומורו',
      el: 'Κομόρες',
      kk: 'Комор аралдары',
      ka: 'კომოროსი',
      th: 'คอโมโรส',
    },
    phoneLength: 7,
    dialCode: '+269',
    code: 'KM',
    flag: '🇰🇲',
  },
  {
    name: {
      en: 'Republic of the Congo',
      ru: 'Республика Конго',
      pl: 'Republika Konga',
      uk: 'Республіка Конго',
      cs: 'Kongo, Republika',
      be: 'Рэспубліка Конга',
      pt: 'Congo-Brazzaville',
      es: 'Congo, República del',
      ro: 'Republica Congo',
      bg: 'Конго, Република Конго',
      de: 'Kongo, Republik Kongo',
      fr: 'Congo, République du',
      nl: 'Congo, Republiek Congo',
      it: 'Congo, Repubblica del Congo',
      cn: '刚果共和国',
      zh: '剛果共和國',
      et: 'Kongo Vabariik',
      ja: 'コンゴ共和国',
      he: 'רפובליקת קונגו',
      el: 'Δημοκρατία του Κονγκό',
      kk: 'Қоңыртқы Республикасы',
      ka: 'კონგო, რესპუბლიკა',
      th: 'สาธารณรัฐคองโก',
    },
    phoneLength: 9,
    dialCode: '+242',
    code: 'CG',
    flag: '🇨🇬',
  },
  {
    name: {
      en: 'Congo, The Democratic Republic',
      ru: 'Конго, Демократическая Республика',
      pl: 'Kongo, Republika Demokratyczna',
      uk: 'Конго, Демократична Республіка',
      cs: 'Kongo, Demokratická Republika',
      be: 'Конга, Дэмакратычная Рэспубліка Конга',
      pt: 'Congo-Kinshasa',
      es: 'Congo, República Democrática del',
      ro: 'Congo, Republica Democrată Congo',
      bg: 'Конго, Демократична република Конго',
      de: 'Kongo, Demokratische Republik Kongo',
      fr: 'Congo, République démocratique du Congo',
      nl: 'Congo, Democratische Republiek Congo',
      it: 'Congo, Repubblica Democratica del Congo',
      cn: '刚果民主共和国',
      zh: '剛果民主共和國',
      et: 'Kongo, Kongo Demokraatlik Vabariik',
      ja: 'コンゴ、コンゴ民主共和国',
      he: 'קונגו, הרפובליקה הדמוקרטית של',
      el: 'Λαϊκή Δημοκρατία του Κονγκό',
      kk: 'Демократиялық Республика Конго',
      ka: 'კონგო, დემოკრატიული რესპუბლიკა',
      th: 'สาธารณรัฐประชาธิปไตยคองโก',
    },
    phoneLength: 9,
    dialCode: '+243',
    code: 'CD',
    flag: '🇨🇩',
  },
  {
    name: {
      en: 'Cook Islands',
      ru: 'Острова Кука',
      pl: 'Wyspy Cooka',
      uk: 'Острови Кука',
      cs: 'Cookovy ostrovy',
      be: 'Астравы Кука',
      pt: 'Ilhas Cook',
      es: 'Islas Cook',
      ro: 'Insulele Cook',
      bg: 'Острови Кук',
      de: 'Cookinseln',
      fr: 'les Îles Cook',
      nl: 'Cook Eilanden',
      it: 'Isole Cook',
      cn: '库克群岛',
      zh: '庫克群島',
      et: 'Cooki saared',
      ja: 'クック諸島',
      he: 'איי קוק',
      el: 'Νήσοι Κουκ',
      kk: 'Кук Аралдары',
      ka: 'კუკის კუნძულები',
      th: 'หมู่เกาะคุก',
    },
    phoneLength: 8,
    dialCode: '+682',
    code: 'CK',
    flag: '🇨🇰',
  },
  {
    name: {
      en: 'Costa Rica',
      ru: 'Коста-Рика',
      pl: 'Kostaryka',
      uk: 'Коста-Ріка',
      cs: 'Kostarika',
      be: 'Коста-Рыка',
      pt: 'Costa Rica',
      es: 'Costa Rica',
      ro: 'Costa Rica',
      bg: 'Коста Рика',
      de: 'Costa Rica',
      fr: 'Costa Rica',
      nl: 'Costa Rica',
      it: 'Costa Rica',
      cn: '哥斯达黎加',
      zh: '哥斯達黎加',
      et: 'Costa Rica',
      ja: 'コスタリカ',
      he: 'קוסטה ריקה',
      el: 'Κόστα Ρίκα',
      kk: 'Коста-Рика Республикасы',
      ka: 'კოსტა-რიკა',
      th: 'ประเทศคอสตาริกา',
    },
    phoneLength: 8,
    dialCode: '+506',
    code: 'CR',
    flag: '🇨🇷',
  },
  {
    name: {
      en: "Cote d'Ivoire",
      ru: "Кот-д'Ивуар",
      pl: 'Wybrzeże Kości Słoniowej',
      uk: "Кот-д'Івуар",
      cs: 'Pobřeží slonoviny',
      be: "Кот-д'Івуар",
      pt: 'Costa do Marfim',
      es: 'Costa de Marfil',
      ro: 'Coasta de Fildeș',
      bg: "Кот д'Ивоар",
      de: 'Elfenbeinküste',
      fr: "Côte d'Ivoire",
      nl: 'Ivoorkust',
      it: "Costa d'Avorio",
      cn: '科特迪瓦',
      zh: '科特迪瓦',
      et: 'Elevandiluurannik',
      ja: 'コートジボワール',
      he: 'חוף השנהב',
      el: 'Ακτή Ελεφαντοστού',
      kk: "Кот-д'Ивуар",
      ka: 'კოტ-დივუარი',
      th: 'โกตดิวัวร์',
    },
    phoneLength: 8,
    dialCode: '+225',
    code: 'CI',
    flag: '🇨🇮',
  },
  {
    name: {
      en: 'Croatia',
      ru: 'Хорватия',
      pl: 'Chorwacja',
      uk: 'Хорватія',
      cs: 'Chorvatsko',
      be: 'Харватыя',
      pt: 'Croácia',
      es: 'Croacia',
      ro: 'Croaţia',
      bg: 'Хърватия',
      de: 'Kroatien',
      fr: 'Croatie',
      nl: 'Kroatië',
      it: 'Croazia',
      cn: '克罗地亚',
      zh: '克羅地亞',
      et: 'Horvaatia',
      ja: 'クロアチア',
      he: 'קרואטיה',
      el: 'Κροατία',
      kk: 'Хорватия',
      ka: 'ხორვატია',
      th: 'โครเอเชีย',
    },
    phoneLength: 8,
    dialCode: '+385',
    code: 'HR',
    flag: '🇭🇷',
  },
  {
    name: {
      en: 'Cuba',
      ru: 'Куба',
      pl: 'Kuba',
      uk: 'Куба',
      cs: 'Kuba',
      be: 'Куба',
      pt: 'Cuba',
      es: 'Cuba',
      ro: 'Cuba',
      bg: 'Куба',
      de: 'Kuba',
      fr: 'Cuba',
      nl: 'Cuba',
      it: 'Cuba',
      cn: '古巴',
      zh: '古巴',
      et: 'Kuuba',
      ja: 'キューバ',
      he: 'קובה',
      el: 'Κούβα',
      kk: 'Куба',
      ka: 'კუბა',
      th: 'คิวบา',
    },
    phoneLength: 8,
    dialCode: '+53',
    code: 'CU',
    flag: '🇨🇺',
  },
  {
    name: {
      en: 'Cyprus',
      ru: 'Кипр',
      pl: 'Cypr',
      uk: 'Кіпр',
      cs: 'Kypr',
      be: 'Кіпр',
      pt: 'Chipre',
      es: 'Chipre',
      ro: 'Cipru',
      bg: 'Кипър',
      de: 'Zypern',
      fr: 'Chypre',
      nl: 'Cyprus',
      it: 'Cipro',
      cn: '塞浦路斯',
      zh: '塞浦路斯',
      et: 'Küpros',
      ja: 'キプロス',
      he: 'קפריסין',
      el: 'Κύπρος',
      kk: 'Кипр Республикасы',
      ka: 'კვიპროსი',
      th: 'ไซปรัส',
    },
    phoneLength: 8,
    dialCode: '+357',
    code: 'CY',
    flag: '🇨🇾',
  },
  {
    name: {
      en: 'Czech Republic',
      ru: 'Чехия',
      pl: 'Republika Czeska',
      uk: 'Чеська Республіка',
      cs: 'Česká republika',
      be: 'Чэская Рэспубліка',
      pt: 'República Checa',
      es: 'República Checa',
      ro: 'Republica Cehă',
      bg: 'Чехия',
      de: 'Tschechien',
      fr: 'République Tchèque',
      nl: 'Tsjechië',
      it: 'Repubblica Ceca',
      cn: '捷克共和国',
      zh: '捷克共和國',
      et: 'Tšehhi Vabariik',
      ja: 'チェコ共和国',
      he: "הרפובליקה הצ'כית",
      el: 'Τσεχία',
      kk: 'Чех Республикасы',
      ka: 'ჩეხეთის რესპუბლიკა',
      th: 'สาธารณรัฐเช็ก',
    },
    phoneLength: 9,
    dialCode: '+420',
    code: 'CZ',
    flag: '🇨🇿',
  },
  {
    name: {
      en: 'Denmark',
      ru: 'Дания',
      pl: 'Dania',
      uk: 'Данія',
      cs: 'Dánsko',
      be: 'Данія',
      pt: 'Dinamarca',
      es: 'Dinamarca',
      ro: 'Danemarca',
      bg: 'Дания',
      de: 'Dänemark',
      fr: 'Danemark',
      nl: 'Denemarken',
      it: 'Danimarca',
      cn: '丹麦',
      zh: '丹麥',
      et: 'Taani',
      ja: 'デンマーク',
      he: 'דנמרק',
      el: 'Δανία',
      kk: 'Дания',
      ka: 'დანია',
      th: 'เดนมาร์ก',
    },
    phoneLength: 8,
    dialCode: '+45',
    code: 'DK',
    flag: '🇩🇰',
  },
  {
    name: {
      en: 'Djibouti',
      ru: 'Джибути',
      pl: 'Dżibuti',
      uk: 'Джибуті',
      cs: 'Džibuti',
      be: 'Джыбуці',
      pt: 'Jibuti',
      es: 'Yibuti',
      ro: 'Djibouti',
      bg: 'Джибути',
      de: 'Dschibuti',
      fr: 'Djibouti',
      nl: 'Djibouti',
      it: 'Gibuti',
      cn: '吉布地',
      zh: '吉布地',
      et: 'Djibouti',
      ja: 'ジブチ',
      he: "ג'יבוטי",
      el: 'Τζιμπουτί',
      kk: 'Жибути Республикасы',
      ka: 'ჯიბუტის რესპუბლიკა',
      th: 'จิบูตี',
    },
    phoneLength: 8,
    dialCode: '+253',
    code: 'DJ',
    flag: '🇩🇯',
  },
  {
    name: {
      en: 'Dominica',
      ru: 'Доминика',
      pl: 'Dominika',
      uk: 'Домініка',
      cs: 'Dominika',
      be: 'Дамініка',
      pt: 'Domínica',
      es: 'Dominica',
      ro: 'Dominica',
      bg: 'Доминика',
      de: 'Dominica',
      fr: 'Dominique',
      nl: 'Dominica',
      it: 'Dominica',
      cn: '多米尼加',
      zh: '多米尼加',
      et: 'Dominica',
      ja: 'ドミニカ',
      he: 'דומיניקה',
      el: 'Δομινίκα',
      kk: 'Доминика Республикасы',
      ka: 'დომინიკა',
      th: 'โดมินิกา',
    },
    phoneLength: 7,
    dialCode: '+1767',
    code: 'DM',
    flag: '🇩🇲',
  },
  {
    name: {
      en: 'Dominican Republic',
      ru: 'Доминиканская Респблика',
      pl: 'Republika Dominikany',
      uk: 'Домініканська республіка',
      cs: 'Dominikánská republika',
      be: 'Дамініканская Рэспубліка',
      pt: 'República Dominicana',
      es: 'República Dominicana',
      ro: 'Republica Dominicana',
      bg: 'Доминиканска република',
      de: 'Dominikanische Republik',
      fr: 'République dominicaine',
      nl: 'Dominicaanse Republiek',
      it: 'Repubblica Dominicana',
      cn: '多明尼加共和国',
      zh: '多明尼加共和國',
      et: 'Dominikaani Vabariik',
      ja: 'ドミニカ共和国',
      he: 'הרפובליקה הדומיניקנית',
      el: 'Δομινικανή Δημοκρατία',
      kk: 'Доминикан Республикасы',
      ka: 'დომინიკას რესპუბლიკა',
      th: 'สาธารณรัฐโดมินิกัน',
    },
    phoneLength: 10,
    dialCode: '+1',
    code: 'DO',
    flag: '🇩🇴',
  },
  {
    name: {
      en: 'Ecuador',
      ru: 'Эквадор',
      pl: 'Ekwador',
      uk: 'Еквадор',
      cs: 'Ekvádor',
      be: 'Эквадор',
      pt: 'Equador',
      es: 'Ecuador',
      ro: 'Ecuador',
      bg: 'Еквадор',
      de: 'Ecuador',
      fr: 'Equateur',
      nl: 'Ecuador',
      it: 'Ecuador',
      cn: '厄瓜多尔',
      zh: '厄瓜多爾',
      et: 'Ecuador',
      ja: 'エクアドル',
      he: 'אקוודור',
      el: 'Ισημερινός',
      kk: 'Экуадор',
      ka: 'ეკვადორი',
      th: 'เอกวาดอร์',
    },
    phoneLength: 9,
    dialCode: '+593',
    code: 'EC',
    flag: '🇪🇨',
  },
  {
    name: {
      en: 'Egypt',
      ru: 'Египет',
      pl: 'Egipt',
      uk: 'Єгипет',
      cs: 'Egypt',
      be: 'Егіпет',
      pt: 'Egipto',
      es: 'Egipto',
      ro: 'Egipt',
      bg: 'Египет',
      de: 'Ägypten',
      fr: 'Egypte',
      nl: 'Egypte',
      it: 'Egitto',
      cn: '埃及',
      zh: '埃及',
      et: 'Egiptus',
      ja: 'エジプト',
      he: 'מצרים',
      el: 'Αίγυπτος',
      kk: 'Египет',
      ka: 'ეგვიპტე',
      th: 'อียิปต์',
    },
    phoneLength: 10,
    dialCode: '+20',
    code: 'EG',
    flag: '🇪🇬',
  },
  {
    name: {
      en: 'El Salvador',
      ru: 'Сальвадор',
      pl: 'Salwador',
      uk: 'Сальвадор',
      cs: 'El Salvador',
      be: 'Сальвадор',
      pt: 'Salvador',
      es: 'El Salvador',
      ro: 'El Salvador',
      bg: 'Ел Салвадор',
      de: 'El Salvador',
      fr: 'Le Salvador',
      nl: 'El Salvador',
      it: 'El Salvador',
      cn: '萨尔瓦多',
      zh: '薩爾瓦多',
      et: 'El Salvador',
      ja: 'エルサルバドル',
      he: 'אל סלבדור',
      el: 'Ελ Σαλβαδόρ',
      kk: 'Сальвадор Республикасы',
      ka: 'სალვადორის რესპუბლიკა',
      th: 'เอลซัลวาดอร์',
    },
    phoneLength: 8,
    dialCode: '+503',
    code: 'SV',
    flag: '🇸🇻',
  },
  {
    name: {
      en: 'Equatorial Guinea',
      ru: 'Экваториальная Гвинея',
      pl: 'Gwinea Równikowa',
      uk: 'Екваторіальна Гвінея',
      cs: 'Rovníková Guinea',
      be: 'Экватарыяльная Гвінея',
      pt: 'Guiné Equatorial',
      es: 'Guinea Ecuatorial',
      ro: 'Guineea Ecuatorială',
      bg: 'Екваториална Гвинея',
      de: 'Äquatorialguinea',
      fr: 'Guinée Équatoriale',
      nl: 'Equatoriaal-Guinea',
      it: 'Guinea Equatoriale',
      cn: '赤道几内亚',
      zh: '赤道幾內亞',
      et: 'Ekvatoriaalne Guinea',
      ja: '赤道ギニア',
      he: 'גיניאה המשוונית',
      el: 'Ισημερινή Γουινέα',
      kk: 'Экваторлық Гвинея Республикасы',
      ka: 'ეკვატორიალური გვინეა, რესპუბლიკა',
      th: 'อิเควทอเรียลกินี',
    },
    phoneLength: 9,
    dialCode: '+240',
    code: 'GQ',
    flag: '🇬🇶',
  },
  {
    name: {
      en: 'Eritrea',
      ru: 'Эритрея',
      pl: 'Erytrea',
      uk: 'Еритрея',
      cs: 'Eritrea',
      be: 'Эрытрэя',
      pt: 'Eritreia',
      es: 'Eritrea',
      ro: 'Eritreea',
      bg: 'Еритрея',
      de: 'Eritrea',
      fr: 'Érythrée',
      nl: 'Eritrea',
      it: 'Eritrea',
      cn: '厄立特里亚',
      zh: '厄立特里亞',
      et: 'Eritrea',
      ja: 'エリトリア',
      he: 'אריתריאה',
      el: 'Ερυθραία',
      kk: 'Эритрея',
      ka: 'ერიტრეა',
      th: 'เอริเทรีย',
    },
    phoneLength: 7,
    dialCode: '+291',
    code: 'ER',
    flag: '🇪🇷',
  },
  {
    name: {
      en: 'Estonia',
      ru: 'Эстония',
      pl: 'Estonia',
      uk: 'Естонія',
      cs: 'Estonsko',
      be: 'Эстонія',
      pt: 'Estónia',
      es: 'Estonia',
      ro: 'Estonia',
      bg: 'Естония',
      de: 'Estland',
      fr: 'Estonie',
      nl: 'Estland',
      it: 'Estonia',
      cn: '爱沙尼亚',
      zh: '愛沙尼亞',
      et: 'Eesti',
      ja: 'エストニア',
      he: 'אסטוניה',
      el: 'Εσθονία',
      kk: 'Эстония',
      ka: 'ესტონეთი',
      th: 'เอสโตเนีย',
    },
    phoneLength: 8,
    dialCode: '+372',
    code: 'EE',
    flag: '🇪🇪',
  },
  {
    name: {
      en: 'Ethiopia',
      ru: 'Эфиопия',
      pl: 'Etiopia',
      uk: 'Ефіопія',
      cs: 'Etiopie',
      be: 'Эфіопія',
      pt: 'Etiópia',
      es: 'Etiopía',
      ro: 'Etiopia',
      bg: 'Етиопия',
      de: 'Äthiopien',
      fr: 'Ethiopie',
      nl: 'Ethiopië',
      it: 'Etiopia',
      cn: '埃塞俄比亚',
      zh: '埃塞俄比亞',
      et: 'Etioopia',
      ja: 'エチオピア',
      he: 'אתיופיה',
      el: 'Αιθιοπία',
      kk: 'Эфиопия',
      ka: 'ეთიოპია',
      th: 'เอธิโอเปีย',
    },
    phoneLength: 9,
    dialCode: '+251',
    code: 'ET',
    flag: '🇪🇹',
  },
  {
    name: {
      en: 'Falkland Islands (Malvinas)',
      ru: 'Фолклендские острова (Malvinas)',
      pl: 'Falklandy (Malwiny)',
      uk: 'Фолклендські острови (Мальвінські острови)',
      cs: 'Falklandské ostrovy (Malvíny)',
      be: 'Фолклендскія астравы (Мальвіна)',
      pt: 'Ilhas Falkland',
      es: 'Islas Malvinas (Falkland Islands)',
      ro: 'Insulele Falkland (Malvinas)',
      bg: 'Фолкландски острови (Малвински острови)',
      de: 'Falklandinseln (Malvinas)',
      fr: 'Îles Falkland (Malvinas)',
      nl: 'Falklandeilanden (Malvinas)',
      it: 'Isole Falkland (Malvinas)',
      cn: '福克兰群岛（马尔维纳斯）',
      zh: '福克蘭群島（馬爾維納斯）',
      et: 'Falklandi saared (Malvinas)',
      ja: 'フォークランド諸島（マルビナス）',
      he: 'איי פוקלנד (מלווינאס)',
      el: 'Νήσοι Φώκλαντ',
      kk: 'Фолкленд аралдары (Мальвина аралдары)',
      ka: 'ფოლკლენდის კუნძულები (მალვინას კუნძები)',
      th: 'หมู่เกาะฟอล์กแลนด์ (มัลวินัส)',
    },
    phoneLength: 5,
    dialCode: '+500',
    code: 'FK',
    flag: '🇫🇰',
  },
  {
    name: {
      en: 'Faroe Islands',
      ru: 'Фарерские острова',
      pl: 'Wyspy Owcze',
      uk: 'Фарерські острови',
      cs: 'Faerské ostrovy',
      be: 'Фарэрскія астравы',
      pt: 'Faroé',
      es: 'Islas Feroe',
      ro: 'Insulele Feroe',
      bg: 'Фарьорските острови',
      de: 'Färöer Inseln',
      fr: 'Îles Féroé',
      nl: 'Faeröer',
      it: 'Isole Faroe',
      cn: '法罗群岛',
      zh: '法羅群島',
      et: 'Fääri saared',
      ja: 'フェロー諸島',
      he: 'איי פרו',
      el: 'Νήσοι Φερόες',
      kk: 'Фарер аралдары',
      ka: 'ფაროს კუნძულები',
      th: 'หมู่เกาะแฟโร',
    },
    phoneLength: 6,
    dialCode: '+298',
    code: 'FO',
    flag: '🇫🇴',
  },
  {
    name: {
      en: 'Fiji',
      ru: 'Фиджи',
      pl: 'Fidżi',
      uk: 'Фіджі',
      cs: 'Fidži',
      be: 'Фіджы',
      pt: 'Fiji',
      es: 'Fiyi',
      ro: 'Fiji',
      bg: 'Фиджи',
      de: 'Fidschi',
      fr: 'Fidji',
      nl: 'Fiji',
      it: 'Figi',
      cn: '斐济',
      zh: '斐濟',
      et: 'Fidži',
      ja: 'フィジー',
      he: "פיג'י",
      el: 'Φίτζι',
      kk: 'Фиджи',
      ka: 'ფიჯი',
      th: 'ฟิจิ',
    },
    phoneLength: 8,
    dialCode: '+679',
    code: 'FJ',
    flag: '🇫🇯',
  },
  {
    name: {
      en: 'Finland',
      ru: 'Финляндия',
      pl: 'Finlandia',
      uk: 'Фінляндія',
      cs: 'Finsko',
      be: 'Фінляндыя',
      pt: 'Finlândia',
      es: 'Finlandia',
      ro: 'Finlanda',
      bg: 'Финландия',
      de: 'Finnland',
      fr: 'Finlande',
      nl: 'Finland',
      it: 'Finlandia',
      cn: '芬兰',
      zh: '芬蘭',
      et: 'Soome',
      ja: 'フィンランド',
      he: 'פינלנד',
      el: 'Φινλανδία',
      kk: 'Финляндия',
      ka: 'ფინეთი',
      th: 'ฟินแลนด์',
    },
    phoneLength: 10,
    dialCode: '+358',
    code: 'FI',
    flag: '🇫🇮',
  },
  {
    name: {
      en: 'France',
      ru: 'Франция',
      pl: 'Francja',
      uk: 'Франція',
      cs: 'Francie',
      be: 'Францыя',
      pt: 'França',
      es: 'Francia',
      ro: 'Franţa',
      bg: 'Франция',
      de: 'Frankreich',
      fr: 'France',
      nl: 'Frankrijk',
      it: 'Francia',
      cn: '法国',
      zh: '法國',
      et: 'Prantsusmaa',
      ja: 'フランス',
      he: 'צרפת',
      el: 'Γαλλία',
      kk: 'Франция Республикасы',
      ka: 'საფრანგეთი',
      th: 'ฝรั่งเศส',
    },
    phoneLength: 9,
    dialCode: '+33',
    code: 'FR',
    flag: '🇫🇷',
  },
  {
    name: {
      en: 'French Guiana',
      ru: 'Французская Гвиана',
      pl: 'Gujana Francuska',
      uk: 'Французька Гвіана',
      cs: 'Francouzská Guyana',
      be: 'Французская Гвіяна',
      pt: 'Guiana Francesa',
      es: 'Guayana Francesa',
      ro: 'Guyana Franceză',
      bg: 'Френска Гвиана',
      de: 'Französisch-Guayana',
      fr: 'Guyane Française',
      nl: 'Frans Guyana',
      it: 'Guiana francese',
      cn: '法属圭亚那',
      zh: '法屬圭亞那',
      et: 'Prantsuse Guajaana',
      ja: 'フランス領ギアナ',
      he: 'גיאנה הצרפתית',
      el: 'Γαλλική Γουιάνα',
      kk: 'Франция Гвианасы',
      ka: 'საფრანგეთის გვიანა',
      th: 'เฟรนช์เกียนา',
    },
    phoneLength: 9,
    dialCode: '+594',
    code: 'GF',
    flag: '🇬🇫',
  },
  {
    name: {
      en: 'French Polynesia',
      ru: 'Французская Полинезия',
      pl: 'Polinezja Francuska',
      uk: 'Французька Полінезія',
      cs: 'Francouzská Polynésie',
      be: 'Французская Палінезія',
      pt: 'Polinésia Francesa',
      es: 'Polinesia Francesa',
      ro: 'Polinezia Franceză',
      bg: 'Френска полинезия',
      de: 'Französisch Polynesien',
      fr: 'Polynésie française',
      nl: 'Frans-Polynesië',
      it: 'Polinesia francese',
      cn: '法属波利尼西亚',
      zh: '法屬波利尼西亞',
      et: 'Prantsuse Polüneesia',
      ja: 'フランス領ポリネシア',
      he: 'פולינזיה הצרפתית',
      el: 'Γαλλική Πολυνησία',
      kk: 'Франция Полинезиясы',
      ka: 'ფრანგეთის პოლინეზია',
      th: 'เฟรนช์โปลินีเซีย',
    },
    phoneLength: 6,
    dialCode: '+689',
    code: 'PF',
    flag: '🇵🇫',
  },
  {
    name: {
      en: 'Gabon',
      ru: 'Габон',
      pl: 'Gabon',
      uk: 'Габон',
      cs: 'Gabon',
      be: 'Габон',
      pt: 'Gabão',
      es: 'Gabón',
      ro: 'Gabon',
      bg: 'Габон',
      de: 'Gabun',
      fr: 'Gabon',
      nl: 'Gabon',
      it: 'Gabon',
      cn: '加蓬',
      zh: '加蓬',
      et: 'Gabon',
      ja: 'ガボン',
      he: 'גאבון',
      el: 'Γκαμπόν',
      kk: 'Габон Республикасы',
      ka: 'გაბონი, რესპუბლიკა',
      th: 'กาบอง',
    },
    phoneLength: 8,
    dialCode: '+241',
    code: 'GA',
    flag: '🇬🇦',
  },
  {
    name: {
      en: 'Gambia',
      ru: 'Гамбия',
      pl: 'Gambia',
      uk: 'Гамбія',
      cs: 'Gambie',
      be: 'Гамбія',
      pt: 'Gâmbia',
      es: 'Gambia',
      ro: 'Gambia',
      bg: 'Гамбия',
      de: 'Gambia',
      fr: 'Gambie',
      nl: 'Gambia',
      it: 'Gambia',
      cn: '冈比亚',
      zh: '岡比亞',
      et: 'Gambia',
      ja: 'ガンビア',
      he: 'גמביה',
      el: 'Γκάμπια',
      kk: 'Гамбия Республикасы',
      ka: 'გამბია, რესპუბლიკა',
      th: 'แกมเบีย',
    },
    phoneLength: 8,
    dialCode: '+220',
    code: 'GM',
    flag: '🇬🇲',
  },
  {
    name: {
      en: 'Georgia',
      ru: 'Грузия',
      pl: 'Gruzja',
      uk: 'Грузія',
      cs: 'Gruzie',
      be: 'Грузія',
      pt: 'Geórgia',
      es: 'Georgia',
      ro: 'Georgia',
      bg: 'Джорджия',
      de: 'Georgia',
      fr: 'Géorgie',
      nl: 'Georgië',
      it: 'Georgia',
      cn: '乔治亚州',
      zh: '喬治亞州',
      et: 'Gruusia',
      ja: 'ジョージア',
      he: 'גאורגיה',
      el: 'Γεωργία',
      kk: 'Грузия',
      ka: 'საქართველო',
      th: 'จอร์เจีย',
    },
    phoneLength: 9,
    dialCode: '+995',
    code: 'GE',
    flag: '🇬🇪',
  },
  {
    name: {
      en: 'Germany',
      ru: 'Германия',
      pl: 'Niemcy',
      uk: 'Німеччина',
      cs: 'Německo',
      be: 'Германія',
      pt: 'Alemanha',
      es: 'Alemania',
      ro: 'Germania',
      bg: 'Германия',
      de: 'Deutschland',
      fr: 'Allemagne',
      nl: 'Duitsland',
      it: 'Germania',
      cn: '德国',
      zh: '德國',
      et: 'Saksamaa',
      ja: 'ドイツ',
      he: 'גרמניה',
      el: 'Γερμανία',
      kk: 'Германия',
      ka: 'გერმანია',
      th: 'เยอรมนี',
    },
    phoneLength: 11,
    dialCode: '+49',
    code: 'DE',
    flag: '🇩🇪',
  },
  {
    name: {
      en: 'Ghana',
      ru: 'Гана',
      pl: 'Ghana',
      uk: 'Гана',
      cs: 'Ghana',
      be: 'Гана',
      pt: 'Gana',
      es: 'Ghana',
      ro: 'Ghana',
      bg: 'Гана',
      de: 'Ghana',
      fr: 'Ghana',
      nl: 'Ghana',
      it: 'Ghana',
      cn: '加纳',
      zh: '加納',
      et: 'Ghana',
      ja: 'ガーナ',
      he: 'גאנה',
      el: 'Γκάνα',
      kk: 'Гана',
      ka: 'განა',
      th: 'กานา',
    },
    phoneLength: 9,
    dialCode: '+233',
    code: 'GH',
    flag: '🇬🇭',
  },
  {
    name: {
      en: 'Gibraltar',
      ru: 'Гибралтар',
      pl: 'Gibraltar',
      uk: 'Гібралтар',
      cs: 'Gibraltar',
      be: 'Гібралтар',
      pt: 'Gibraltar',
      es: 'Gibraltar',
      ro: 'Gibraltar',
      bg: 'Гибралтар',
      de: 'Gibraltar',
      fr: 'Gibraltar',
      nl: 'Gibraltar',
      it: 'Gibilterra',
      cn: '直布罗陀',
      zh: '直布羅陀',
      et: 'Gibraltar',
      ja: 'ジブラルタル',
      he: 'גיברלטר',
      el: 'Γιβραλτάρ',
      kk: 'Ґібралтар',
      ka: 'გიბრალტარი',
      th: 'ยิบรอลตาร์',
    },
    phoneLength: 8,
    dialCode: '+350',
    code: 'GI',
    flag: '🇬🇮',
  },
  {
    name: {
      en: 'Greece',
      ru: 'Греция',
      pl: 'Grecja',
      uk: 'Греція',
      cs: 'Řecko',
      be: 'Грэцыя',
      pt: 'Grécia',
      es: 'Grecia',
      ro: 'Grecia',
      bg: 'Гърция',
      de: 'Griechenland',
      fr: 'Grèce',
      nl: 'Griekenland',
      it: 'Grecia',
      cn: '希腊',
      zh: '希臘',
      et: 'Kreeka',
      ja: 'ギリシャ',
      he: 'יוון',
      el: 'Ελλάδα',
      kk: 'Греция',
      ka: 'საბერძნეთი',
      th: 'กรีซ',
    },
    phoneLength: 10,
    dialCode: '+30',
    code: 'GR',
    flag: '🇬🇷',
  },
  {
    name: {
      en: 'Greenland',
      ru: 'Гренландия',
      pl: 'Grenlandia',
      uk: 'Гренландія',
      cs: 'Grenlandia',
      be: 'Грэнландыя',
      pt: 'Gronelândia',
      es: 'Groenlandia',
      ro: 'Groenlanda',
      bg: 'Гренландия',
      de: 'Grönland',
      fr: 'Groenland',
      nl: 'Groenland',
      it: 'Groenlandia',
      cn: '格陵兰',
      zh: '格陵蘭',
      et: 'Gröönimaa',
      ja: 'グリーンランド',
      he: 'גרינלנד',
      el: 'Γροιλανδία',
      kk: 'Гренландия',
      ka: 'გრენლანდია',
      th: 'กรีนแลนด์',
    },
    phoneLength: 8,
    dialCode: '+299',
    code: 'GL',
    flag: '🇬🇱',
  },
  {
    name: {
      en: 'Grenada',
      ru: 'Гренада',
      pl: 'Grenada',
      uk: 'Гренада',
      cs: 'Grenada',
      be: 'Грэнада',
      pt: 'Granada',
      es: 'Granada',
      ro: 'Grenada',
      bg: 'Гренада',
      de: 'Grenada',
      fr: 'Grenade',
      nl: 'Grenada',
      it: 'Grenada',
      cn: '格林纳达',
      zh: '格林納達',
      et: 'Grenada',
      ja: 'グレナダ',
      he: 'גרנדה',
      el: 'Γρενάδα',
      kk: 'Гренада',
      ka: 'გრენადა',
      th: 'เกรเนดา',
    },
    phoneLength: 7,
    dialCode: '+1473',
    code: 'GD',
    flag: '🇬🇩',
  },
  {
    name: {
      en: 'Guadeloupe',
      ru: 'Гваделупа',
      pl: 'Gwadelupa',
      uk: 'Гваделупа',
      cs: 'Guadeloupe',
      be: 'Гвадэлупа',
      pt: 'Guadalupe',
      es: 'Guadalupe',
      ro: 'Guadelupa',
      bg: 'Гваделупа',
      de: 'Guadeloupe',
      fr: 'Guadeloupe',
      nl: 'Guadeloupe',
      it: 'Guadalupa',
      cn: '瓜德罗普岛',
      zh: '瓜德羅普島',
      et: 'Guadeloupe',
      ja: 'グアドループ',
      he: 'גוואדלופ',
      el: 'Γουαδελούπη',
      kk: 'Гваделупа',
      ka: 'გვადელუპა',
      th: 'กัวเดอลูป',
    },
    phoneLength: 9,
    dialCode: '+590',
    code: 'GP',
    flag: '🇬🇵',
  },
  {
    name: {
      en: 'Guam',
      ru: 'Гуам',
      pl: 'Guam',
      uk: 'Гуам',
      cs: 'Guam',
      be: 'Гуам',
      pt: 'Guame',
      es: 'Guam',
      ro: 'Guam',
      bg: 'Гуам',
      de: 'Guam',
      fr: 'Guam',
      nl: 'Guam',
      it: 'Guam',
      cn: '关岛',
      zh: '關島',
      et: 'Guam',
      ja: 'グアム',
      he: 'גואם',
      el: 'Γκουάμ',
      kk: 'Гуам',
      ka: 'გუამი',
      th: 'กวม',
    },
    phoneLength: 7,
    dialCode: '+1671',
    code: 'GU',
    flag: '🇬🇺',
  },
  {
    name: {
      en: 'Guatemala',
      ru: 'Гватемала',
      pl: 'Gwatemala',
      uk: 'Гватемала',
      cs: 'Guatemala',
      be: 'Гватэмала',
      pt: 'Guatemala',
      es: 'Guatemala',
      ro: 'Guatemala',
      bg: 'Гватемала',
      de: 'Guatemala',
      fr: 'Guatemala',
      nl: 'Guatemala',
      it: 'Guatemala',
      cn: '危地马拉',
      zh: '危地馬拉',
      et: 'Guatemala',
      ja: 'グアテマラ',
      he: 'גואטמלה',
      el: 'Γουατεμάλα',
      kk: 'Гватемала',
      ka: 'გვატემალა',
      th: 'กัวเตมาลา',
    },
    phoneLength: 8,
    dialCode: '+502',
    code: 'GT',
    flag: '🇬🇹',
  },
  {
    name: {
      en: 'Guernsey',
      ru: 'Гернси',
      pl: 'Guernsey',
      uk: 'Гернсі',
      cs: 'Guernsey',
      be: 'Гернсі',
      pt: 'Guernsey',
      es: 'Guernsey',
      ro: 'Guernsey',
      bg: 'Гернси',
      de: 'Guernsey',
      fr: 'Guernesey',
      nl: 'Guernsey',
      it: 'Guernsey',
      cn: '根西岛',
      zh: '根西島',
      et: 'Guernsey',
      ja: 'ガーンジー',
      he: 'גרנזי',
      el: 'Γκέρνσεϊ',
      kk: 'Гернси',
      ka: 'გერნსი',
      th: 'เกิร์นซีย์',
    },
    phoneLength: 6,
    dialCode: '+44',
    code: 'GG',
    flag: '🇬🇬',
  },
  {
    name: {
      en: 'Guinea',
      ru: 'Гвинея',
      pl: 'Gwinea',
      uk: 'Гвінея',
      cs: 'Guinea',
      be: 'Гвінея',
      pt: 'Guiné',
      es: 'Guinea',
      ro: 'Guineea',
      bg: 'Гвинея',
      de: 'Guinea',
      fr: 'Guinée',
      nl: 'Guinea',
      it: 'Guinea',
      cn: '几内亚',
      zh: '幾內亞',
      et: 'Guinea',
      ja: 'ギニア',
      he: 'גינאה',
      el: 'Γουινέα',
      kk: 'Гвинея',
      ka: 'გვინეა',
      th: 'กินี',
    },
    phoneLength: 8,
    dialCode: '+224',
    code: 'GN',
    flag: '🇬🇳',
  },
  {
    name: {
      en: 'Guinea-Bissau',
      ru: 'Гвинея-Бисау',
      pl: 'Gwinea Bissau',
      uk: 'Гвінея-Бісау',
      cs: 'Guinea-Bissau',
      be: 'Гвінея-Бісаў',
      pt: 'Guiné-Bissau',
      es: 'Guinea-Bissau',
      ro: 'Guineea-Bissau',
      bg: 'Гвинея-Бисау',
      de: 'Guinea-Bissau',
      fr: 'Guinée-Bissau',
      nl: 'Guinee-Bissau',
      it: 'Guinea-Bissau',
      cn: '几内亚比绍',
      zh: '幾內亞比紹',
      et: 'Guinea-Bissau',
      ja: 'ギニアビサウ',
      he: 'גינאה-ביסאו',
      el: 'Γουινέα-Μπισσάου',
      kk: 'Гвинея-Бисау',
      ka: 'გვინეა-ბისაუ',
      th: 'กินี-บิสเซา',
    },
    phoneLength: 9,
    dialCode: '+245',
    code: 'GW',
    flag: '🇬🇼',
  },
  {
    name: {
      en: 'Guyana',
      ru: 'Гайана',
      pl: 'Gujana',
      uk: 'Гайана',
      cs: 'Guyana',
      be: 'Гаяна',
      pt: 'Guiana',
      es: 'Guyana',
      ro: 'Guyana',
      bg: 'Гвиана',
      de: 'Guyana',
      fr: 'Guyane',
      nl: 'Guyana',
      it: 'Guyana',
      cn: '圭亚那',
      zh: '圭亞那',
      et: 'Guajaana',
      ja: 'ガイアナ',
      he: 'גיאנה',
      el: 'Γουιάνα',
      kk: 'Гайана',
      ka: 'გაიანა',
      th: 'กายอานา',
    },
    phoneLength: 7,
    dialCode: '+592',
    code: 'GY',
    flag: '🇬🇾',
  },
  {
    name: {
      en: 'Haiti',
      ru: 'Гаити',
      pl: 'Haiti',
      uk: 'Гаїті',
      cs: 'Haiti',
      be: 'Гаіці',
      pt: 'Haiti',
      es: 'Haití',
      ro: 'Haiti',
      bg: 'Хаити',
      de: 'Haiti',
      fr: 'Haïti',
      nl: 'Haïti',
      it: 'Haiti',
      cn: '海地',
      zh: '海地',
      et: 'Haiti',
      ja: 'ハイチ',
      he: 'האיטי',
      el: 'Αϊτή',
      kk: 'Гаити',
      ka: 'ჰაიტი',
      th: 'เฮติ',
    },
    phoneLength: 8,
    dialCode: '+509',
    code: 'HT',
    flag: '🇭🇹',
  },
  {
    name: {
      en: 'Holy See (Vatican City State)',
      ru: 'Святой Престол (Vatican City State)',
      pl: 'Stolica Apostolska (Państwo Watykańskie)',
      uk: 'Святий Престол (Ватикан)',
      cs: 'Svatý stolec (Vatikánský městský stát)',
      be: 'Святы Пасад (дзяржава Ватыкан)',
      pt: 'Vaticano',
      es: 'Santa Sede (Estado de la Ciudad del Vaticano)',
      ro: 'Sfântul Scaun (Statul Vatican)',
      bg: 'Свети престол (Ватикан)',
      de: 'Heiliger Stuhl (Staat der Vatikanstadt)',
      fr: 'Saint-Siège (État de la Cité du Vatican)',
      nl: 'Heilige Stoel (Vaticaanstad)',
      it: 'Santa Sede (Stato della Città del Vaticano)',
      cn: '罗马教廷（梵蒂冈城国）',
      zh: '羅馬教廷（梵蒂岡城國）',
      et: 'Püha Tool (Vatikani linnriik)',
      ja: 'ホーリーシー（バチカン市国）',
      he: 'הכס הקדוש (מדינת הוותיקן)',
      el: 'Βατικανό',
      kk: 'Жарлык Ел Ватикан',
      ka: 'წმინდა საყდარი (ქალაქი)',
      th: 'สาธารณรัฐวาติกัน',
    },
    phoneLength: 10,
    dialCode: '+379',
    code: 'VA',
    flag: '🇻🇦',
  },
  {
    name: {
      en: 'Honduras',
      ru: 'Гондурас',
      pl: 'Honduras',
      uk: 'Гондурас',
      cs: 'Honduras',
      be: 'Гандурас',
      pt: 'Honduras',
      es: 'Honduras',
      ro: 'Honduras',
      bg: 'Хондурас',
      de: 'Honduras',
      fr: 'Honduras',
      nl: 'Honduras',
      it: 'Honduras',
      cn: '洪都拉斯',
      zh: '洪都拉斯',
      et: 'Honduras',
      ja: 'ホンジュラス',
      he: 'הונדורס',
      el: 'Ονδούρα',
      kk: 'Гондурас',
      ka: 'ჰონდურასი',
      th: 'ฮอนดูรัส',
    },
    phoneLength: 8,
    dialCode: '+504',
    code: 'HN',
    flag: '🇭🇳',
  },
  {
    name: {
      en: 'Hong Kong',
      ru: 'Гонконг',
      pl: 'Hongkong',
      uk: 'Гонконг',
      cs: 'Hongkong',
      be: 'Ганконг',
      pt: 'Hong Kong',
      es: 'Hong Kong',
      ro: 'Hong Kong',
      bg: 'Хонг Конг',
      de: 'Hongkong',
      fr: 'Hong Kong',
      nl: 'Hong Kong',
      it: 'Hong Kong',
      cn: '香港',
      zh: '香港',
      et: 'Hongkong',
      ja: '香港',
      he: 'הונג קונג',
      el: 'Χονγκ Κονγκ',
      kk: 'Гонконг',
      ka: 'ჰონგ კონგი',
      th: 'ฮ่องกง',
    },
    phoneLength: 8,
    dialCode: '+852',
    code: 'HK',
    flag: '🇭🇰',
  },
  {
    name: {
      en: 'Hungary',
      ru: 'Венгрия',
      pl: 'Węgry',
      uk: 'Угорщина',
      cs: 'Maďarsko',
      be: 'Венгрыя',
      pt: 'Hungria',
      es: 'Hungría',
      ro: 'Ungaria',
      bg: 'Унгария',
      de: 'Ungarn',
      fr: 'Hongrie',
      nl: 'Hongarije',
      it: 'Ungheria',
      cn: '匈牙利',
      zh: '匈牙利',
      et: 'Ungari',
      ja: 'ハンガリー',
      he: 'הונגריה',
      el: 'Ουγγαρία',
      kk: 'Венгрия',
      ka: 'უნგრეთი',
      th: 'ฮังการี',
    },
    phoneLength: 9,
    dialCode: '+36',
    code: 'HU',
    flag: '🇭🇺',
  },
  {
    name: {
      en: 'Iceland',
      ru: 'Исландия',
      pl: 'Islandia',
      uk: 'Ісландія',
      cs: 'Island',
      be: 'Ісландыя',
      pt: 'Islândia',
      es: 'Islandia',
      ro: 'Islanda',
      bg: 'Исландия',
      de: 'Island',
      fr: 'Islande',
      nl: 'IJsland',
      it: 'Islanda',
      cn: '冰岛',
      zh: '冰島',
      et: 'Island',
      ja: 'アイスランド',
      he: 'איסלנד',
      el: 'Ισλανδία',
      kk: 'Исландия',
      ka: 'ისლანდია',
      th: 'ไอซ์แลนด์',
    },
    phoneLength: 7,
    dialCode: '+354',
    code: 'IS',
    flag: '🇮🇸',
  },
  {
    name: {
      en: 'India',
      ru: 'Индия',
      pl: 'Indie',
      uk: 'Індія',
      cs: 'Indie',
      be: 'Індыя',
      pt: 'Índia',
      es: 'India',
      ro: 'India',
      bg: 'Индия',
      de: 'Indien',
      fr: 'Inde',
      nl: 'India',
      it: 'India',
      cn: '印度',
      zh: '印度',
      et: 'India',
      ja: 'インド',
      he: 'הוֹדוּ',
      el: 'Ινδία',
      kk: 'Үндістан',
      ka: 'ინდოეთი',
      th: 'อินเดีย',
    },
    phoneLength: 10,
    dialCode: '+91',
    code: 'IN',
    flag: '🇮🇳',
  },
  {
    name: {
      en: 'Indonesia',
      ru: 'Индонезия',
      pl: 'Indonezja',
      uk: 'Індонезія',
      cs: 'Indonésie',
      be: 'Інданезія',
      pt: 'Indonésia',
      es: 'Indonesia',
      ro: 'Indonezia',
      bg: 'Индонезия',
      de: 'Indonesien',
      fr: 'Indonésie',
      nl: 'Indonesië',
      it: 'Indonesia',
      cn: '印度尼西亚',
      zh: '印度尼西亞',
      et: 'Indoneesia',
      ja: 'インドネシア',
      he: 'אינדונזיה',
      el: 'Ινδονησία',
      kk: 'Индонезия',
      ka: 'ინდონეზია',
      th: 'อินโดนีเซีย',
    },
    phoneLength: 10,
    dialCode: '+62',
    code: 'ID',
    flag: '🇮🇩',
  },
  {
    name: {
      en: 'Iran, Islamic Republic',
      ru: 'Иран, Исламская Республика',
      pl: 'Iran, Republika Islamska',
      uk: 'Іран, Ісламська Республіка',
      cs: 'Írán, Islámská Republika',
      be: 'Іран, Ісламская Рэспубліка',
      pt: 'Irão',
      es: 'Irán, República Islámica',
      ro: 'Iran, Republica Islamica',
      bg: 'Иран, Ислямска република',
      de: 'Iran, Islamische Republik',
      fr: 'Iran, République islamique',
      nl: 'Iran, Islamitische Republiek',
      it: 'Iran, Repubblica Islamica',
      cn: '伊朗伊斯兰共和国',
      zh: '伊朗伊斯蘭共和國',
      et: 'Iraan, Iraagi Islamivabariik',
      ja: 'イラン、イスラム共和国',
      he: 'איראן',
      el: 'Ιράν',
      kk: 'Иран Республикасы',
      ka: 'ირანის ისლამის რესპუბლიკა',
      th: 'อิหร่าน',
    },
    phoneLength: 10,
    dialCode: '+98',
    code: 'IR',
    flag: '🇮🇷',
  },
  {
    name: {
      en: 'Iraq',
      ru: 'Ирак',
      pl: 'Irak',
      uk: 'Ірак',
      cs: 'Irák',
      be: 'Ірак',
      pt: 'Iraque',
      es: 'Irak',
      ro: 'Irak',
      bg: 'Ирак',
      de: 'Irak',
      fr: 'Irak',
      nl: 'Irak',
      it: 'Iraq',
      cn: '伊拉克',
      zh: '伊拉克',
      et: 'Iraak',
      ja: 'イラク',
      he: 'עיראק',
      el: 'Ιράκ',
      kk: 'Ирак',
      ka: 'ერაყი',
      th: 'อิรัก',
    },
    phoneLength: 10,
    dialCode: '+964',
    code: 'IQ',
    flag: '🇮🇶',
  },
  {
    name: {
      en: 'Ireland',
      ru: 'Ирландия',
      pl: 'Irlandia',
      uk: 'Ірландія',
      cs: 'Irsko',
      be: 'Ірландыя',
      pt: 'Irlanda',
      es: 'Irlanda',
      ro: 'Irlanda',
      bg: 'Ирландия',
      de: 'Irland',
      fr: 'Irlande',
      nl: 'Ierland',
      it: 'Irlanda',
      cn: '爱尔兰',
      zh: '愛爾蘭',
      et: 'Iirimaa',
      ja: 'アイルランド',
      he: 'אירלנד',
      el: 'Ιρλανδία',
      kk: 'Ирландия',
      ka: 'ირლანდია',
      th: 'ไอร์แลนด์',
    },
    phoneLength: 9,
    dialCode: '+353',
    code: 'IE',
    flag: '🇮🇪',
  },
  {
    name: {
      en: 'Isle of Man',
      ru: 'Остров Мэн',
      pl: 'Wyspa Man',
      uk: 'Острів Мен',
      cs: 'Isle of Man',
      be: 'Востраў Мэн',
      pt: 'Ilha de Man',
      es: 'Isla de Man',
      ro: 'insula Barbatului',
      bg: 'Остров Ман',
      de: 'Isle of Man',
      fr: 'île de Man',
      nl: 'Isle of Man',
      it: 'Isola di Man',
      cn: '马恩岛',
      zh: '馬恩島',
      et: 'Mani saar',
      ja: 'マン島',
      he: 'האי מאן',
      el: 'Νήσος Μαν',
      kk: 'Мэн аралы',
      ka: 'მენის კუნძული',
      th: 'เกาะแมน',
    },
    phoneLength: 8,
    dialCode: '+44',
    code: 'IM',
    flag: '🇮🇲',
  },
  {
    name: {
      en: 'Israel',
      ru: 'Израиль',
      pl: 'Izrael',
      uk: 'Ізраїль',
      cs: 'Izrael',
      be: 'Ізраіль',
      pt: 'Israel',
      es: 'Israel',
      ro: 'Israel',
      bg: 'Израел',
      de: 'Israel',
      fr: 'Israël',
      nl: 'Israël',
      it: 'Israele',
      cn: '以色列',
      zh: '以色列',
      et: 'Iisrael',
      ja: 'イスラエル',
      he: 'ישראל',
      el: 'Ισραήλ',
      kk: 'Израиль',
      ka: 'ისრაელი',
      th: 'อิสราเอล',
    },
    phoneLength: 9,
    dialCode: '+972',
    code: 'IL',
    flag: '🇮🇱',
  },
  {
    name: {
      en: 'Italy',
      ru: 'Италия',
      pl: 'Włochy',
      uk: 'Італія',
      cs: 'Itálie',
      be: 'Італія',
      pt: 'Itália',
      es: 'Italia',
      ro: 'Italia',
      bg: 'Италия',
      de: 'Italien',
      fr: 'Italie',
      nl: 'Italië',
      it: 'Italia',
      cn: '意大利',
      zh: '意大利',
      et: 'Itaalia',
      ja: 'イタリア',
      he: 'איטליה',
      el: 'Ιταλία',
      kk: 'Италия',
      ka: 'იტალია',
      th: 'อิตาลี',
    },
    phoneLength: 10,
    dialCode: '+39',
    code: 'IT',
    flag: '🇮🇹',
  },
  {
    name: {
      en: 'Jamaica',
      ru: 'Ямайка',
      pl: 'Jamajka',
      uk: 'Ямайка',
      cs: 'Jamaica',
      be: 'Ямайка',
      pt: 'Jamaica',
      es: 'Jamaica',
      ro: 'Jamaica',
      bg: 'Ямайка',
      de: 'Jamaika',
      fr: 'Jamaïque',
      nl: 'Jamaica',
      it: 'Giamaica',
      cn: '的牙买加',
      zh: '的牙買加',
      et: 'Jamaica',
      ja: 'ジャマイカ',
      he: "ג'מייקה",
      el: 'Τζαμάικα',
      kk: 'Жамайка',
      ka: 'იამაიკა',
      th: 'จาเมกา',
    },
    phoneLength: 7,
    dialCode: '+1876',
    code: 'JM',
    flag: '🇯🇲',
  },
  {
    name: {
      en: 'Japan',
      ru: 'Япония',
      pl: 'Japonia',
      uk: 'Японія',
      cs: 'Japonsko',
      be: 'Японія',
      pt: 'Japão',
      es: 'Japón',
      ro: 'Japonia',
      bg: 'Япония',
      de: 'Japan',
      fr: 'Japon',
      nl: 'Japan',
      it: 'Giappone',
      cn: '日本',
      zh: '日本',
      et: 'Jaapan',
      ja: '日本',
      he: 'יפן',
      el: 'Ιαπωνία',
      kk: 'Жапония',
      ka: 'იაპონია',
      th: 'ญี่ปุ่น',
    },
    phoneLength: 10,
    dialCode: '+81',
    code: 'JP',
    flag: '🇯🇵',
  },
  {
    name: {
      en: 'Jersey',
      ru: 'Джерси',
      pl: 'Jersey',
      uk: 'Джерсі',
      cs: 'Trikot',
      be: 'Джэрсі',
      pt: 'Jersey',
      es: 'Jersey',
      ro: 'Jersey',
      bg: 'Джърси',
      de: 'Jersey',
      fr: 'Jersey',
      nl: 'Jersey',
      it: 'Jersey',
      cn: '球衣',
      zh: '球衣',
      et: 'Jersey',
      ja: 'ジャージー',
      he: "ג'רזי",
      el: 'Τζέρσεϊ',
      kk: 'Джерси',
      ka: 'ჯერსი',
      th: 'เจอร์ซีย์',
    },
    phoneLength: 6,
    dialCode: '+44',
    code: 'JE',
    flag: '🇯🇪',
  },
  {
    name: {
      en: 'Jordan',
      ru: 'Иордания',
      pl: 'Jordania',
      uk: 'Йорданія',
      cs: 'Jordán',
      be: 'Іарданія',
      pt: 'Jordânia',
      es: 'Jordania',
      ro: 'Iordania',
      bg: 'Йордания',
      de: 'Jordanien',
      fr: 'Jordan',
      nl: 'Jordanië',
      it: 'Giordania',
      cn: '约旦',
      zh: '約旦',
      et: 'Jordaania',
      ja: 'ヨルダン',
      he: 'ירדן',
      el: 'Ιορδανία',
      kk: 'Йордания',
      ka: 'იორდანია',
      th: 'จอร์แดน',
    },
    phoneLength: 9,
    dialCode: '+962',
    code: 'JO',
    flag: '🇯🇴',
  },
  {
    name: {
      en: 'Kazakhstan',
      ru: 'Казахстан',
      pl: 'Kazachstan',
      uk: 'Казахстан',
      cs: 'Kazachstán',
      be: 'Казахстан',
      pt: 'Cazaquistão',
      es: 'Kazajstán',
      ro: 'Kazahstan',
      bg: 'Казахстан',
      de: 'Kasachstan',
      fr: 'Kazakhstan',
      nl: 'Kazachstan',
      it: 'Kazakistan',
      cn: '哈萨克斯坦',
      zh: '哈薩克斯坦',
      et: 'Kasahstan',
      ja: 'カザフスタン',
      he: 'קזחסטן',
      el: 'Καζακστάν',
      kk: 'Қазақстан',
      ka: 'ყაზახეთი',
      th: 'คาซัคสถาน',
    },
    phoneLength: 10,
    dialCode: '+7',
    code: 'KZ',
    flag: '🇰🇿',
  },
  {
    name: {
      en: 'Kenya',
      ru: 'Кения',
      pl: 'Kenia',
      uk: 'Кенія',
      cs: 'Keňa',
      be: 'Кенія',
      pt: 'Quénia',
      es: 'Kenia',
      ro: 'Kenya',
      bg: 'Кения',
      de: 'Kenia',
      fr: 'Kenya',
      nl: 'Kenia',
      it: 'Kenya',
      cn: '肯尼亚',
      zh: '肯尼亞',
      et: 'Keenia',
      ja: 'ケニア',
      he: 'קניה',
      el: 'Κένυα',
      kk: 'Кения',
      ka: 'კენია',
      th: 'เคนยา',
    },
    phoneLength: 9,
    dialCode: '+254',
    code: 'KE',
    flag: '🇰🇪',
  },
  {
    name: {
      en: 'Kiribati',
      ru: 'Кирибати',
      pl: 'Kiribati',
      uk: 'Kiribati',
      cs: 'Kiribati',
      be: 'Кірыбаці',
      pt: 'Quiribáti',
      es: 'Kiribati',
      ro: 'Kiribati',
      bg: 'Кирибати',
      de: 'Kiribati',
      fr: 'Kiribati',
      nl: 'Kiribati',
      it: 'Kiribati',
      cn: '基里巴斯',
      zh: '基里巴斯',
      et: 'Kiribati',
      ja: 'キリバス',
      he: 'קיריבטי',
      el: 'Κιριμπάτι',
      kk: 'Кирибати',
      ka: 'კირიბატი',
      th: 'คิริบาส',
    },
    phoneLength: 8,
    dialCode: '+686',
    code: 'KI',
    flag: '🇰🇮',
  },
  {
    name: {
      en: 'Korea, Republic',
      ru: 'Республика Корея',
      pl: 'Republika Korei',
      uk: 'Корея, Республіка',
      cs: 'Korea, republika',
      be: 'Карэя, Рэспубліка',
      pt: 'Coreia do Sul',
      es: 'Corea, República de',
      ro: 'Republica Coreea',
      bg: 'Република Корея',
      de: 'Korea, Republik von',
      fr: 'Corée, République de',
      nl: 'Korea, republiek van',
      it: 'Corea, Repubblica di',
      cn: '韩国',
      zh: '韓國',
      et: 'Korea Vabariik',
      ja: '大韓民国',
      he: 'קוריאה הדרומית',
      el: 'Νότια Κορέα',
      kk: 'Көрея Республикасы',
      ka: 'სამხრეთ კორეა',
      th: 'เกาหลีใต้',
    },
    phoneLength: 9,
    dialCode: '+82',
    code: 'KR',
    flag: '🇰🇷',
  },
  {
    name: {
      en: 'Kuwait',
      ru: 'Кувейт',
      pl: 'Kuwejt',
      uk: 'Кувейт',
      cs: 'Kuvajt',
      be: 'Кувейт',
      pt: 'Kuwait',
      es: 'Kuwait',
      ro: 'Kuweit',
      bg: 'Кувейт',
      de: 'Kuwait',
      fr: 'Koweit',
      nl: 'Koeweit',
      it: 'Kuwait',
      cn: '科威特',
      zh: '科威特',
      et: 'Kuveit',
      ja: 'クウェート',
      he: 'כווית',
      el: 'Κουβέιτ',
      kk: 'Кувейт',
      ka: 'ქუვეითი',
      th: 'คูเวต',
    },
    phoneLength: 8,
    dialCode: '+965',
    code: 'KW',
    flag: '🇰🇼',
  },
  {
    name: {
      en: 'Kyrgyzstan',
      ru: 'Kyrgyzstan',
      pl: 'Kirgistan',
      uk: 'Киргизстан',
      cs: 'Kyrgyzstán',
      be: 'Кыргызстан',
      pt: 'Quirguizistão',
      es: 'Kirguistán',
      ro: 'Kârgâzstan',
      bg: 'Киргизстан',
      de: 'Kirgisistan',
      fr: 'Kirghizistan',
      nl: 'Kirgizië',
      it: 'Kirghizistan',
      cn: '吉尔吉斯斯坦',
      zh: '吉爾吉斯斯坦',
      et: 'Kõrgõzstan',
      ja: 'キルギスタン',
      he: 'קירגיזסטן',
      el: 'Κιργιζία',
      kk: 'Кыргызстан',
      ka: 'ყირგიზეთი',
      th: 'คีร์กีซสถาน',
    },
    phoneLength: 9,
    dialCode: '+996',
    code: 'KG',
    flag: '🇰🇬',
  },
  {
    name: {
      en: "Lao People's Democratic Republic",
      ru: 'Лаосская Народно-Демократическая Республика',
      pl: 'Laotańska Republika Ludowo-Demokratyczna',
      uk: 'Лаоська Народно-Демократична Республіка',
      cs: 'Laoská lidově demokratická republika',
      be: 'Лаоская Народна-Дэмакратычная Рэспубліка',
      pt: 'Laos',
      es: 'República Democrática Popular de Laos',
      ro: 'Republica Populară Democrată Laos',
      bg: 'Лаосска народнодемократична република',
      de: 'Demokratische Volksrepublik Laos',
      fr: 'République démocratique populaire lao',
      nl: 'Lao Democratische Volksrepubliek',
      it: 'Repubblica Democratica Popolare del Laos',
      cn: '老挝人民民主共和国',
      zh: '老撾人民民主共和國',
      et: 'Laose Demokraatlik Rahvavabariik',
      ja: 'ラオス人民民主共和国',
      he: 'הרפובליקה הדמוקרטית העממית של לאו',
      el: 'Λάος',
      kk: 'Лаос',
      ka: 'ლაოსი',
      th: 'ประเทศลาว',
    },
    phoneLength: 8,
    dialCode: '+856',
    code: 'LA',
    flag: '🇱🇦',
  },
  {
    name: {
      en: 'Latvia',
      ru: 'Латвия',
      pl: 'Łotwa',
      uk: 'Латвія',
      cs: 'Lotyšsko',
      be: 'Латвія',
      pt: 'Letónia',
      es: 'Letonia',
      ro: 'Letonia',
      bg: 'Латвия',
      de: 'Lettland',
      fr: 'Lettonie',
      nl: 'Letland',
      it: 'Lettonia',
      cn: '拉脱维亚',
      zh: '拉脫維亞',
      et: 'Läti',
      ja: 'ラトビア',
      he: 'לטביה',
      el: 'Λετονία',
      kk: 'Latviya',
      ka: 'ლატვია',
      th: 'ประเทศลัตเวีย',
    },
    phoneLength: 8,
    dialCode: '+371',
    code: 'LV',
    flag: '🇱🇻',
  },
  {
    name: {
      en: 'Lebanon',
      ru: 'Ливан',
      pl: 'Liban',
      uk: 'Ліван',
      cs: 'Libanon',
      be: 'Ліван',
      pt: 'Líbano',
      es: 'Líbano',
      ro: 'Liban',
      bg: 'Ливан',
      de: 'Libanon',
      fr: 'Liban',
      nl: 'Libanon',
      it: 'Libano',
      cn: '黎巴嫩的',
      zh: '黎巴嫩的',
      et: 'Liibanon',
      ja: 'レバノン',
      he: 'לבנון',
      el: 'Λίβανος',
      kk: 'Ливан',
      ka: 'ლიბანი',
      th: 'เลบานอน',
    },
    phoneLength: 8,
    dialCode: '+961',
    code: 'LB',
    flag: '🇱🇧',
  },
  {
    name: {
      en: 'Lesotho',
      ru: 'Лесото',
      pl: 'Lesoto',
      uk: 'Лесото',
      cs: 'Lesotho',
      be: 'Лесота',
      pt: 'Lesoto',
      es: 'Lesotho',
      ro: 'Lesotho',
      bg: 'Лесото',
      de: 'Lesotho',
      fr: 'Lesotho',
      nl: 'Lesotho',
      it: 'Lesotho',
      cn: '莱索托',
      zh: '萊索托',
      et: 'Lesotho',
      ja: 'レソト',
      he: 'לסוטו',
      el: 'Λεσότο',
      kk: 'Лесото',
      ka: 'ლესოთო',
      th: 'เลโซโท',
    },
    phoneLength: 8,
    dialCode: '+266',
    code: 'LS',
    flag: '🇱🇸',
  },
  {
    name: {
      en: 'Liberia',
      ru: 'Либерия',
      pl: 'Liberia',
      uk: 'Ліберія',
      cs: 'Libérie',
      be: 'Ліберыя',
      pt: 'Libéria',
      es: 'Liberia',
      ro: 'Liberia',
      bg: 'Либерия',
      de: 'Liberia',
      fr: 'Libéria',
      nl: 'Liberia',
      it: 'Liberia',
      cn: '利比里亚',
      zh: '利比里亞',
      et: 'Libeeria',
      ja: 'リベリア',
      he: 'ליבריה',
      el: 'Λιβερία',
      kk: 'Либерия',
      ka: 'ლიბერია',
      th: 'ประเทศไลบีเรีย',
    },
    phoneLength: 8,
    dialCode: '+231',
    code: 'LR',
    flag: '🇱🇷',
  },
  {
    name: {
      en: 'Libya',
      ru: 'Ливия',
      pl: 'Libia',
      uk: 'Лівія',
      cs: 'Libye',
      be: 'Лівія',
      pt: 'Líbia',
      es: 'Libia',
      ro: 'Libia',
      bg: 'Либия',
      de: 'Libyen',
      fr: 'Libye',
      nl: 'Libië',
      it: 'Libia',
      cn: '利比亚',
      zh: '利比亚',
      et: 'Liibüa',
      ja: 'リビア',
      he: 'לוב',
      el: 'Λιβύη',
      kk: 'Ливия',
      ka: 'ლიბია',
      th: 'ประเทศลิเบีย',
    },
    phoneLength: 8,
    dialCode: '+218',
    code: 'LY',
    flag: '🇱🇾',
  },
  {
    name: {
      en: 'Liechtenstein',
      ru: 'Лихтенштейн',
      pl: 'Liechtenstein',
      uk: 'Ліхтенштейн',
      cs: 'Lichtenštejnsko',
      be: 'Ліхтэнштэйн',
      pt: 'Listenstaine',
      es: 'Liechtenstein',
      ro: 'Liechtenstein',
      bg: 'Лихтенщайн',
      de: 'Liechtenstein',
      fr: 'Liechtenstein',
      nl: 'Liechtenstein',
      it: 'Liechtenstein',
      cn: '列支敦士登',
      zh: '列支敦士登',
      et: 'Liechtenstein',
      ja: 'リヒテンシュタイン',
      he: 'ליכטנשטיין',
      el: 'Λίχτενσταϊν',
      kk: 'Лихтенштейн',
      ka: 'ლიხტენშტაინი',
      th: 'ประเทศลิกเตนสไตน์',
    },
    phoneLength: 8,
    dialCode: '+423',
    code: 'LI',
    flag: '🇱🇮',
  },
  {
    name: {
      en: 'Lithuania',
      ru: 'Литва',
      pl: 'Litwa',
      uk: 'Литва',
      cs: 'Litva',
      be: 'Літва',
      pt: 'Lituânia',
      es: 'Lituania',
      ro: 'Lituania',
      bg: 'Литва',
      de: 'Litauen',
      fr: 'Lituanie',
      nl: 'Litouwen',
      it: 'Lituania',
      cn: '立陶宛',
      zh: '立陶宛',
      et: 'Leedu',
      ja: 'リトアニア',
      he: 'ליטא',
      el: 'Λιθουανία',
      kk: 'Литва',
      ka: 'ლიტვა',
      th: 'ประเทศลิทัวเนีย',
    },
    phoneLength: 8,
    dialCode: '+370',
    code: 'LT',
    flag: '🇱🇹',
  },
  {
    name: {
      en: 'Luxembourg',
      ru: 'Люксембург',
      pl: 'Luksemburg',
      uk: 'Люксембург',
      cs: 'Lucembursko',
      be: 'Люксембург',
      pt: 'Luxemburgo',
      es: 'Luxemburgo',
      ro: 'Luxemburg',
      bg: 'Люксембург',
      de: 'Luxemburg',
      fr: 'Luxembourg',
      nl: 'Luxemburg',
      it: 'Lussemburgo',
      cn: '卢森堡',
      zh: '盧森堡',
      et: 'Luksemburg',
      ja: 'ルクセンブルク',
      he: 'לוקסמבורג',
      el: 'Λουξεμβούργο',
      kk: 'Люксембург',
      ka: 'ლუქსემბურგი',
      th: 'ประเทศลักเซมเบิร์ก',
    },
    phoneLength: 8,
    dialCode: '+352',
    code: 'LU',
    flag: '🇱🇺',
  },
  {
    name: {
      en: 'Macao',
      ru: 'Макао',
      pl: 'Makao',
      uk: 'Макао',
      cs: 'Macao',
      be: 'Макао',
      pt: 'Macau',
      es: 'Macao',
      ro: 'Macao',
      bg: 'Макао',
      de: 'Macao',
      fr: 'Macao',
      nl: 'Macao',
      it: 'Macao',
      cn: '澳门',
      zh: '澳門',
      et: 'Aomen',
      ja: 'マカオ',
      he: 'מקאו',
      el: 'Μακάου',
      kk: 'Макао',
      ka: 'მაკაო',
      th: 'ประเทศมาเก๊า',
    },
    phoneLength: 8,
    dialCode: '+853',
    code: 'MO',
    flag: '🇲🇴',
  },
  {
    name: {
      en: 'North Macedonia',
      ru: 'Северная Македония',
      pl: 'Macedonia Północna',
      uk: 'Північна Македонія',
      cs: 'Severní Makedonie',
      be: 'Паўночная Македонія',
      pt: 'Macedônia do Norte',
      es: 'Macedonia del Norte',
      ro: 'Macedonia de Nord',
      bg: 'Северна Македония',
      de: 'Nordmazedonien',
      fr: 'Macédoine du Nord',
      nl: 'Noord-Macedonië',
      it: 'Macedonia del Nord',
      cn: '北马其顿',
      zh: '北馬其頓',
      et: 'Põhja-Makedoonia',
      ja: '北マケドニア',
      he: 'צפון מקדוניה',
      el: 'Βόρεια Μακεδονία',
      kk: 'Түндүк Македония',
      ka: 'ჩრდილოეთ მაკედონია',
      th: 'ประเทศมาซิโดเนียเหนือ',
    },
    phoneLength: 8,
    dialCode: '+389',
    code: 'MK',
    flag: '🇲🇰',
  },
  {
    name: {
      en: 'Madagascar',
      ru: 'Мадагаскар',
      pl: 'Madagaskar',
      uk: 'Мадагаскар',
      cs: 'Madagaskar',
      be: 'Мадагаскар',
      pt: 'Madagáscar',
      es: 'Madagascar',
      ro: 'Madagascar',
      bg: 'Мадагаскар',
      de: 'Madagaskar',
      fr: 'Madagascar',
      nl: 'Madagascar',
      it: 'Madagascar',
      cn: '马达加斯加',
      zh: '馬達加斯加',
      et: 'Madagaskar',
      ja: 'マダガスカル',
      he: 'מדגסקר',
      el: 'Μαδαγασκάρη',
      kk: 'Мадагаскар',
      ka: 'მადაგასკარი',
      th: 'ประเทศมาดากัสการ์',
    },
    phoneLength: 8,
    dialCode: '+261',
    code: 'MG',
    flag: '🇲🇬',
  },
  {
    name: {
      en: 'Malawi',
      ru: 'Малави',
      pl: 'Malawi',
      uk: 'Малаві',
      cs: 'Malawi',
      be: 'Малаві',
      pt: 'Malávi',
      es: 'Malawi',
      ro: 'Malawi',
      bg: 'Малави',
      de: 'Malawi',
      fr: 'Malawi',
      nl: 'Malawi',
      it: 'Malawi',
      cn: '马拉维',
      zh: '馬拉維',
      et: 'Malawi',
      ja: 'マラウイ',
      he: 'מלאווי',
      el: 'Μαλάουι',
      kk: 'Малави',
      ka: 'მალავი',
      th: 'ประเทศมาลาวี',
    },
    phoneLength: 8,
    dialCode: '+265',
    code: 'MW',
    flag: '🇲🇼',
  },
  {
    name: {
      en: 'Malaysia',
      ru: 'Малайзия',
      pl: 'Malezja',
      uk: 'Малайзія',
      cs: 'Malajsie',
      be: 'Малайзія',
      pt: 'Malásia',
      es: 'Malasia',
      ro: 'Malaezia',
      bg: 'Малайзия',
      de: 'Malaysia',
      fr: 'Malaisie',
      nl: 'Maleisië',
      it: 'Malaysia',
      cn: '马来西亚',
      zh: '馬來西亞',
      et: 'Malaisia',
      ja: 'マレーシア',
      he: 'מלזיה',
      el: 'Μαλαισία',
      kk: 'Малайзия',
      ka: 'მალაიზია',
      th: 'ประเทศมาเลเซีย',
    },
    phoneLength: 8,
    dialCode: '+60',
    code: 'MY',
    flag: '🇲🇾',
  },
  {
    name: {
      en: 'Maldives',
      ru: 'Мальдивы',
      pl: 'Malediwy',
      uk: 'Мальдіви',
      cs: 'Maledivy',
      be: 'Мальдывы',
      pt: 'Maldivas',
      es: 'Maldivas',
      ro: 'Maldive',
      bg: 'Малдивите',
      de: 'Malediven',
      fr: 'Maldives',
      nl: 'Maldiven',
      it: 'Maldive',
      cn: '马尔代夫',
      zh: '馬爾代夫',
      et: 'Maldiivid',
      ja: 'モルディブ',
      he: 'המלדיביים',
      el: 'Μαλδίβες',
      kk: 'Мальдив аралдары',
      ka: 'მალდივი',
      th: 'มัลดีฟส์',
    },
    phoneLength: 7,
    dialCode: '+960',
    code: 'MV',
    flag: '🇲🇻',
  },
  {
    name: {
      en: 'Mali',
      ru: 'Мали',
      pl: 'Mali',
      uk: 'Малі',
      cs: 'Mali',
      be: 'Малі',
      pt: 'Mali',
      es: 'Malí',
      ro: 'Mali',
      bg: 'Мали',
      de: 'Mali',
      fr: 'Mali',
      nl: 'Mali',
      it: 'Mali',
      cn: '马里',
      zh: '馬里',
      et: 'Mali',
      ja: 'マリ',
      he: 'מלי',
      el: 'Μάλι',
      kk: 'Мали',
      ka: 'მალი',
      th: 'ประเทศ Mali',
    },
    phoneLength: 8,
    dialCode: '+223',
    code: 'ML',
    flag: '🇲🇱',
  },
  {
    name: {
      en: 'Malta',
      ru: 'Мальта',
      pl: 'Malta',
      uk: 'Мальта',
      cs: 'Malta',
      be: 'Мальта',
      pt: 'Malta',
      es: 'Malta',
      ro: 'Malta',
      bg: 'Малта',
      de: 'Malta',
      fr: 'Malte',
      nl: 'Malta',
      it: 'Malta',
      cn: '马耳他',
      zh: '馬耳他',
      et: 'Malta',
      ja: 'マルタ',
      he: 'מלטה',
      el: 'Μάλτα',
      kk: 'Мальта',
      ka: 'მალტა',
      th: 'ประเทศมอลตา',
    },
    phoneLength: 8,
    dialCode: '+356',
    code: 'MT',
    flag: '🇲🇹',
  },
  {
    name: {
      en: 'Marshall Islands',
      ru: 'Маршалловы острова',
      pl: 'Wyspy Marshalla',
      uk: 'Маршаллові острови',
      cs: 'Marshallovy ostrovy',
      be: 'Маршалавы выспы',
      pt: 'Ilhas Marshall',
      es: 'Islas Marshall',
      ro: 'Insulele Marshall',
      bg: 'Маршалови острови',
      de: 'Marshallinseln',
      fr: 'Iles Marshall',
      nl: 'Marshall eilanden',
      it: 'Isole Marshall',
      cn: '马绍尔群岛',
      zh: '馬紹爾群島',
      et: 'Marshalli saared',
      ja: 'マーシャル諸島',
      he: 'איי מרשל',
      el: 'Νήσοι Μάρσαλ',
      kk: 'Маршалл аралдары',
      ka: 'მარშალის კუნძულები',
      th: 'หมู่เกาะมาร์แชลล์',
    },
    phoneLength: 7,
    dialCode: '+692',
    code: 'MH',
    flag: '🇲🇭',
  },
  {
    name: {
      en: 'Martinique',
      ru: 'Мартиника',
      pl: 'Martynika',
      uk: 'Мартініка',
      cs: 'Martinik',
      be: 'Марцініка',
      pt: 'Martinica',
      es: 'Martinica',
      ro: 'Martinica',
      bg: 'Мартиника',
      de: 'Martinique',
      fr: 'Martinique',
      nl: 'Martinique',
      it: 'Martinica',
      cn: '马提尼克岛',
      zh: '馬提尼克島',
      et: 'Martinique',
      ja: 'マルティニーク',
      he: 'מרטיניק',
      el: 'Μαρτινίκα',
      kk: 'Мартиника',
      ka: 'მარტინიკა',
      th: 'มาร์ตีนีก',
    },
    phoneLength: 9,
    dialCode: '+596',
    code: 'MQ',
    flag: '🇲🇶',
  },
  {
    name: {
      en: 'Mauritania',
      ru: 'Мавритания',
      pl: 'Mauretania',
      uk: 'Мавританія',
      cs: 'Mauretánie',
      be: 'Маўрытанія',
      pt: 'Mauritânia',
      es: 'Mauritania',
      ro: 'Mauritania',
      bg: 'Мавритания',
      de: 'Mauretanien',
      fr: 'Mauritanie',
      nl: 'Mauritanië',
      it: 'Mauritania',
      cn: '毛里塔尼亚',
      zh: '毛里塔尼亞',
      et: 'Mauritaania',
      ja: 'モーリタニア',
      he: 'מאוריטניה',
      el: 'Μαυριτανία',
      kk: 'Мавритания',
      ka: 'მავრიტანია',
      th: 'ประเทศมอริเตเนีย',
    },
    phoneLength: 8,
    dialCode: '+222',
    code: 'MR',
    flag: '🇲🇷',
  },
  {
    name: {
      en: 'Mauritius',
      ru: 'Маврикий',
      pl: 'Mauritius',
      uk: 'Маврикій',
      cs: 'Mauricius',
      be: 'Маўрыкій',
      pt: 'Maurícia',
      es: 'Mauricio',
      ro: 'Mauritius',
      bg: 'Мавриций',
      de: 'Mauritius',
      fr: 'Ile Maurice',
      nl: 'Mauritius',
      it: 'Maurizio',
      cn: '毛里求斯',
      zh: '毛里求斯',
      et: 'Mauritius',
      ja: 'モーリシャス',
      he: 'מאוריציוס',
      el: 'Μαυρίκιος',
      kk: 'Маврикий',
      ka: 'მავრიკი',
      th: 'ประเทศมอริเชียส',
    },
    phoneLength: 8,
    dialCode: '+230',
    code: 'MU',
    flag: '🇲🇺',
  },
  {
    name: {
      en: 'Mayotte',
      ru: 'Майотта',
      pl: 'Majotta',
      uk: 'Майотта',
      cs: 'Mayotte',
      be: 'Маёта',
      pt: 'Mayotte',
      es: 'Mayotte',
      ro: 'Mayotte',
      bg: 'Майот',
      de: 'Mayotte',
      fr: 'Mayotte',
      nl: 'Mayotte',
      it: 'Mayotte',
      cn: '马约特岛',
      zh: '馬約特島',
      et: 'Mayotte',
      ja: 'マヨット',
      he: 'מיוט',
      el: 'Μαγιότ',
      kk: 'Майотта',
      ka: 'მაიოტა',
      th: 'มายอต',
    },
    phoneLength: 8,
    dialCode: '+262',
    code: 'YT',
    flag: '🇾🇹',
  },
  {
    name: {
      en: 'Mexico',
      ru: 'Мексика',
      pl: 'Meksyk',
      uk: 'Мексика',
      cs: 'Mexiko',
      be: 'Мексіка',
      pt: 'México',
      es: 'México',
      ro: 'Mexic',
      bg: 'Мексико',
      de: 'Mexiko',
      fr: 'Mexique',
      nl: 'Mexico',
      it: 'Messico',
      cn: '墨西哥',
      zh: '墨西哥',
      et: 'Mehhiko',
      ja: 'メキシコ',
      he: 'מקסיקו',
      el: 'Μεξικό',
      kk: 'Мексика',
      ka: 'მექსიკა',
      th: 'ประเทศเม็กซิโก',
    },
    phoneLength: 10,
    dialCode: '+52',
    code: 'MX',
    flag: '🇲🇽',
  },
  {
    name: {
      en: 'Micronesia',
      ru: 'Микронезия',
      pl: 'Mikronezja',
      uk: 'Мікронезія',
      cs: 'Mikronésie',
      be: 'Мікранезія',
      pt: 'Micronésia',
      es: 'Micronesia',
      ro: 'Micronezia',
      bg: 'Микронезия',
      de: 'Mikronesien',
      fr: 'Micronésie',
      nl: 'Micronesië',
      it: 'Micronesia',
      cn: '密克罗尼西亚',
      zh: '密克羅尼西亞',
      et: 'Mikroneesia',
      ja: 'ミクロネシア連邦',
      he: 'מיקרונזיה',
      el: 'Μικρονησία',
      kk: 'Микронезия',
      ka: 'მიკრონეზია',
      th: 'ไมโครนีเซีย',
    },
    phoneLength: 7,
    dialCode: '+691',
    code: 'FM',
    flag: '🇫🇲',
  },
  {
    name: {
      en: 'Moldova',
      ru: 'Молдова',
      pl: 'Mołdawia',
      uk: 'Молдова',
      cs: 'Moldavsko',
      be: 'Малдова',
      pt: 'Moldávia',
      es: 'Moldavia',
      ro: 'Moldova',
      bg: 'Молдова',
      de: 'Moldawien',
      fr: 'Moldavie',
      nl: 'Moldavië',
      it: 'Moldavia',
      cn: '摩尔多瓦',
      zh: '摩爾多瓦',
      et: 'Moldova',
      ja: 'モルドバ',
      he: 'מולדובה',
      el: 'Μολδαβία',
      kk: 'Молдова',
      ka: 'მოლდოვა',
      th: 'ประเทศมอลโดวา',
    },
    phoneLength: 8,
    dialCode: '+373',
    code: 'MD',
    flag: '🇲🇩',
  },
  {
    name: {
      en: 'Monaco',
      ru: 'Монако',
      pl: 'Monako',
      uk: 'Монако',
      cs: 'Monako',
      be: 'Манака',
      pt: 'Mónaco',
      es: 'Mónaco',
      ro: 'Monaco',
      bg: 'Монако',
      de: 'Monaco',
      fr: 'Monaco',
      nl: 'Monaco',
      it: 'Monaco',
      cn: '摩纳哥',
      zh: '摩納哥',
      et: 'Monaco',
      ja: 'モナコ',
      he: 'מונקו',
      el: 'Μονακό',
      kk: 'Монако',
      ka: 'მონაკო',
      th: 'ประเทศโมนาโก',
    },
    phoneLength: 8,
    dialCode: '+377',
    code: 'MC',
    flag: '🇲🇨',
  },
  {
    name: {
      en: 'Mongolia',
      ru: 'Монголия',
      pl: 'Mongolia',
      uk: 'Монголія',
      cs: 'Mongolsko',
      be: 'Манголія',
      pt: 'Mongólia',
      es: 'Mongolia',
      ro: 'Mongolia',
      bg: 'Монголия',
      de: 'Mongolei',
      fr: 'Mongolie',
      nl: 'Mongolië',
      it: 'Mongolia',
      cn: '蒙古',
      zh: '蒙古',
      et: 'Mongoolia',
      ja: 'モンゴル',
      he: 'מונגוליה',
      el: 'Μογγολία',
      kk: 'Моңғолия',
      ka: 'მონღოლეთი',
      th: 'ประเทศมองโกเลีย',
    },
    phoneLength: 8,
    dialCode: '+976',
    code: 'MN',
    flag: '🇲🇳',
  },
  {
    name: {
      en: 'Montenegro',
      ru: 'Черногория',
      pl: 'Czarnogóra',
      uk: 'Чорногорія',
      cs: 'Černá Hora',
      be: 'Чарнагорыя',
      pt: 'Montenegro',
      es: 'Montenegro',
      ro: 'Muntenegru',
      bg: 'Черна гора',
      de: 'Montenegro',
      fr: 'Monténégro',
      nl: 'Montenegro',
      it: 'Montenegro',
      cn: '黑山共和国',
      zh: '黑山共和國',
      et: 'Montenegro',
      ja: 'モンテネグロ',
      he: 'מונטנגרו',
      el: 'Μαυροβούνιο',
      kk: 'Черногория',
      ka: 'მონტენეგრო',
      th: 'ประเทศมอนเตเนโกร',
    },
    phoneLength: 8,
    dialCode: '+382',
    code: 'ME',
    flag: '🇲🇪',
  },
  {
    name: {
      en: 'Montserrat',
      ru: 'Монтсеррат',
      pl: 'Montserrat',
      uk: 'Монтсеррат',
      cs: 'Montserrat',
      be: 'Мансерат',
      pt: 'Monserrate',
      es: 'Montserrat',
      ro: 'Montserrat',
      bg: 'Монсерат',
      de: 'Montserrat',
      fr: 'Montserrat',
      nl: 'Montserrat',
      it: 'Montserrat',
      cn: '蒙特塞拉特',
      zh: '蒙特塞拉特',
      et: 'Montserrat',
      ja: 'モントセラト',
      he: 'מונטסראט',
      el: 'Μοντσερά',
      kk: 'Монтсеррат',
      ka: 'მონსერატის კუნძული',
      th: 'ประเทศมอนต์เซอร์รัต',
    },
    phoneLength: 7,
    dialCode: '+1664',
    code: 'MS',
    flag: '🇲🇸',
  },
  {
    name: {
      en: 'Morocco',
      ru: 'Марокко',
      pl: 'Maroko',
      uk: 'Марокко',
      cs: 'Maroko',
      be: 'Марока',
      pt: 'Marrocos',
      es: 'Marruecos',
      ro: 'Maroc',
      bg: 'Мароко',
      de: 'Marokko',
      fr: 'Maroc',
      nl: 'Marokko',
      it: 'Marocco',
      cn: '摩洛哥',
      zh: '摩洛哥',
      et: 'Maroko',
      ja: 'モロッコ',
      he: 'מרוקו',
      el: 'Μαρόκο',
      kk: 'Марокко',
      ka: 'მაროკო',
      th: 'ประเทศโมร็อกโก',
    },
    phoneLength: 9,
    dialCode: '+212',
    code: 'MA',
    flag: '🇲🇦',
  },
  {
    name: {
      en: 'Mozambique',
      ru: 'Мозамбик',
      pl: 'Mozambik',
      uk: 'Мозамбік',
      cs: 'Mosambik',
      be: 'Мазамбік',
      pt: 'Moçambique',
      es: 'Mozambique',
      ro: 'Mozambic',
      bg: 'Мозамбик',
      de: 'Mosambik',
      fr: 'Mozambique',
      nl: 'Mozambique',
      it: 'Mozambico',
      cn: '莫桑比克',
      zh: '莫桑比克',
      et: 'Mosambiik',
      ja: 'モザンビーク',
      he: 'מוזמביק',
      el: 'Μοζαμβίκη',
      kk: 'Мозамбик',
      ka: 'მოზამბიკი',
      th: 'ประเทศโมซัมบิก',
    },
    phoneLength: 9,
    dialCode: '+258',
    code: 'MZ',
    flag: '🇲🇿',
  },
  {
    name: {
      en: 'Myanmar',
      ru: 'Мьянма',
      pl: 'Myanmar',
      uk: "М'янма",
      cs: 'Myanmar',
      be: "М'янма",
      pt: 'Birmânia',
      es: 'Myanmar',
      ro: 'Myanmar',
      bg: 'Мианмар',
      de: 'Myanmar',
      fr: 'Myanmar',
      nl: 'Myanmar',
      it: 'Myanmar',
      cn: '缅甸',
      zh: '緬甸',
      et: 'Myanmar',
      ja: 'ミャンマー',
      he: 'מיאנמר',
      el: 'Μιανμάρ',
      kk: 'Мьянма',
      ka: 'მიანმარი',
      th: 'ประเทศพม่า',
    },
    phoneLength: 8,
    dialCode: '+95',
    code: 'MM',
    flag: '🇲🇲',
  },
  {
    name: {
      en: 'Namibia',
      ru: 'Намибия',
      pl: 'Namibia',
      uk: 'Намібія',
      cs: 'Namibie',
      be: 'Намібія',
      pt: 'Namíbia',
      es: 'Namibia',
      ro: 'Namibia',
      bg: 'Намибия',
      de: 'Namibia',
      fr: 'Namibie',
      nl: 'Namibië',
      it: 'Namibia',
      cn: '纳米比亚',
      zh: '納米比亞',
      et: 'Namiibia',
      ja: 'ナミビア',
      he: 'נמיביה',
      el: 'Ναμίμπια',
      kk: 'Намибия',
      ka: 'ნამიბია',
      th: 'ประเทศนามิเบีย',
    },
    phoneLength: 8,
    dialCode: '+264',
    code: 'NA',
    flag: '🇳🇦',
  },
  {
    name: {
      en: 'Nauru',
      ru: 'Науру',
      pl: 'Nauru',
      uk: 'Науру',
      cs: 'Nauru',
      be: 'Науру',
      pt: 'Nauru',
      es: 'Nauru',
      ro: 'Nauru',
      bg: 'Науру',
      de: 'Nauru',
      fr: 'Nauru',
      nl: 'Nauru',
      it: 'Nauru',
      cn: '瑙鲁',
      zh: '瑙魯',
      et: 'Nauru',
      ja: 'ナウル',
      he: 'נאורו',
      el: 'Ναουρού',
      kk: 'Науру',
      ka: 'ნაურუ',
      th: 'ประเทศนาอูรู',
    },
    phoneLength: 7,
    dialCode: '+674',
    code: 'NR',
    flag: '🇳🇷',
  },
  {
    name: {
      en: 'Nepal',
      ru: 'Непал',
      pl: 'Nepal',
      uk: 'Непал',
      cs: 'Nepál',
      be: 'Непал',
      pt: 'Nepal',
      es: 'Nepal',
      ro: 'Nepal',
      bg: 'Непал',
      de: 'Nepal',
      fr: 'Népal',
      nl: 'Nepal',
      it: 'Nepal',
      cn: '尼尼泊尔',
      zh: '尼尼泊爾',
      et: 'Nepal',
      ja: 'ネパール',
      he: 'נפאל',
      el: 'Νεπάλ',
      kk: 'Непал',
      ka: 'ნეპალი',
      th: 'ประเทศเนปาล',
    },
    phoneLength: 10,
    dialCode: '+977',
    code: 'NP',
    flag: '🇳🇵',
  },
  {
    name: {
      en: 'Netherlands',
      ru: 'Нидерланды',
      pl: 'Holandia',
      uk: 'Нідерланди',
      cs: 'Holandsko',
      be: 'Нідэрланды',
      pt: 'Países Baixos',
      es: 'Países Bajos',
      ro: 'Olanda',
      bg: 'Холандия',
      de: 'Niederlande',
      fr: 'Pays-Bas',
      nl: 'Nederland',
      it: 'Olanda',
      cn: '荷兰',
      zh: '荷蘭',
      et: 'Holland',
      ja: 'オランダ',
      he: 'הולנד',
      el: 'Ολλανδία',
      kk: 'Нидерланды',
      ka: 'ნიდერლანდები',
      th: 'ประเทศเนเธอร์แลนด์',
    },
    phoneLength: 9,
    dialCode: '+31',
    code: 'NL',
    flag: '🇳🇱',
  },
  {
    name: {
      en: 'New Caledonia',
      ru: 'Новая Каледония',
      pl: 'Nowa Kaledonia',
      uk: 'Нова Каледонія',
      cs: 'Nová Kaledonie',
      be: 'Новая Каледонія',
      pt: 'Nova Caledónia',
      es: 'Nueva Caledonia',
      ro: 'Noua Caledonie',
      bg: 'Нова Каледония',
      de: 'Neu-Kaledonien',
      fr: 'Nouvelle Calédonie',
      nl: 'Nieuw-Caledonië',
      it: 'Nuova Caledonia',
      cn: '新喀里多尼亚',
      zh: '新喀里多尼亞',
      et: 'Uus-Kaledoonia',
      ja: 'ニューカレドニア',
      he: 'קלדוניה החדשה',
      el: 'Νέα Καληδονία',
      kk: 'Жаңа Каледония',
      ka: 'ახალი კალედონია',
      th: 'ประเทศนิวแคลิโดเนีย',
    },
    phoneLength: 6,
    dialCode: '+687',
    code: 'NC',
    flag: '🇳🇨',
  },
  {
    name: {
      en: 'New Zealand',
      ru: 'Новая Зеландия',
      pl: 'Nowa Zelandia',
      uk: 'Нова Зеландія',
      cs: 'Nový Zéland',
      be: 'Новая Зеландыя',
      pt: 'Nova Zelândia',
      es: 'Nueva Zelanda',
      ro: 'Noua Zeelanda',
      bg: 'Нова Зеландия',
      de: 'Neuseeland',
      fr: 'Nouvelle-Zélande',
      nl: 'Nieuw-Zeeland',
      it: 'Nuova Zelanda',
      cn: '新西兰',
      zh: '新西蘭',
      et: 'Uus-Meremaa',
      ja: 'ニュージーランド',
      he: 'ניו זילנד',
      el: 'Νέα Ζηλανδία',
      kk: 'Жаңа Зеландия',
      ka: 'ახალი ზელანდია',
      th: 'ประเทศนิวซีแลนด์',
    },
    phoneLength: 8,
    dialCode: '+64',
    code: 'NZ',
    flag: '🇳🇿',
  },
  {
    name: {
      en: 'Nicaragua',
      ru: 'Никарагуа',
      pl: 'Nikaragua',
      uk: 'Нікарагуа',
      cs: 'Nikaragua',
      be: 'Нікарагуа',
      pt: 'Nicarágua',
      es: 'Nicaragua',
      ro: 'Nicaragua',
      bg: 'Никарагуа',
      de: 'Nicaragua',
      fr: 'Nicaragua',
      nl: 'Nicaragua',
      it: 'Nicaragua',
      cn: '尼加拉瓜',
      zh: '尼加拉瓜',
      et: 'Nicaragua',
      ja: 'ニカラグア',
      he: 'ניקרגואה',
      el: 'Νικαράγουα',
      kk: 'Никарагуа',
      ka: 'ნიკარაგუა',
      th: 'ประเทศนิการากัว',
    },
    phoneLength: 8,
    dialCode: '+505',
    code: 'NI',
    flag: '🇳🇮',
  },
  {
    name: {
      en: 'Niger',
      ru: 'Нигер',
      pl: 'Niger',
      uk: 'Нігер',
      cs: 'Niger',
      be: 'Нігер',
      pt: 'Níger',
      es: 'Níger',
      ro: 'Niger',
      bg: 'Нигер',
      de: 'Niger',
      fr: 'Niger',
      nl: 'Niger',
      it: 'Niger',
      cn: '尼日尔',
      zh: '尼日爾',
      et: 'Niger',
      ja: 'ニジェール',
      he: "ניז'ר",
      el: 'Νίγηρας',
      kk: 'Нигер',
      ka: 'ნიგერი',
      th: 'ประเทศไนเจอร์',
    },
    phoneLength: 8,
    dialCode: '+227',
    code: 'NE',
    flag: '🇳🇪',
  },
  {
    name: {
      en: 'Nigeria',
      ru: 'Нигерия',
      pl: 'Nigeria',
      uk: 'Нігерія',
      cs: 'Nigérie',
      be: 'Нігерыя',
      pt: 'Nigéria',
      es: 'Nigeria',
      ro: 'Nigeria',
      bg: 'Нигерия',
      de: 'Nigeria',
      fr: 'Nigeria',
      nl: 'Nigeria',
      it: 'Nigeria',
      cn: '奈及利亚',
      zh: '奈及利亞',
      et: 'Nigeeria',
      ja: 'ナイジェリア',
      he: 'ניגריה',
      el: 'Νιγηρία',
      kk: 'Нигерия',
      ka: 'ნიგერია',
      th: 'ประเทศไนจีเรีย',
    },
    phoneLength: 11,
    dialCode: '+234',
    code: 'NG',
    flag: '🇳🇬',
  },
  {
    name: {
      en: 'Norfolk Island',
      ru: 'Остров Норфолк',
      pl: 'Wyspa Norfolk',
      uk: 'Острів Норфолк',
      cs: 'Ostrov Norfolk',
      be: 'Востраў Норфолк',
      pt: 'Ilha Norfolk',
      es: 'Isla de Norfolk',
      ro: 'Insula Norfolk',
      bg: 'Остров Норфолк',
      de: 'Norfolkinsel',
      fr: "l'ile de Norfolk",
      nl: 'Norfolkeiland',
      it: 'Isola Norfolk',
      cn: '诺福克岛',
      zh: '諾福克島',
      et: 'Norfolki saar',
      ja: 'ノーフォーク島',
      he: 'האי נורפוק',
      el: 'Νησί Νόρφολκ',
      kk: 'Норфолк аралы',
      ka: 'ნორფოლკის კუნძული',
      th: 'เกาะนอร์ฟอล์ก',
    },
    phoneLength: 6,
    dialCode: '+672',
    code: 'NF',
    flag: '🇳🇫',
  },
  {
    name: {
      en: 'Northern Mariana Islands',
      ru: 'Северные Марианские острова',
      pl: 'Mariany Północne',
      uk: 'Північні Маріанські острови',
      cs: 'Severní Mariany',
      be: 'Паўночныя Марыянскія астравы',
      pt: 'Marianas do Norte',
      es: 'Islas Marianas del Norte',
      ro: 'Insulele Marianelor de Nord',
      bg: 'Северни Мариански острови',
      de: 'Nördliche Marianneninseln',
      fr: 'Îles Mariannes du Nord',
      nl: 'noordelijke Mariana eilanden',
      it: 'Isole Marianne settentrionali',
      cn: '北马里亚纳群岛',
      zh: '北馬里亞納群島',
      et: 'Põhja-Mariaanid',
      ja: '北マリアナ諸島',
      he: 'איי מריאנה הצפוניים',
      el: 'Βόρειες Μαριάνες Νήσοι',
      kk: 'Шығыс Мариан аралдары',
      ka: 'ჩრდილოეთი მარიანის კუნძულები',
      th: 'หมู่เกาะนอร์เทิร์นมาเรียนา',
    },
    phoneLength: 7,
    dialCode: '+1670',
    code: 'MP',
    flag: '🇲🇵',
  },
  {
    name: {
      en: 'Norway',
      ru: 'Норвегия',
      pl: 'Norwegia',
      uk: 'Норвегія',
      cs: 'Norsko',
      be: 'Нарвегія',
      pt: 'Noruega',
      es: 'Noruega',
      ro: 'Norvegia',
      bg: 'Норвегия',
      de: 'Norwegen',
      fr: 'Norvège',
      nl: 'Noorwegen',
      it: 'Norvegia',
      cn: '挪威',
      zh: '挪威',
      et: 'Norra',
      ja: 'ノルウェー',
      he: 'נורווגיה',
      el: 'Νορβηγία',
      kk: 'Норвегия',
      ka: 'ნორვეგია',
      th: 'ประเทศนอร์เวย์',
    },
    phoneLength: 8,
    dialCode: '+47',
    code: 'NO',
    flag: '🇳🇴',
  },
  {
    name: {
      en: 'Oman',
      ru: 'Оман',
      pl: 'Oman',
      uk: 'Оман',
      cs: 'Omán',
      be: 'Аман',
      pt: 'Omã',
      es: 'Omán',
      ro: 'Oman',
      bg: 'Оман',
      de: 'Oman',
      fr: 'Oman',
      nl: 'Oman',
      it: 'Oman',
      cn: '阿曼',
      zh: '阿曼',
      et: 'Omaan',
      ja: 'オマーン',
      he: 'עומאן',
      el: 'Ομάν',
      kk: 'Оман',
      ka: 'ომანი',
      th: 'ประเทศโอมาน',
    },
    phoneLength: 8,
    dialCode: '+968',
    code: 'OM',
    flag: '🇴🇲',
  },
  {
    name: {
      en: 'Pakistan',
      ru: 'Пакистан',
      pl: 'Pakistan',
      uk: 'Пакистан',
      cs: 'Pákistán',
      be: 'Пакістан',
      pt: 'Paquistão',
      es: 'Pakistán',
      ro: 'Pakistan',
      bg: 'Пакистан',
      de: 'Pakistan',
      fr: 'Pakistan',
      nl: 'Pakistan',
      it: 'Pakistan',
      cn: '巴基斯坦',
      zh: '巴基斯坦',
      et: 'Pakistan',
      ja: 'パキスタン',
      he: 'פקיסטן',
      el: 'Πακιστάν',
      kk: 'Пәкістан',
      ka: 'პაკისტანი',
      th: 'ประเทศปากีสถาน',
    },
    phoneLength: 10,
    dialCode: '+92',
    code: 'PK',
    flag: '🇵🇰',
  },
  {
    name: {
      en: 'Palau',
      ru: 'Палау',
      pl: 'Palau',
      uk: 'Палау',
      cs: 'Palau',
      be: 'Палаў',
      pt: 'Palau',
      es: 'Palau',
      ro: 'Palau',
      bg: 'Палау',
      de: 'Palau',
      fr: 'Palau',
      nl: 'Palau',
      it: 'Palau',
      cn: 'u琉',
      zh: 'u琉',
      et: 'Palau',
      ja: 'パラオ',
      he: 'פלאו',
      el: 'Παλάου',
      kk: 'Палау',
      ka: 'პალაუ',
      th: 'ประเทศปาเลา',
    },
    phoneLength: 7,
    dialCode: '+680',
    code: 'PW',
    flag: '🇵🇼',
  },
  {
    name: {
      en: 'Palestine',
      ru: 'Палестина',
      pl: 'Palestyna',
      uk: 'Палестина',
      cs: 'Palestina',
      be: 'Палестына',
      pt: 'Palestina',
      es: 'Palestina',
      ro: 'Palestina',
      bg: 'Палестина',
      de: 'Palästina',
      fr: 'Palestine',
      nl: 'Palestina',
      it: 'Palestina',
      cn: '巴勒斯坦',
      zh: '巴勒斯坦',
      et: 'Palestiina',
      ja: 'パレスチナ',
      he: 'פלסטין',
      el: 'Παλαιστίνη',
      kk: 'Палестина',
      ka: 'პალესტინა',
      th: 'ประเทศปาเลสไตน์',
    },
    phoneLength: 8,
    dialCode: '+970',
    code: 'PS',
    flag: '🇵🇸',
  },
  {
    name: {
      en: 'Panama',
      ru: 'Панама',
      pl: 'Panama',
      uk: 'Панама',
      cs: 'Panama',
      be: 'Панама',
      pt: 'Panamá',
      es: 'Panamá',
      ro: 'Panama',
      bg: 'Панама',
      de: 'Panama',
      fr: 'Panama',
      nl: 'Panama',
      it: 'Panama',
      cn: '巴拿马',
      zh: '巴拿馬',
      et: 'Panama',
      ja: 'パナマ',
      he: 'פנמה',
      el: 'Παναμάς',
      kk: 'Панама',
      ka: 'პანამა',
      th: 'ประเทศปานามา',
    },
    phoneLength: 8,
    dialCode: '+507',
    code: 'PA',
    flag: '🇵🇦',
  },
  {
    name: {
      en: 'Papua New Guinea',
      ru: 'Папуа - Новая Гвинея',
      pl: 'Papua Nowa Gwinea',
      uk: 'Папуа-Нова Гвінея',
      cs: 'Papua-Nová Guinea',
      be: 'Папуа-Новая Гвінея',
      pt: 'Papua-Nova Guiné',
      es: 'Papúa Nueva Guinea',
      ro: 'Papua Noua Guinee',
      bg: 'Папуа-Нова Гвинея',
      de: 'Papua Neu-Guinea',
      fr: 'Papouasie Nouvelle Guinée',
      nl: 'Papoea-Nieuw-Guinea',
      it: 'Papua Nuova Guinea',
      cn: '巴布亚新几内亚',
      zh: '巴布亞新幾內亞',
      et: 'Paapua Uus-Guinea',
      ja: 'パプアニューギニア',
      he: 'פפואה גינאה החדשה',
      el: 'Παπούα Νέα Γουινέα',
      kk: 'Папуа — Жаңа Гвинея',
      ka: 'პაპუა-ახალი გვინეა',
      th: 'ประเทศปาปัวนิวกินี',
    },
    phoneLength: 7,
    dialCode: '+675',
    code: 'PG',
    flag: '🇵🇬',
  },
  {
    name: {
      en: 'Paraguay',
      ru: 'Парагвай',
      pl: 'Paragwaj',
      uk: 'Парагвай',
      cs: 'Paraguay',
      be: 'Парагвай',
      pt: 'Paraguai',
      es: 'Paraguay',
      ro: 'Paraguay',
      bg: 'Парагвай',
      de: 'Paraguay',
      fr: 'Paraguay',
      nl: 'Paraguay',
      it: 'Paraguay',
      cn: '巴拉圭',
      zh: '巴拉圭',
      et: 'Paraguay',
      ja: 'パラグアイ',
      he: 'פרגוואי',
      el: 'Παραγουάη',
      kk: 'Парагвай',
      ka: 'პარაგვაი',
      th: 'ประเทศปารากวัย',
    },
    phoneLength: 9,
    dialCode: '+595',
    code: 'PY',
    flag: '🇵🇾',
  },
  {
    name: {
      en: 'Peru',
      ru: 'Перу',
      pl: 'Peru',
      uk: 'Перу',
      cs: 'Peru',
      be: 'Перу',
      pt: 'Peru',
      es: 'Perú',
      ro: 'Peru',
      bg: 'Перу',
      de: 'Peru',
      fr: 'Pérou',
      nl: 'Peru',
      it: 'Perù',
      cn: '秘鲁',
      zh: '秘魯',
      et: 'Peruu',
      ja: 'ペルー',
      he: 'פרו',
      el: 'Περού',
      kk: 'Перу',
      ka: 'პერუ',
      th: 'ประเทศเปรู',
    },
    phoneLength: 9,
    dialCode: '+51',
    code: 'PE',
    flag: '🇵🇪',
  },
  {
    name: {
      en: 'Philippines',
      ru: 'Филиппины',
      pl: 'Filipiny',
      uk: 'Філіппіни',
      cs: 'Filipíny',
      be: 'Філіпіны',
      pt: 'Filipinas',
      es: 'Filipinas',
      ro: 'Filipine',
      bg: 'Филипините',
      de: 'Philippinen',
      fr: 'Philippines',
      nl: 'Filippijnen',
      it: 'Filippine',
      cn: '菲律宾',
      zh: '菲律賓',
      et: 'Filipiinid',
      ja: 'フィリピン',
      he: 'פיליפינים',
      el: 'Φιλιππίνες',
      kk: 'Филиппиндер',
      ka: 'ფილიპინები',
      th: 'ประเทศฟิลิปปินส์',
    },
    phoneLength: 10,
    dialCode: '+63',
    code: 'PH',
    flag: '🇵🇭',
  },
  {
    name: {
      en: 'Pitcairn',
      ru: 'Питкэрн',
      pl: 'Pitcairn',
      uk: 'Піткерн',
      cs: 'Pitcairn',
      be: 'Піткэрн',
      pt: 'Pitcairn',
      es: 'Pitcairn',
      ro: 'Pitcairn',
      bg: 'Питкерн',
      de: 'Pitcairn',
      fr: 'Pitcairn',
      nl: 'Pitcairn',
      it: 'Pitcairn',
      cn: '皮特凯恩',
      zh: '皮特凱恩',
      et: 'Pitcairn',
      ja: 'ピトケアン',
      he: 'פיטקרן',
      el: 'Πίτκαιρν',
      kk: 'Питкэрн',
      ka: 'პიტკერნი',
      th: 'ประเทศพิตแคร์น',
    },
    phoneLength: 6,
    dialCode: '+64',
    code: 'PN',
    flag: '🇵🇳',
  },
  {
    name: {
      en: 'Poland',
      ru: 'Польша',
      pl: 'Polska',
      uk: 'Польща',
      cs: 'Polsko',
      be: 'Польшча',
      pt: 'Polónia',
      es: 'Polonia',
      ro: 'Polonia',
      bg: 'Полша',
      de: 'Polen',
      fr: 'Pologne',
      nl: 'Polen',
      it: 'Polonia',
      cn: '波兰',
      zh: '波蘭',
      et: 'Poola',
      ja: 'ポーランド',
      he: 'פולין',
      el: 'Πολωνία',
      kk: 'Польша',
      ka: 'პოლონეთი',
      th: 'ประเทศโปแลนด์',
    },
    phoneLength: 9,
    dialCode: '+48',
    code: 'PL',
    flag: '🇵🇱',
  },
  {
    name: {
      en: 'Portugal',
      ru: 'Португалия',
      pl: 'Portugalia',
      uk: 'Португалія',
      cs: 'Portugalsko',
      be: 'Партугалія',
      pt: 'Portugal',
      es: 'Portugal',
      ro: 'Portugalia',
      bg: 'Португалия',
      de: 'Portugal',
      fr: 'Le Portugal',
      nl: 'Portugal',
      it: 'Portogallo',
      cn: '葡萄牙',
      zh: '葡萄牙',
      et: 'Portugal',
      ja: 'ポルトガル',
      he: 'פורטוגל',
      el: 'Πορτογαλία',
      kk: 'Португалия',
      ka: 'პორტუგალია',
      th: 'ประเทศโปรตุเกส',
    },
    phoneLength: 9,
    dialCode: '+351',
    code: 'PT',
    flag: '🇵🇹',
  },
  {
    name: {
      en: 'Puerto Rico',
      ru: 'Пуэрто-Рико',
      pl: 'Portoryko',
      uk: 'Пуерто Ріко',
      cs: 'Portoriko',
      be: 'Пуэрта-Рыка',
      pt: 'Porto Rico',
      es: 'Puerto Rico',
      ro: 'Puerto Rico',
      bg: 'Пуерто Рико',
      de: 'Puerto Rico',
      fr: 'Porto Rico',
      nl: 'Puerto Rico',
      it: 'Porto Rico',
      cn: '波多黎各',
      zh: '波多黎各',
      et: 'Puerto Rico',
      ja: 'プエルトリコ',
      he: 'פוארטו ריקו',
      el: 'Πουέρτο Ρίκο',
      kk: 'Пуэрто Рико',
      ka: 'პუერტო რიკო',
      th: 'ประเทศเปอร์โตริโก',
    },
    phoneLength: 10,
    dialCode: '+1',
    code: 'PR',
    flag: '🇵🇷',
  },
  {
    name: {
      en: 'Qatar',
      ru: 'Катар',
      pl: 'Katar',
      uk: 'Катар',
      cs: 'Katar',
      be: 'Катар',
      pt: 'Catar',
      es: 'Qatar',
      ro: 'Qatar',
      bg: 'Катар',
      de: 'Katar',
      fr: 'Qatar',
      nl: 'Qatar',
      it: 'Qatar',
      cn: '卡塔尔',
      zh: '卡塔爾',
      et: 'Katar',
      ja: 'カタール',
      he: 'קטאר',
      el: 'Κατάρ',
      kk: 'Катар',
      ka: 'კატარი',
      th: 'ประเทศกาตาร์',
    },
    phoneLength: 8,
    dialCode: '+974',
    code: 'QA',
    flag: '🇶🇦',
  },
  {
    name: {
      en: 'Romania',
      ru: 'Румыния',
      pl: 'Rumunia',
      uk: 'Румунія',
      cs: 'Rumunsko',
      be: 'Румынія',
      pt: 'Roménia',
      es: 'Rumanía',
      ro: 'România',
      bg: 'Румъния',
      de: 'Rumänien',
      fr: 'Roumanie',
      nl: 'Roemenië',
      it: 'Romania',
      cn: '罗马尼亚',
      zh: '羅馬尼亞',
      et: 'Rumeenia',
      ja: 'ルーマニア',
      he: 'רומניה',
      el: 'Ρουμανία',
      kk: 'Румыния',
      ka: 'რუმინეთი',
      th: 'ประเทศโรมาเนีย',
    },
    phoneLength: 9,
    dialCode: '+40',
    code: 'RO',
    flag: '🇷🇴',
  },
  {
    name: {
      en: 'Russia',
      ru: 'Россия',
      pl: 'Rosja',
      uk: 'Росія',
      cs: 'Rusko',
      be: 'Расійская Федэрацыя',
      pt: 'Rússia',
      es: 'Rusia',
      ro: 'Federația Rusă',
      bg: 'Руска федерация',
      de: 'Russische Föderation',
      fr: 'Fédération Russe',
      nl: 'Russische Federatie',
      it: 'Federazione Russa',
      cn: '俄罗斯联邦',
      zh: '俄羅斯聯邦',
      et: 'Venemaa Föderatsioon',
      ja: 'ロシア連邦',
      he: 'רוסיה',
      el: 'Ρωσία',
      kk: 'Ресей',
      ka: 'რუსეთი',
      th: 'ประเทศรัสเซีย',
    },
    phoneLength: 10,
    dialCode: '+7',
    code: 'RU',
    flag: '🇷🇺',
  },
  {
    name: {
      en: 'Rwanda',
      ru: 'Руанда',
      pl: 'Rwanda',
      uk: 'Руанда',
      cs: 'Rwanda',
      be: 'Руанда',
      pt: 'Ruanda',
      es: 'Ruanda',
      ro: 'Rwanda',
      bg: 'Руанда',
      de: 'Ruanda',
      fr: 'Rwanda',
      nl: 'Rwanda',
      it: 'Ruanda',
      cn: '卢旺达',
      zh: '盧旺達',
      et: 'Rwanda',
      ja: 'ルワンダ',
      he: 'רואנדה',
      el: 'Ρουάντα',
      kk: 'Руанда',
      ka: 'რუანდა',
      th: 'ประเทศรวันดา',
    },
    phoneLength: 8,
    dialCode: '+250',
    code: 'RW',
    flag: '🇷🇼',
  },
  {
    name: {
      en: 'Saint Barthélemy',
      ru: 'Святой Варфоломей',
      pl: 'Saint Barthelemy',
      uk: 'Сен-Бартелемі',
      cs: 'Svatý Bartoloměj',
      be: 'Святы Бартэлемі',
      pt: 'São Bartolomeu',
      es: 'San Bartolomé',
      ro: 'Sfântul Barthelemy',
      bg: 'Свети Бартелеми',
      de: 'Heiliger Barthelemy',
      fr: 'Saint Barthélemy',
      nl: 'Sint-Bartholomeus',
      it: 'Saint Barthelemy',
      cn: '圣巴托洛缪岛',
      zh: '聖巴托洛繆島',
      et: 'Püha Barthelemy',
      ja: 'サンバルテルミー',
      he: "סנט ברת'למי",
      el: 'Άγιος Βαρθολομαίος',
      kk: 'Сен-Бартелеми',
      ka: 'სენ-ბართელემი',
      th: 'เซนต์บาร์เธเลมี',
    },
    phoneLength: 6,
    dialCode: '+590',
    code: 'BL',
    flag: '🇧🇱',
  },
  {
    name: {
      en: 'Saint Kitts and Nevis',
      ru: 'Сент-Китс и Невис',
      pl: 'Saint Kitts i Nevis',
      uk: 'Сент-Кітс і Невіс',
      cs: 'Svatý Kryštof a Nevis',
      be: 'Сэнт-Кітс і Нэвіс',
      pt: 'São Cristóvão e Neves',
      es: 'San Cristóbal y Nieves',
      ro: 'Sfântul Kitts și Nevis',
      bg: 'Сейнт Китс и Невис',
      de: 'St. Kitts und Nevis',
      fr: 'Saint-Christophe-et-Niévès',
      nl: 'Saint Kitts en Nevis',
      it: 'Saint Kitts e Nevis',
      cn: '圣基茨和尼维斯',
      zh: '聖基茨和尼維斯',
      et: 'Saint Kitts ja Nevis',
      ja: 'セントクリストファーネイビス',
      he: 'סנט קיטס ונוויס',
      el: 'Άγιος Χριστόφορος και Νέβις',
      kk: 'Сент-Китс және Невис',
      ka: 'სენტ-კიტსი და ნევისი',
      th: 'เซนต์คิตส์และเนวิส',
    },
    phoneLength: 7,
    dialCode: '+1869',
    code: 'KN',
    flag: '🇰🇳',
  },
  {
    name: {
      en: 'Saint Lucia',
      ru: 'Санкт-Люсия',
      pl: 'święta Lucia',
      uk: 'Сент-Люсія',
      cs: 'Svatá Lucie',
      be: 'Святая Люсія',
      pt: 'Santa Lúcia',
      es: 'Santa Lucía',
      ro: 'Sfânta Lucia',
      bg: 'Сейнт Лусия',
      de: 'St. Lucia',
      fr: 'Sainte-Lucie',
      nl: 'Saint Lucia',
      it: 'Santa Lucia',
      cn: '圣卢西亚',
      zh: '聖盧西亞',
      et: 'Saint Lucia',
      ja: 'セントルシア',
      he: 'סנט לוסיה',
      el: 'Αγία Λουκία',
      kk: 'Сент-Люсия',
      ka: 'წმინდა ლუსია',
      th: 'เซนต์ลูเซีย',
    },
    phoneLength: 7,
    dialCode: '+1758',
    code: 'LC',
    flag: '🇱🇨',
  },
  {
    name: {
      en: 'Saint Pierre and Miquelon',
      ru: 'Сен-Пьер и Микелон',
      pl: 'Saint-Pierre i Miquelon',
      uk: "Сен-П'єр і Мікелон",
      cs: 'Svatý Pierre a Miquelon',
      be: "Сен-П'ер і Мікелон",
      pt: 'São Pedro e Miquelon',
      es: 'San Pedro y Miquelón',
      ro: 'Saint Pierre și Miquelon',
      bg: 'Сен Пиер и Микелон',
      de: 'Saint Pierre und Miquelon',
      fr: 'Saint-Pierre-et-Miquelon',
      nl: 'Saint Pierre en Miquelon',
      it: 'Saint Pierre e Miquelon',
      cn: '圣皮埃尔和密克隆群岛',
      zh: '聖皮埃爾和密克隆群島',
      et: 'Saint Pierre ja Miquelon',
      ja: 'サンピエール島とミクロン島',
      he: 'סנט פייר ומיקלון',
      el: 'Σεντ Πιέρ και Μικελόν',
      kk: 'Сен-Пьер және Микелон',
      ka: 'სენ-პიერი და მიკელონი',
      th: 'เซนต์ปีแยร์และมีเกอลง',
    },
    phoneLength: 6,
    dialCode: '+508',
    code: 'PM',
    flag: '🇵🇲',
  },
  {
    name: {
      en: 'Saint Vincent and the Grenadines',
      ru: 'Святой Винсент и Гренадины',
      pl: 'Saint Vincent i Grenadyny',
      uk: 'Сент-Вінсент і Гренадини',
      cs: 'Svatý Vincenc a Grenadiny',
      be: 'Сэнт-Вінсэнт і Грэнадыны',
      pt: 'São Vicente e Granadinas',
      es: 'San Vicente y las Granadinas',
      ro: 'Sfântul Vincent și Grenadine',
      bg: 'Сейнт Винсент и Гренадини',
      de: 'St. Vincent und die Grenadinen',
      fr: 'Saint-Vincent-et-les-Grenadines',
      nl: 'Saint Vincent en de Grenadines',
      it: 'Saint Vincent e Grenadine',
      cn: '圣文森特和格林纳丁斯',
      zh: '聖文森特和格林納丁斯',
      et: 'Saint Vincent ja Grenadiinid',
      ja: 'セントビンセントおよびグレナディーン諸島',
      he: 'סנט וינסנט והגרנדינים',
      el: 'Άγιος Βικέντιος και Γρεναδίνες',
      kk: 'Сент-Винсент және Гренадиндер',
      ka: 'სენტ-ვინსენტი და გრენადინები',
      th: 'เซนต์วินเซนต์และเกรนาดีนส์',
    },
    phoneLength: 7,
    dialCode: '+1784',
    code: 'VC',
    flag: '🇻🇨',
  },
  {
    name: {
      en: 'Samoa',
      ru: 'Самоа',
      pl: 'Samoa',
      uk: 'Самоа',
      cs: 'Samoa',
      be: 'Самоа',
      pt: 'Samoa',
      es: 'Samoa',
      ro: 'Samoa',
      bg: 'Самоа',
      de: 'Samoa',
      fr: 'Samoa',
      nl: 'Samoa',
      it: 'Samoa',
      cn: '萨摩亚',
      zh: '薩摩亞',
      et: 'Samoa',
      ja: 'サモア',
      he: 'סמואה',
      el: 'Σαμόα',
      kk: 'Самоа',
      ka: 'სამოა',
      th: 'ซามัว',
    },
    phoneLength: 7,
    dialCode: '+685',
    code: 'WS',
    flag: '🇼🇸',
  },
  {
    name: {
      en: 'San Marino',
      ru: 'Сан-Марино',
      pl: 'San Marino',
      uk: 'Сан-Марино',
      cs: 'San Marino',
      be: 'Сан-Марына',
      pt: 'São Marinho',
      es: 'San Marino',
      ro: 'San Marino',
      bg: 'Сан Марино',
      de: 'San Marino',
      fr: 'Saint Marin',
      nl: 'San Marino',
      it: 'San Marino',
      cn: '圣马力诺',
      zh: '聖馬力諾',
      et: 'San Marino',
      ja: 'サンマリノ',
      he: 'סן מרינו',
      el: 'Άγιος Μαρίνος',
      kk: 'Сан-Марино',
      ka: 'სან-მარინო',
      th: 'ซานมารีโน',
    },
    phoneLength: 6,
    dialCode: '+378',
    code: 'SM',
    flag: '🇸🇲',
  },
  {
    name: {
      en: 'Sao Tome and Principe',
      ru: 'Сан-Томе и Принсипи',
      pl: 'Wyspy Świętego Tomasza i Książęca',
      uk: 'Сан-Томе і Принсіпі',
      cs: 'Svatý Tomáš a Princův ostrov',
      be: 'Сан-Томе і Прынсіпі',
      pt: 'São Tomé e Príncipe',
      es: 'Santo Tomé y Príncipe',
      ro: 'Sao Tome și Principe',
      bg: 'Сао Томе и Принсипи',
      de: 'Sao Tome und Principe',
      fr: 'Sao Tomé et Principe',
      nl: 'Sao Tomé en Principe',
      it: 'Sao Tome e Principe',
      cn: '圣多美和普林西比',
      zh: '聖多美和普林西比',
      et: 'Sao Tome ja Principe',
      ja: 'サントメ・プリンシペ',
      he: 'סאו טומה ופרינסיפה',
      el: 'Σάο Τομέ και Πρίνσιπε',
      kk: 'Сан-Томе және Принсипи',
      ka: 'სან-ტომე და პრინსიპი',
      th: 'เซาตูเมและปรินซีปี',
    },
    phoneLength: 7,
    dialCode: '+239',
    code: 'ST',
    flag: '🇸🇹',
  },
  {
    name: {
      en: 'Saudi Arabia',
      ru: 'Саудовская Аравия',
      pl: 'Arabia Saudyjska',
      uk: 'Саудівська Аравія',
      cs: 'Saudská arábie',
      be: 'Саўдаўская Аравія',
      pt: 'Arábia Saudita',
      es: 'San Vicente y las Granadinas',
      ro: 'Arabia Saudită',
      bg: 'Саудитска Арабия',
      de: 'Saudi-Arabien',
      fr: 'Arabie Saoudite',
      nl: 'Saoedi-Arabië',
      it: 'Arabia Saudita',
      cn: '沙特阿拉伯',
      zh: '沙特阿拉伯',
      et: 'Saudi Araabia',
      ja: 'サウジアラビア',
      he: 'ערב הסעודית',
      el: 'Σαουδική Αραβία',
      kk: 'Сауд Арабиясы',
      ka: 'საუდის არაბეთი',
      th: 'ซาอุดีอาระเบีย',
    },
    phoneLength: 9,
    dialCode: '+966',
    code: 'SA',
    flag: '🇸🇦',
  },
  {
    name: {
      en: 'Senegal',
      ru: 'Сенегал',
      pl: 'Senegal',
      uk: 'Сенегал',
      cs: 'Senegal',
      be: 'Сенегал',
      pt: 'Senegal',
      es: 'Senegal',
      ro: 'Senegal',
      bg: 'Сенегал',
      de: 'Senegal',
      fr: 'Sénégal',
      nl: 'Senegal',
      it: 'Senegal',
      cn: '塞内加尔',
      zh: '塞內加爾',
      et: 'Senegal',
      ja: 'セネガル',
      he: 'סנגל',
      el: 'Σενεγάλη',
      kk: 'Сенегал',
      ka: 'სენეგალი',
      th: 'เซเนกัล',
    },
    phoneLength: 9,
    dialCode: '+221',
    code: 'SN',
    flag: '🇸🇳',
  },
  {
    name: {
      en: 'Serbia',
      ru: 'Сербия',
      pl: 'Serbia',
      uk: 'Сербія',
      cs: 'Srbsko',
      be: 'Сербія',
      pt: 'Sérvia',
      es: 'Serbia',
      ro: 'Serbia',
      bg: 'Сърбия',
      de: 'Serbien',
      fr: 'Serbie',
      nl: 'Servië',
      it: 'Serbia',
      cn: '塞尔维亚',
      zh: '塞爾維亞',
      et: 'Serbia',
      ja: 'セルビア',
      he: 'סרביה',
      el: 'Σερβία',
      kk: 'Сербия',
      ka: 'სერბეთი',
      th: 'เซอร์เบีย',
    },
    phoneLength: 8,
    dialCode: '+381',
    code: 'RS',
    flag: '🇷🇸',
  },
  {
    name: {
      en: 'Seychelles',
      ru: 'Сейшельские острова',
      pl: 'Seszele',
      uk: 'Сейшельські острови',
      cs: 'Seychely',
      be: 'Сейшэльскія астравы',
      pt: 'Seicheles',
      es: 'Seychelles',
      ro: 'Seychelles',
      bg: 'Сейшелски острови',
      de: 'Seychellen',
      fr: 'les Seychelles',
      nl: 'Seychellen',
      it: 'Seychelles',
      cn: '塞舌尔',
      zh: '塞舌爾',
      et: 'Seišellid',
      ja: 'セイシェル',
      he: 'איי סיישל',
      el: 'Σεϋχέλλες',
      kk: 'Сейшел аралдары',
      ka: 'სეიშელი',
      th: 'เซเชลส์',
    },
    phoneLength: 7,
    dialCode: '+248',
    code: 'SC',
    flag: '🇸🇨',
  },
  {
    name: {
      en: 'Sierra Leone',
      ru: 'Сьерра-Леоне',
      pl: 'Sierra Leone',
      uk: 'Сьєрра-Леоне',
      cs: 'Sierra Leone',
      be: 'Сьера-Леонэ',
      pt: 'Serra Leoa',
      es: 'Sierra Leona',
      ro: 'Sierra Leone',
      bg: 'Сиера Леоне',
      de: 'Sierra Leone',
      fr: 'Sierra Leone',
      nl: 'Sierra Leone',
      it: 'Sierra Leone',
      cn: '塞拉利昂',
      zh: '塞拉利昂',
      et: 'Sierra Leone',
      ja: 'シエラレオネ',
      he: 'סיירה לאון',
      el: 'Σιέρα Λεόνε',
      kk: 'Сьерра-Леоне',
      ka: 'სიერა-ლეონე',
      th: 'เซียร์ราลีโอน',
    },
    phoneLength: 8,
    dialCode: '+232',
    code: 'SL',
    flag: '🇸🇱',
  },
  {
    name: {
      en: 'Singapore',
      ru: 'Сингапур',
      pl: 'Singapur',
      uk: 'Сінгапур',
      cs: 'Singapur',
      be: 'Сінгапур',
      pt: 'Singapura',
      es: 'Singapur',
      ro: 'Singapore',
      bg: 'Сингапур',
      de: 'Singapur',
      fr: 'Singapour',
      nl: 'Singapore',
      it: 'Singapore',
      cn: '新加坡',
      zh: '新加坡',
      et: 'Singapur',
      ja: 'シンガポール',
      he: 'סינגפור',
      el: 'Σιγκαπούρη',
      kk: 'Сингапур',
      ka: 'სინგაპური',
      th: 'สิงคโปร์',
    },
    phoneLength: 8,
    dialCode: '+65',
    code: 'SG',
    flag: '🇸🇬',
  },
  {
    name: {
      en: 'Slovakia',
      ru: 'Словакия',
      pl: 'Słowacja',
      uk: 'Словаччина',
      cs: 'Slovensko',
      be: 'Славакія',
      pt: 'Eslováquia',
      es: 'Eslovaquia',
      ro: 'Slovacia',
      bg: 'Словакия',
      de: 'Slowakei',
      fr: 'Slovaquie',
      nl: 'Slowakije',
      it: 'Slovacchia',
      cn: '斯洛伐克',
      zh: '斯洛伐克',
      et: 'Slovakkia',
      ja: 'スロバキア',
      he: 'סלובקיה',
      el: 'Σλοβακία',
      kk: 'Словакия',
      ka: 'სლოვაკეთი',
      th: 'สโลวะเกีย',
    },
    phoneLength: 9,
    dialCode: '+421',
    code: 'SK',
    flag: '🇸🇰',
  },
  {
    name: {
      en: 'Slovenia',
      ru: 'Словения',
      pl: 'Słowenia',
      uk: 'Словенія',
      cs: 'Slovinsko',
      be: 'Славенія',
      pt: 'Eslovénia',
      es: 'Eslovenia',
      ro: 'Slovenia',
      bg: 'Словения',
      de: 'Slowenien',
      fr: 'Slovénie',
      nl: 'Slovenië',
      it: 'Slovenia',
      cn: '斯洛文尼亚',
      zh: '斯洛文尼亞',
      et: 'Sloveenia',
      ja: 'スロベニア',
      he: 'סלובניה',
      el: 'Σλοβενία',
      kk: 'Словения',
      ka: 'სლოვენია',
      th: 'สโลวีเนีย',
    },
    phoneLength: 8,
    dialCode: '+386',
    code: 'SI',
    flag: '🇸🇮',
  },
  {
    name: {
      en: 'Solomon Islands',
      ru: 'Соломоновы острова',
      pl: 'Wyspy Salomona',
      uk: 'Соломонові острови',
      cs: 'Solomonovy ostrovy',
      be: 'Саламонавы астравы',
      pt: 'Ilhas Salomão',
      es: 'Islas Salomón',
      ro: 'Insulele Solomon',
      bg: 'Соломонови острови',
      de: 'Salomon-Inseln',
      fr: 'Les îles Salomon',
      nl: 'Solomon eilanden',
      it: 'Isole Salomone',
      cn: '所罗门群岛',
      zh: '所羅門群島',
      et: 'Saalomoni Saared',
      ja: 'ソロモン諸島',
      he: 'איי שלמה',
      el: 'Νησιά Σολομώντα',
      kk: 'Соломон аралдары',
      ka: 'სოლომონის კუნძულები',
      th: 'หมู่เกาะโซโลมอน',
    },
    phoneLength: 7,
    dialCode: '+677',
    code: 'SB',
    flag: '🇸🇧',
  },
  {
    name: {
      en: 'Somalia',
      ru: 'Сомали',
      pl: 'Somali',
      uk: 'Сомалі',
      cs: 'Somálsko',
      be: 'Самалі',
      pt: 'Somália',
      es: 'Somalia',
      ro: 'Somalia',
      bg: 'Сомалия',
      de: 'Somalia',
      fr: 'Somalie',
      nl: 'Somalië',
      it: 'Somalia',
      cn: '索马里',
      zh: '索馬里',
      et: 'Somaalia',
      ja: 'ソマリア',
      he: 'סומליה',
      el: 'Σομαλία',
      kk: 'Сомали',
      ka: 'სომალი',
      th: 'โซมาเลีย',
    },
    phoneLength: 7,
    dialCode: '+252',
    code: 'SO',
    flag: '🇸🇴',
  },
  {
    name: {
      en: 'South Africa',
      ru: 'Южная Африка',
      pl: 'Afryka Południowa',
      uk: 'Південна Африка',
      cs: 'Jižní Afrika',
      be: 'Паўднёвая Афрыка',
      pt: 'África do Sul',
      es: 'Sudáfrica',
      ro: 'Africa de Sud',
      bg: 'Южна Африка',
      de: 'Südafrika',
      fr: 'Afrique du Sud',
      nl: 'Zuid-Afrika',
      it: 'Sud Africa',
      cn: '南非',
      zh: '南非',
      et: 'Lõuna-Aafrika',
      ja: '南アフリカ',
      he: 'דרום אפריקה',
      el: 'Νότια Αφρική',
      kk: 'Әулие Африка',
      ka: 'სამხრეთ აფრიკა',
      th: 'แอฟริกาใต้',
    },
    phoneLength: 9,
    dialCode: '+27',
    code: 'ZA',
    flag: '🇿🇦',
  },
  {
    name: {
      en: 'South Georgia and the South Sandwich Islands',
      ru: 'Южная Георгия и Южные Сандвичевы острова',
      pl: 'Georgia Południowa i Sandwich Południowy',
      uk: 'Південна Джорджія та Південні Сандвічеві острови',
      cs: 'Jižní Georgie a Jižní Sandwichovy ostrovy',
      be: 'Паўднёвая Джорджыя і Паўднёвыя Сандвічавы астравы',
      pt: 'Geórgia do Sul e Sandwich do Sul',
      es: 'Georgia del Sur y las Islas Sandwich del Sur',
      ro: 'Georgia de Sud și Insulele Sandwich de Sud',
      bg: 'Южна Джорджия и Южните сандвичеви острови',
      de: 'Süd-Georgien und die südlichen Sandwich-Inseln',
      fr: 'Géorgie du Sud et îles Sandwich du Sud',
      nl: 'Zuid-Georgië en de Zuidelijke Sandwicheilanden',
      it: 'Georgia del Sud e isole Sandwich meridionali',
      cn: '南乔治亚岛和南桑威奇群岛',
      zh: '南喬治亞島和南桑威奇群島',
      et: 'Lõuna-Georgia ja Lõuna-Sandwichi saared',
      ja: 'サウスジョージア島とサウスサンドイッチ諸島',
      he: "דרום ג'ורג'יה ואיי סנדוויץ' הדרומיים",
      el: 'Νότιος Γεωργία και Νότιοι Νήσοι Σάντουιτς',
      kk: 'South Georgia and the South Sandwich Islands',
      ka: 'სამხრეთ ჯამხარა და სამხრეთ სენდვიჩის კუნძულები',
      th: 'เกาะเซาท์จอร์เจียและหมู่เกาะซานด์วิช',
    },
    phoneLength: 5,
    dialCode: '+500',
    code: 'GS',
    flag: '🇬🇸',
  },
  {
    name: {
      en: 'Spain',
      ru: 'Испания',
      pl: 'Hiszpania',
      uk: 'Іспанія',
      cs: 'Španělsko',
      be: 'Іспанія',
      pt: 'Espanha',
      es: 'España',
      ro: 'Spania',
      bg: 'Испания',
      de: 'Spanien',
      fr: 'Espagne',
      nl: 'Spanje',
      it: 'Spagna',
      cn: '西班牙',
      zh: '西班牙',
      et: 'Hispaania',
      ja: 'スペイン',
      he: 'ספרד',
      el: 'Ισπανία',
      kk: 'Испания',
      ka: 'ესპანეთი',
      th: 'สเปน',
    },
    phoneLength: 9,
    dialCode: '+34',
    code: 'ES',
    flag: '🇪🇸',
  },
  {
    name: {
      en: 'Sri Lanka',
      ru: 'Шри-Ланка',
      pl: 'Sri Lanka',
      uk: 'Шрі Ланка',
      cs: 'Srí Lanka',
      be: 'Шры Ланка',
      pt: 'Sri Lanca',
      es: 'Sri Lanka',
      ro: 'Sri Lanka',
      bg: 'Шри Ланка',
      de: 'Sri Lanka',
      fr: 'Sri Lanka',
      nl: 'Sri Lanka',
      it: 'Sri Lanka',
      cn: '斯里兰卡',
      zh: '斯里蘭卡',
      et: 'Sri Lanka',
      ja: 'スリランカ',
      he: 'סרי לנקה',
      el: 'Σρι Λάνκα',
      kk: 'Шри-Ланка',
      ka: 'შრი-ლანკა',
      th: 'ศรีลังกา',
    },
    phoneLength: 9,
    dialCode: '+94',
    code: 'LK',
    flag: '🇱🇰',
  },
  {
    name: {
      en: 'Sudan',
      ru: 'Судан',
      pl: 'Sudan',
      uk: 'Судан',
      cs: 'Súdán',
      be: 'Судан',
      pt: 'Sudão',
      es: 'Sudán',
      ro: 'Sudan',
      bg: 'Судан',
      de: 'Sudan',
      fr: 'Soudan',
      nl: 'Soedan',
      it: 'Sudan',
      cn: '苏丹',
      zh: '蘇丹',
      et: 'Sudaan',
      ja: 'スーダン',
      he: 'סודן',
      el: 'Σουδάν',
      kk: 'Судан',
      ka: 'სუდანი',
      th: 'ซูดาน',
    },
    phoneLength: 9,
    dialCode: '+249',
    code: 'SD',
    flag: '🇸🇩',
  },
  {
    name: {
      en: 'Suriname',
      ru: 'Суринам',
      pl: 'Surinam',
      uk: 'Суринам',
      cs: 'Surinam',
      be: 'Сурынам',
      pt: 'Suriname',
      es: 'Surinam',
      ro: 'Surinam',
      bg: 'Суринам',
      de: 'Suriname',
      fr: 'Suriname',
      nl: 'Suriname',
      it: 'Suriname',
      cn: '苏里南',
      zh: '蘇裡南',
      et: 'Suriname',
      ja: 'スリナム',
      he: 'סורינאם',
      el: 'Σουρινάμ',
      kk: 'Суринам',
      ka: 'სურინამი',
      th: 'ซูรินาเม',
    },
    phoneLength: 7,
    dialCode: '+597',
    code: 'SR',
    flag: '🇸🇷',
  },
  {
    name: {
      en: 'Svalbard and Jan Mayen',
      ru: 'Шпицберген и Ян Майен',
      pl: 'Svalbard i Jan Mayen',
      uk: 'Шпіцберген та Ян Маєн',
      cs: 'Špicberky a Jan Mayen',
      be: 'Шпіцберген і Ян Маен',
      pt: 'Svalbard e Jan Mayen',
      es: 'Svalbard y Jan Mayen',
      ro: 'Svalbard și Jan Mayen',
      bg: 'Шпицберген и Ян Майен',
      de: 'Spitzbergen und Jan Mayen',
      fr: 'Svalbard et Jan Mayen',
      nl: 'Svalbard en Jan Mayen',
      it: 'Svalbard e Jan Mayen',
      cn: '斯瓦尔巴和扬·马延',
      zh: '斯瓦爾巴和揚·馬延',
      et: 'Svalbard ja Jan Mayen',
      ja: 'スバールバル諸島およびヤンマイエン',
      he: 'סבאלברד ויאן מאין',
      el: 'Σβάλμπαρντ και Γιαν Μάγεν',
      kk: 'Шпицберген және Ян-Майен',
      ka: 'სვალბარდი და იან-მაიენი',
      th: 'สฟาลบาร์และยานไมเอน',
    },
    phoneLength: 8,
    dialCode: '+47',
    code: 'SJ',
    flag: '🇸🇯',
  },
  {
    name: {
      en: 'Eswatini',
      ru: 'Эсватини',
      pl: 'Eswatini',
      uk: 'Есватіні',
      cs: 'Svazijsko',
      be: 'Эсватыні',
      pt: 'Eswatini',
      es: 'Eswatini',
      ro: 'Eswatini',
      bg: 'Есватини',
      de: 'Eswatini',
      fr: 'Eswatini',
      nl: 'Eswatini',
      it: 'Eswatini',
      cn: '斯威士兰',
      zh: '斯威士兰',
      et: 'Eswatini',
      ja: 'エスワティニ',
      he: 'סווזילנד',
      el: 'Εσουατίνι',
      kk: 'Эсватини',
      ka: 'ესვატინი',
      th: 'เอสวาตีนี',
    },
    phoneLength: 8,
    dialCode: '+268',
    code: 'SZ',
    flag: '🇸🇿',
  },
  {
    name: {
      en: 'Sweden',
      ru: 'Швеция',
      pl: 'Szwecja',
      uk: 'Швеція',
      cs: 'Švédsko',
      be: 'Швецыя',
      pt: 'Suécia',
      es: 'Suecia',
      ro: 'Suedia',
      bg: 'Швеция',
      de: 'Schweden',
      fr: 'Suède',
      nl: 'Zweden',
      it: 'Svezia',
      cn: '瑞典',
      zh: '瑞典',
      et: 'Rootsi',
      ja: 'スウェーデン',
      he: 'שבדיה',
      el: 'Σουηδία',
      kk: 'Швеция',
      ka: 'შვედეთი',
      th: 'สวีเดน',
    },
    phoneLength: 9,
    dialCode: '+46',
    code: 'SE',
    flag: '🇸🇪',
  },
  {
    name: {
      en: 'Switzerland',
      ru: 'Швейцария',
      pl: 'Szwajcaria',
      uk: 'Швейцарія',
      cs: 'Švýcarsko',
      be: 'Швейцарыя',
      pt: 'Suíça',
      es: 'Suiza',
      ro: 'Elveţia',
      bg: 'Швейцария',
      de: 'Schweiz',
      fr: 'la Suisse',
      nl: 'Zwitserland',
      it: 'Svizzera',
      cn: '瑞士',
      zh: '瑞士',
      et: 'Šveits',
      ja: 'スイス',
      he: 'שוויץ',
      el: 'Ελβετία',
      kk: 'Швейцария',
      ka: 'შვეიცარია',
      th: 'สวิตเซอร์แลนด์',
    },
    phoneLength: 9,
    dialCode: '+41',
    code: 'CH',
    flag: '🇨🇭',
  },
  {
    name: {
      en: 'Syrian Arab Republic',
      ru: 'Сирийская Арабская Республика',
      pl: 'Republika Syryjsko-Arabska',
      uk: 'Сирійська Арабська Республіка',
      cs: 'Syrská Arabská republika',
      be: 'Сірыйская Арабская Рэспубліка',
      pt: 'Síria',
      es: 'República Árabe Siria',
      ro: 'Republica Araba Siriana',
      bg: 'Сирийска Арабска Република',
      de: 'Syrische Arabische Republik',
      fr: 'République arabe syrienne',
      nl: 'Syrische Arabische Republiek',
      it: 'Repubblica Araba Siriana',
      cn: '阿拉伯叙利亚共和国',
      zh: '阿拉伯敘利亞共和國',
      et: 'Süüria Araabia Vabariik',
      ja: 'シリアアラブ共和国',
      he: 'סוריה',
      el: 'Συρία',
      kk: 'Сирия Араб Республикасы',
      ka: 'სირიის არაბთა რესპუბლიკა',
      th: 'สาธารณรัฐอาหรับซีเรีย',
    },
    phoneLength: 9,
    dialCode: '+963',
    code: 'SY',
    flag: '🇸🇾',
  },
  {
    name: {
      en: 'Taiwan',
      ru: 'Тайвань',
      pl: 'Tajwan',
      uk: 'Тайвань',
      cs: 'Tchaj-wan',
      be: 'Тайвань',
      pt: 'Taiwan',
      es: 'Taiwán',
      ro: 'Taiwan',
      bg: 'Тайван',
      de: 'Taiwan',
      fr: 'Taïwan',
      nl: 'Taiwan',
      it: 'Taiwan',
      cn: '台湾',
      zh: '台灣',
      et: 'Taiwan',
      ja: '台湾',
      he: 'טייוואן',
      el: 'Ταϊβάν',
      kk: 'Тайвань',
      ka: 'ტაივანი',
      th: 'ไต้หวัน',
    },
    phoneLength: 9,
    dialCode: '+886',
    code: 'TW',
    flag: '🇹🇼',
  },
  {
    name: {
      en: 'Tajikistan',
      ru: 'Таджикистан',
      pl: 'Tadżykistan',
      uk: 'Таджикистан',
      cs: 'Tádžikistán',
      be: 'Таджыкістан',
      pt: 'Tajiquistão',
      es: 'Tayikistán',
      ro: 'Tadjikistan',
      bg: 'Таджикистан',
      de: 'Tadschikistan',
      fr: 'Tadjikistan',
      nl: 'Tadzjikistan',
      it: 'Tagikistan',
      cn: '塔吉克斯坦',
      zh: '塔吉克斯坦',
      et: 'Tadžikistan',
      ja: 'タジキスタン',
      he: "טג'יקיסטן",
      el: 'Τατζικιστάν',
      kk: 'Тоҷикистон',
      ka: 'ტაჯიკეთი',
      th: 'ประเทศทาจิกิสถาน',
    },
    phoneLength: 9,
    dialCode: '+992',
    code: 'TJ',
    flag: '🇹🇯',
  },
  {
    name: {
      en: 'Tanzania',
      ru: 'Танзания',
      pl: 'Tanzania',
      uk: 'Танзанія',
      cs: 'Tanzanie',
      be: 'Танзанія',
      pt: 'Tanzânia',
      es: 'Tanzania',
      ro: 'Tanzania',
      bg: 'Танзания',
      de: 'Tansania',
      fr: 'Tanzanie',
      nl: 'Tanzania',
      it: 'Tanzania',
      cn: '坦桑尼亚',
      zh: '坦桑尼亚',
      et: 'Tansaania',
      ja: 'タンザニア',
      he: 'טנזניה',
      el: 'Τανζανία',
      kk: 'Танзания',
      ka: 'ტანზანია',
      th: 'ประเทศแทนซาเนีย',
    },
    phoneLength: 9,
    dialCode: '+255',
    code: 'TZ',
    flag: '🇹🇿',
  },
  {
    name: {
      en: 'Thailand',
      ru: 'Таиланд',
      pl: 'Tajlandia',
      uk: 'Таїланд',
      cs: 'Thajsko',
      be: 'Тайланд',
      pt: 'Tailândia',
      es: 'Tailandia',
      ro: 'Tailanda',
      bg: 'Тайланд',
      de: 'Thailand',
      fr: 'Thaïlande',
      nl: 'Thailand',
      it: 'Tailandia',
      cn: '泰国',
      zh: '泰國',
      et: 'Tai',
      ja: 'タイ',
      he: 'תאילנד',
      el: 'Ταϊλάνδη',
      kk: 'Таиланд',
      ka: 'ტაილანდი',
      th: 'ประเทศไทย',
    },
    phoneLength: 9,
    dialCode: '+66',
    code: 'TH',
    flag: '🇹🇭',
  },
  {
    name: {
      en: 'Timor-Leste',
      ru: 'Восточный Тимор',
      pl: 'Timor Wschodni',
      uk: 'Восточний Тимор',
      cs: 'Východní Timor',
      be: 'Востраў Тымор',
      pt: 'Timor Leste',
      es: 'Timor-Leste',
      ro: 'Timor-Leste',
      bg: 'Тимор-Лешти',
      de: 'Timor-Leste',
      fr: 'Timor-Leste',
      nl: 'Oost-Timor',
      it: 'Timor-Leste',
      cn: '东帝汶',
      zh: '東帝汶',
      et: 'Ida-Timor',
      ja: '東ティモール',
      he: 'טימור-לסטה',
      el: 'Ανατολικό Τιμόρ',
      kk: 'Тимор-Лешти',
      ka: 'ტიმორ-ლესტე',
      th: 'ติมอร์เลสเต',
    },
    phoneLength: 8,
    dialCode: '+670',
    code: 'TL',
    flag: '🇹🇱',
  },
  {
    name: {
      en: 'Togo',
      ru: 'Того',
      pl: 'Togo',
      uk: 'Того',
      cs: 'Togo',
      be: 'Ісці',
      pt: 'Togo',
      es: 'Togo',
      ro: 'A merge',
      bg: 'Да отида',
      de: 'Gehen',
      fr: 'Aller',
      nl: 'Gaan',
      it: 'Andare',
      cn: '多哥',
      zh: '多哥',
      et: 'Minema',
      ja: 'トーゴ',
      he: 'טוגו',
      el: 'Τόγκο',
      kk: 'Того',
      ka: 'ტოგო',
      th: 'ไป',
    },
    phoneLength: 8,
    dialCode: '+228',
    code: 'TG',
    flag: '🇹🇬',
  },
  {
    name: {
      en: 'Tokelau',
      ru: 'Токелау',
      pl: 'Tokelau',
      uk: 'Токелау',
      cs: 'Tokelau',
      be: 'Такелаў',
      pt: 'Tokelau',
      es: 'Tokelau',
      ro: 'Tokelau',
      bg: 'Токелау',
      de: 'Tokelau',
      fr: 'Tokelau',
      nl: 'Tokelau',
      it: 'Tokelau',
      cn: '托克劳',
      zh: '托克勞',
      et: 'Tokelau',
      ja: 'トケラウ',
      he: 'טוקלאו',
      el: 'Τοκελάου',
      kk: 'Токелау',
      ka: 'ტოკელაუ',
      th: 'โตเกเลา',
    },
    phoneLength: 5,
    dialCode: '+690',
    code: 'TK',
    flag: '🇹🇰',
  },
  {
    name: {
      en: 'Tonga',
      ru: 'Тонга',
      pl: 'Tonga',
      uk: 'Тонга',
      cs: 'Tonga',
      be: 'Тонга',
      pt: 'Tonga',
      es: 'Tonga',
      ro: 'Tonga',
      bg: 'Тонга',
      de: 'Tonga',
      fr: 'Tonga',
      nl: 'Tonga',
      it: 'Tonga',
      cn: '汤加',
      zh: '湯加',
      et: 'Tonga',
      ja: 'トンガ',
      he: 'טונגה',
      el: 'Τόνγκα',
      kk: 'Тонга',
      ka: 'ტონგა',
      th: 'ตองกา',
    },
    phoneLength: 5,
    dialCode: '+676',
    code: 'TO',
    flag: '🇹🇴',
  },
  {
    name: {
      en: 'Trinidad and Tobago',
      ru: 'Тринидад и Тобаго',
      pl: 'Trynidad i Tobago',
      uk: 'Тринідад і Тобаго',
      cs: 'Trinidad a Tobago',
      be: 'Трынідад і Табага',
      pt: 'Trindade e Tobago',
      es: 'Trinidad y Tobago',
      ro: 'Trinidad și Tobago',
      bg: 'Тринидад и Тобаго',
      de: 'Trinidad und Tobago',
      fr: 'Trinité-et-Tobago',
      nl: 'Trinidad en Tobago',
      it: 'Trinidad e Tobago',
      cn: '特立尼达和多巴哥',
      zh: '特立尼達和多巴哥',
      et: 'Trinidad ja Tobago',
      ja: 'トリニダード・トバゴ',
      he: 'טרינידד וטובגו',
      el: 'Τρίνινταντ και Tομπάγκο',
      kk: 'Тринидад және Тобаго',
      ka: 'ტრინიდადი და ტობაგო',
      th: 'ตรินิแดดและโตเบโก',
    },
    phoneLength: 7,
    dialCode: '+1868',
    code: 'TT',
    flag: '🇹🇹',
  },
  {
    name: {
      en: 'Tunisia',
      ru: 'Тунис',
      pl: 'Tunezja',
      uk: 'Туніс',
      cs: 'Tunisko',
      be: 'Туніс',
      pt: 'Tunísia',
      es: 'Túnez',
      ro: 'Tunisia',
      bg: 'Тунис',
      de: 'Tunesien',
      fr: 'Tunisie',
      nl: 'Tunesië',
      it: 'Tunisia',
      cn: '突尼斯',
      zh: '突尼斯',
      et: 'Tuneesia',
      ja: 'チュニジア',
      he: 'תוניסיה',
      el: 'Τυνησία',
      kk: 'Тунис',
      ka: 'ტუნისი',
      th: 'ตูนิเซีย',
    },
    phoneLength: 8,
    dialCode: '+216',
    code: 'TN',
    flag: '🇹🇳',
  },
  {
    name: {
      en: 'Turkey',
      ru: 'Турция',
      pl: 'Turcja',
      uk: 'Туреччина',
      cs: 'Turecko',
      be: 'Турцыя',
      pt: 'Turquia',
      es: 'Turquía',
      ro: 'Curcan',
      bg: 'Турция',
      de: 'Türkei',
      fr: 'dinde',
      nl: 'kalkoen',
      it: 'tacchino',
      cn: '火鸡',
      zh: '火雞',
      et: 'Türgi',
      ja: '七面鳥',
      he: 'טורקיה',
      el: 'Τουρκία',
      kk: 'Түркия',
      ka: 'თურქეთი',
      th: 'ไก่งวง',
    },
    phoneLength: 10,
    dialCode: '+90',
    code: 'TR',
    flag: '🇹🇷',
  },
  {
    name: {
      en: 'Turkmenistan',
      ru: 'Туркменистан',
      pl: 'Turkmenia',
      uk: 'Туркменістан',
      cs: 'Turkmenistán',
      be: 'Туркменістан',
      pt: 'Turquemenistão',
      es: 'Turkmenistán',
      ro: 'Turkmenistan',
      bg: 'Туркменистан',
      de: 'Turkmenistan',
      fr: 'Turkménistan',
      nl: 'Turkmenistan',
      it: 'Turkmenistan',
      cn: '土库曼斯坦',
      zh: '土庫曼斯坦',
      et: 'Türkmenistan',
      ja: 'トルクメニスタン',
      he: 'טורקמניסטן',
      el: 'Τουρκμενιστάν',
      kk: 'Түркменистан',
      ka: 'თურქმენეთი',
      th: 'เติร์กเมนิสถาน',
    },
    phoneLength: 8,
    dialCode: '+993',
    code: 'TM',
    flag: '🇹🇲',
  },
  {
    name: {
      en: 'Turks and Caicos Islands',
      ru: 'Острова Теркс и Кайкос',
      pl: 'Wyspy Turks i Caicos',
      uk: 'Острови Теркс і Кайкос',
      cs: 'ostrovy Turks a Cacois',
      be: 'Астравы Тэркс і Кайкас',
      pt: 'Ilhas Turcas e Caicos',
      es: 'Islas Turcas y Caicos',
      ro: 'Insulele Turks și Caicos',
      bg: 'Острови Търкс и Кайкос',
      de: 'Turks- und Caicosinseln',
      fr: 'îles Turques-et-Caïques',
      nl: 'Turks- en Caicoseilanden',
      it: 'Isole Turks e Caicos',
      cn: '特克斯和凯科斯群岛',
      zh: '特克斯和凱科斯群島',
      et: 'Turksi ja Caicose saared',
      ja: 'タークス・カイコス諸島',
      he: 'איי טורקס וקאיקוס',
      el: 'Νήσοι Τουρκ και Κάικος',
      kk: 'Теркс және Кайкос аралдары',
      ka: 'ტერქსის და კაიკოსის კუნძულები',
      th: 'หมู่เกาะเติร์กส์และคาคอส',
    },
    phoneLength: 7,
    dialCode: '+1649',
    code: 'TC',
    flag: '🇹🇨',
  },
  {
    name: {
      en: 'Tuvalu',
      ru: 'Тувалу',
      pl: 'Tuvalu',
      uk: 'Тувалу',
      cs: 'Tuvalu',
      be: 'Тувалу',
      pt: 'Tuvalu',
      es: 'Tuvalu',
      ro: 'Tuvalu',
      bg: 'Тувалу',
      de: 'Tuvalu',
      fr: 'Tuvalu',
      nl: 'Tuvalu',
      it: 'Tuvalu',
      cn: '图瓦卢',
      zh: '圖瓦盧',
      et: 'Tuvalu',
      ja: 'ツバル',
      he: 'טובאלו',
      el: 'Τουβαλού',
      kk: 'Тувалу',
      ka: 'ტუვალუ',
      th: 'ตูวาลู',
    },
    phoneLength: 7,
    dialCode: '+688',
    code: 'TV',
    flag: '🇹🇻',
  },
  {
    name: {
      en: 'Uganda',
      ru: 'Уганда',
      pl: 'Uganda',
      uk: 'Уганда',
      cs: 'Uganda',
      be: 'Уганда',
      pt: 'Uganda',
      es: 'Uganda',
      ro: 'Uganda',
      bg: 'Уганда',
      de: 'Uganda',
      fr: 'Ouganda',
      nl: 'Oeganda',
      it: 'Uganda',
      cn: '乌干达',
      zh: '烏干達',
      et: 'Uganda',
      ja: 'ウガンダ',
      he: 'אוגנדה',
      el: 'Ουγκάντα',
      kk: 'Уганда',
      ka: 'უგანდა',
      th: 'ยูกันดา',
    },
    phoneLength: 9,
    dialCode: '+256',
    code: 'UG',
    flag: '🇺🇬',
  },
  {
    name: {
      en: 'Ukraine',
      ru: 'Украина',
      pl: 'Ukraina',
      uk: 'Україна',
      cs: 'Ukrajina',
      be: 'Украіна',
      pt: 'Ucrânia',
      es: 'Ucrania',
      ro: 'Ucraina',
      bg: 'Украйна',
      de: 'Ukraine',
      fr: 'Ukraine',
      nl: 'Oekraïne',
      it: 'Ucraina',
      cn: '乌克兰',
      zh: '烏克蘭',
      et: 'Ukraina',
      ja: 'ウクライナ',
      he: 'אוקראינה',
      el: 'Ουκρανία',
      kk: 'Украина',
      ka: 'უკრაინა',
      th: 'ยูเครน',
    },
    phoneLength: 9,
    dialCode: '+380',
    code: 'UA',
    flag: '🇺🇦',
  },
  {
    name: {
      en: 'United Arab Emirates',
      ru: 'Объединенные Арабские Эмираты',
      pl: 'Zjednoczone Emiraty Arabskie',
      uk: "Об'єднані Арабські Емірати",
      cs: 'Spojené arabské emiráty',
      be: "Аб'яднаныя Арабскія Эміраты",
      pt: 'Emirados Árabes Unidos',
      es: 'Emiratos Árabes Unidos',
      ro: 'Emiratele Arabe Unite',
      bg: 'Обединени арабски емирства',
      de: 'Vereinigte Arabische Emirate',
      fr: 'Émirats arabes unis',
      nl: 'Verenigde Arabische Emiraten',
      it: 'Emirati Arabi Uniti',
      cn: '阿联酋',
      zh: '阿拉伯联合酋长国',
      et: 'Araabia Ühendemiraadid',
      ja: 'アラブ首長国連邦',
      he: 'איחוד האמירויות הערביות',
      el: 'Ηνωμένα Αραβικά Εμιράτα',
      kk: 'Біріккен Араб Әмірліктері',
      ka: 'არაბეთის ემირატები',
      th: 'สหรัฐอาหรับเอมิเรตส์',
    },
    phoneLength: 9,
    dialCode: '+971',
    code: 'AE',
    flag: '🇦🇪',
  },
  {
    name: {
      en: 'United Kingdom',
      ru: 'Объединенное Королевство',
      pl: 'Zjednoczone Królestwo',
      uk: "Об'єднане Королівство",
      cs: 'Spojené království',
      be: 'Злучанае Каралеўства',
      pt: 'Reino Unido',
      es: 'Reino Unido',
      ro: 'Regatul Unit',
      bg: 'Великобритания',
      de: 'Vereinigtes Königreich',
      fr: 'Royaume-Uni',
      nl: 'Verenigd Koningkrijk',
      it: 'Regno Unito',
      cn: '英国',
      zh: '英國',
      et: 'Ühendkuningriik',
      ja: 'イギリス',
      he: 'הממלכה המאוחדת',
      el: 'Ηνωμένο Βασίλειο',
      kk: 'Біріккен Корольдік',
      ka: 'დიდი ბრიტანეთი',
      th: 'สหราชอาณาจักร',
    },
    phoneLength: 10,
    dialCode: '+44',
    code: 'GB',
    flag: '🇬🇧',
  },
  {
    name: {
      en: 'United States',
      ru: 'Соединенные Штаты',
      pl: 'Stany Zjednoczone',
      uk: 'Сполучені Штати',
      cs: 'Spojené státy',
      be: 'Злучаныя Штаты',
      pt: 'Estados Unidos',
      es: 'Estados Unidos',
      ro: 'Statele Unite',
      bg: 'Съединени щати',
      de: 'Vereinigte Staaten',
      fr: 'États-Unis',
      nl: 'Verenigde Staten',
      it: 'stati Uniti',
      cn: '美国',
      zh: '美國',
      et: 'Ühendriigid',
      ja: 'アメリカ',
      he: 'ארצות הברית',
      el: 'Ηνωμένες Πολιτείες Αμερικής',
      kk: 'АҚШ',
      ka: 'აშშ',
      th: 'สหรัฐอเมริกา',
    },
    phoneLength: 10,
    dialCode: '+1',
    code: 'US',
    flag: '🇺🇸',
  },
  {
    name: {
      en: 'Uruguay',
      ru: 'Уругвай',
      pl: 'Urugwaj',
      uk: 'Уругвай',
      cs: 'Uruguay',
      be: 'Уругвай',
      pt: 'Uruguai',
      es: 'Uruguay',
      ro: 'Uruguay',
      bg: 'Уругвай',
      de: 'Uruguay',
      fr: 'Uruguay',
      nl: 'Uruguay',
      it: 'Uruguay',
      cn: '乌拉圭',
      zh: '烏拉圭',
      et: 'Uruguay',
      ja: 'ウルグアイ',
      he: 'אורוגוואי',
      el: 'Ουρουγουάη',
      kk: 'Уругвай',
      ka: 'ურუგვაი',
      th: 'อุรุกวัย',
    },
    phoneLength: 8,
    dialCode: '+598',
    code: 'UY',
    flag: '🇺🇾',
  },
  {
    name: {
      en: 'Uzbekistan',
      ru: 'Узбекистан',
      pl: 'Uzbekistan',
      uk: 'Узбекистан',
      cs: 'Uzbekistán',
      be: 'Узбекістан',
      pt: 'Usbequistão',
      es: 'Uzbekistán',
      ro: 'Uzbekistan',
      bg: 'Узбекистан',
      de: 'Usbekistan',
      fr: 'Ouzbékistan',
      nl: 'Oezbekistan',
      it: 'Uzbekistan',
      cn: '乌兹别克斯坦',
      zh: '烏茲別克斯坦',
      et: 'Usbekistan',
      ja: 'ウズベキスタン',
      he: 'אוזבקיסטן',
      el: 'Ουζμπεκιστάν',
      kk: 'Ўзбекистон',
      ka: 'უზბეკეთი',
      th: 'อุซเบกิสถาน',
    },
    phoneLength: 9,
    dialCode: '+998',
    code: 'UZ',
    flag: '🇺🇿',
  },
  {
    name: {
      en: 'Vanuatu',
      ru: 'Вануату',
      pl: 'Vanuatu',
      uk: 'Вануату',
      cs: 'Vanuatu',
      be: 'Вануату',
      pt: 'Vanuatu',
      es: 'Vanuatu',
      ro: 'Vanuatu',
      bg: 'Вануату',
      de: 'Vanuatu',
      fr: 'Vanuatu',
      nl: 'Vanuatu',
      it: 'Vanuatu',
      cn: '瓦努阿图',
      zh: '瓦努阿圖',
      et: 'Vanuatu',
      ja: 'バヌアツ',
      he: 'ונואטו',
      el: 'Βανουάτου',
      kk: 'Вануату',
      ka: 'ვანუატუ',
      th: 'วานูอาตู',
    },
    phoneLength: 7,
    dialCode: '+678',
    code: 'VU',
    flag: '🇻🇺',
  },
  {
    name: {
      en: 'Venezuela',
      ru: 'Венесуэла',
      pl: 'Wenezuela',
      uk: 'Венесуела',
      cs: 'Venezuela',
      be: 'Венесуэла',
      pt: 'Venezuela',
      es: 'Venezuela',
      ro: 'Venezuela',
      bg: 'Венецуела',
      de: 'Venezuela',
      fr: 'Venezuela',
      nl: 'Venezuela',
      it: 'Venezuela',
      cn: '委内瑞拉',
      zh: '委內瑞拉',
      et: 'Venezuela',
      ja: 'ベネズエラ',
      he: 'ונצואלה',
      el: 'Βενεζουέλα',
      kk: 'Венесуэла',
      ka: 'ვენესუელა',
      th: 'เวเนซุเอลา',
    },
    phoneLength: 10,
    dialCode: '+58',
    code: 'VE',
    flag: '🇻🇪',
  },
  {
    name: {
      en: 'Vietnam',
      ru: 'Вьетнам',
      pl: 'Wietnam',
      uk: "В'єтнам",
      cs: 'Vietnam',
      be: "В'етнам",
      pt: 'Vietname',
      es: 'Vietnam',
      ro: 'Vietnam',
      bg: 'Виетнам',
      de: 'Vietnam',
      fr: 'Viêt Nam',
      nl: 'Vietnam',
      it: 'Vietnam',
      cn: '越南',
      zh: '越南',
      et: 'Vietnam',
      ja: 'ベトナム',
      he: 'וייטנאם',
      el: 'Βιετνάμ',
      kk: 'Вьетнам',
      ka: 'ვიეტნამი',
      th: 'เวียดนาม',
    },
    phoneLength: 10,
    dialCode: '+84',
    code: 'VN',
    flag: '🇻🇳',
  },
  {
    name: {
      en: 'Virgin Islands, British',
      ru: 'Виргинские острова, Британские',
      pl: 'Wyspy Dziewicze, Brytyjskie',
      uk: 'Віргінські острови, Британські',
      cs: 'Panenské ostrovy, Britové',
      be: 'Віргінскія астравы, Брытанія',
      pt: 'Ilhas Virgens Britânicas',
      es: 'Islas Vírgenes Británicas',
      ro: 'Insulele Virgine, britanice',
      bg: 'Вирджински острови, британски',
      de: 'Virgin Inseln, Britisch',
      fr: 'Îles Vierges britanniques',
      nl: 'Britse Maagdeneilanden',
      it: 'Isole Vergini britanniche',
      cn: '英属维尔京群岛',
      zh: '英屬維爾京群島',
      et: 'Neitsisaared, Suurbritannia',
      ja: '英領バージン諸島',
      he: 'איי הבתולה הבריטיים',
      el: 'Βρετανικές Παρθένοι Νήσοι',
      kk: 'Британ Виргин аралдары',
      ka: 'ბრიტანეთის ვირჯინის კუნძულები',
      th: 'หมู่เกาะเวอร์จินของสหราชอาณาจักร',
    },
    phoneLength: 7,
    dialCode: '+1284',
    code: 'VG',
    flag: '🇻🇬',
  },
  {
    name: {
      en: 'Virgin Islands, U.S.',
      ru: 'Американские Виргинские острова',
      pl: 'Wyspy Dziewicze Stanów Zjednoczonych',
      uk: 'Віргінські острови, США',
      cs: 'Panenské ostrovy, USA',
      be: 'Віргінскія астравы, ЗША',
      pt: 'Ilhas Virgens Americanas',
      es: 'Islas Vírgenes, EE.UU.',
      ro: 'Insulele Virgine, S.U.A.',
      bg: 'Вирджински острови, САЩ',
      de: 'Jungferninseln, USA',
      fr: 'Îles Vierges américaines, États-Unis',
      nl: 'Maagdeneilanden, U.s.',
      it: 'Isole Vergini, Stati Uniti',
      cn: '美国维尔京群岛',
      zh: '美國維爾京群島',
      et: 'Neitsisaared, USA',
      ja: 'アメリカ領バージン諸島',
      he: 'איי הבתולה של ארצות הברית',
      el: 'Αμερικανικές Παρθένοι Νήσοι',
      kk: 'АҚШ Виргин аралдары',
      ka: 'აშშ-ის ვირჯინის კუნძულები',
      th: 'หมู่เกาะเวอร์จินของสหรัฐอเมริกา',
    },
    phoneLength: 7,
    dialCode: '+1340',
    code: 'VI',
    flag: '🇻🇮',
  },
  {
    name: {
      en: 'Wallis and Futuna',
      ru: 'Уоллис и Футуна',
      pl: 'Wallis i Futuna',
      uk: 'Уолліс і Футуна',
      cs: 'Wallis a Futuna',
      be: 'Уоліс і Футуна',
      pt: 'Wallis e Futuna',
      es: 'Wallis y Futuna',
      ro: 'Wallis și Futuna',
      bg: 'Уолис и Футуна',
      de: 'Wallis und Futuna',
      fr: 'Wallis et Futuna',
      nl: 'Wallis en Futuna',
      it: 'Wallis e Futuna',
      cn: '瓦利斯和富图纳群岛',
      zh: '瓦利斯和富圖納群島',
      et: 'Wallis ja Futuna',
      ja: 'ウォリス・フツナ',
      he: 'וואליס ופוטונה',
      el: 'Ουώλλις και Φουτούνα',
      kk: 'Уоллис және Футуна',
      ka: 'უოლისი და ფუტუნა',
      th: 'วาลลิสและฟุตูนา',
    },
    phoneLength: 8,
    dialCode: '+681',
    code: 'WF',
    flag: '🇼🇫',
  },
  {
    name: {
      en: 'Yemen',
      ru: 'Йемен',
      pl: 'Jemen',
      uk: 'Ємен',
      cs: 'Jemen',
      be: 'Емен',
      pt: 'Iémen',
      es: 'Yemen',
      ro: 'Yemen',
      bg: 'Йемен',
      de: 'Jemen',
      fr: 'Yémen',
      nl: 'Jemen',
      it: 'Yemen',
      cn: '也门',
      zh: '也門',
      et: 'Jeemen',
      ja: 'イエメン',
      he: 'תימן',
      el: 'Υεμένη',
      kk: 'Йемен',
      ka: 'იემენი',
      th: 'เยเมน',
    },
    phoneLength: 9,
    dialCode: '+967',
    code: 'YE',
    flag: '🇾🇪',
  },
  {
    name: {
      en: 'Zambia',
      ru: 'Замбия',
      pl: 'Zambia',
      uk: 'Замбія',
      cs: 'Zambie',
      be: 'Замбія',
      pt: 'Zâmbia',
      es: 'Zambia',
      ro: 'Zambia',
      bg: 'Замбия',
      de: 'Sambia',
      fr: 'Zambie',
      nl: 'Zambia',
      it: 'Zambia',
      cn: '赞比亚',
      zh: '讚比亞',
      et: 'Sambia',
      ja: 'ザンビア',
      he: 'זמביה',
      el: 'Ζάμπια',
      kk: 'Замбия',
      ka: 'ზამბია',
      th: 'แซมเบีย',
    },
    phoneLength: 9,
    dialCode: '+260',
    code: 'ZM',
    flag: '🇿🇲',
  },
  {
    name: {
      en: 'Zimbabwe',
      ru: 'Зимбабве',
      pl: 'Zimbabwe',
      uk: 'Зімбабве',
      cs: 'Zimbabwe',
      be: 'Зімбабвэ',
      pt: 'Zimbabué',
      es: 'Zimbabue',
      ro: 'Zimbabwe',
      bg: 'Зимбабве',
      de: 'Zimbabwe',
      fr: 'Zimbabwe',
      nl: 'Zimbabwe',
      it: 'Zimbabwe',
      cn: '津巴布韦',
      zh: '津巴布韋',
      et: 'Zimbabwe',
      ja: 'ジンバブエ',
      he: 'זימבבואה',
      el: 'Ζιμπάμπουε',
      kk: 'Зимбабве',
      ka: 'ზიმბაბვე',
      th: 'ซิมบับเว',
    },
    phoneLength: 9,
    dialCode: '+263',
    code: 'ZW',
    flag: '🇿🇼',
  },
  {
    name: {
      en: 'Åland Islands',
      ru: 'Аландские острова',
      pl: 'Wyspy Alandzkie',
      uk: 'Аландські острови',
      cs: 'Alandy',
      be: 'Аландскія астравы',
      pt: 'Ilhas Aland',
      es: 'Islas Åland',
      ro: 'Insulele Aland',
      bg: 'Аландски острови',
      de: 'Aland Islands',
      fr: 'Iles Aland',
      nl: 'Aland-eilanden',
      it: 'Isole Aland',
      cn: '奥兰群岛',
      zh: '奧蘭群島',
      et: 'Alandi saared',
      ja: 'オーランド諸島',
      he: 'איי אלנד',
      el: 'Νήσοι Άλαντ',
      kk: 'Аланд аралдары',
      ka: 'ალანდის კუნძულები',
      th: 'หมู่เกาะโอลันด์',
    },
    phoneLength: 8,
    dialCode: '+358',
    code: 'AX',
    flag: '🇦🇽',
  },
];
